const AboutUsBanner = () => {
  return (
    <svg
      width="287"
      height="83"
      viewBox="0 0 287 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.11125 55L16.0513 11.2H29.9713L45.3313 55H36.5713L23.5513 17.02L26.6113 18.34H19.1113L22.2313 17.02L9.63125 55H1.11125ZM11.5513 43.36L14.2513 36.16H32.0113L34.6513 43.36H11.5513ZM70.3175 56.08C67.6375 56.08 65.2775 55.52 63.2375 54.4C61.1975 53.24 59.5975 51.56 58.4375 49.36C57.2775 47.16 56.6375 44.5 56.5175 41.38H57.7775V55H51.1775V11.2H59.5175V33.1L57.2975 36.52C57.4575 33.16 58.1175 30.36 59.2775 28.12C60.4775 25.88 62.0775 24.2 64.0775 23.08C66.0775 21.96 68.3375 21.4 70.8575 21.4C73.0975 21.4 75.1375 21.82 76.9775 22.66C78.8175 23.5 80.3975 24.68 81.7175 26.2C83.0375 27.68 84.0375 29.42 84.7175 31.42C85.4375 33.42 85.7975 35.6 85.7975 37.96V39.22C85.7975 41.58 85.4375 43.78 84.7175 45.82C83.9975 47.86 82.9575 49.66 81.5975 51.22C80.2375 52.74 78.5975 53.94 76.6775 54.82C74.7975 55.66 72.6775 56.08 70.3175 56.08ZM68.4575 49.06C70.2575 49.06 71.8175 48.62 73.1375 47.74C74.4975 46.82 75.5575 45.58 76.3175 44.02C77.0775 42.46 77.4575 40.66 77.4575 38.62C77.4575 36.54 77.0775 34.74 76.3175 33.22C75.5575 31.7 74.4975 30.52 73.1375 29.68C71.8175 28.84 70.2575 28.42 68.4575 28.42C66.8175 28.42 65.2975 28.78 63.8975 29.5C62.5375 30.22 61.4175 31.28 60.5375 32.68C59.6975 34.08 59.2775 35.76 59.2775 37.72V40.12C59.2775 42 59.7175 43.6 60.5975 44.92C61.4775 46.24 62.6175 47.26 64.0175 47.98C65.4175 48.7 66.8975 49.06 68.4575 49.06ZM108.791 56.14C105.911 56.14 103.371 55.68 101.171 54.76C98.9706 53.84 97.1106 52.6 95.5906 51.04C94.0706 49.44 92.9106 47.64 92.1106 45.64C91.3506 43.64 90.9706 41.56 90.9706 39.4V38.14C90.9706 35.9 91.3706 33.78 92.1706 31.78C93.0106 29.74 94.1906 27.94 95.7106 26.38C97.2706 24.78 99.1506 23.54 101.351 22.66C103.551 21.74 106.031 21.28 108.791 21.28C111.551 21.28 114.031 21.74 116.231 22.66C118.431 23.54 120.291 24.78 121.811 26.38C123.371 27.94 124.551 29.74 125.351 31.78C126.151 33.78 126.551 35.9 126.551 38.14V39.4C126.551 41.56 126.151 43.64 125.351 45.64C124.591 47.64 123.451 49.44 121.931 51.04C120.411 52.6 118.551 53.84 116.351 54.76C114.151 55.68 111.631 56.14 108.791 56.14ZM108.791 49C110.831 49 112.551 48.56 113.951 47.68C115.351 46.76 116.411 45.54 117.131 44.02C117.851 42.46 118.211 40.7 118.211 38.74C118.211 36.74 117.831 34.98 117.071 33.46C116.351 31.9 115.271 30.68 113.831 29.8C112.431 28.88 110.751 28.42 108.791 28.42C106.831 28.42 105.131 28.88 103.691 29.8C102.291 30.68 101.211 31.9 100.451 33.46C99.6906 34.98 99.3106 36.74 99.3106 38.74C99.3106 40.7 99.6706 42.46 100.391 44.02C101.151 45.54 102.231 46.76 103.631 47.68C105.031 48.56 106.751 49 108.791 49ZM144.953 56.02C141.193 56.02 138.273 54.78 136.193 52.3C134.153 49.82 133.133 46.14 133.133 41.26V22.36H141.473V41.98C141.473 43.98 142.033 45.58 143.153 46.78C144.273 47.94 145.793 48.52 147.713 48.52C149.633 48.52 151.193 47.9 152.393 46.66C153.633 45.42 154.253 43.74 154.253 41.62V22.36H162.593V55H155.993V41.14H156.653C156.653 44.42 156.233 47.16 155.393 49.36C154.553 51.56 153.293 53.22 151.613 54.34C149.933 55.46 147.833 56.02 145.313 56.02H144.953ZM186.334 55.42C183.334 55.42 180.854 55.04 178.894 54.28C176.974 53.48 175.534 52.16 174.574 50.32C173.614 48.44 173.134 45.92 173.134 42.76L173.194 13.24H180.994L180.934 43.3C180.934 44.9 181.354 46.14 182.194 47.02C183.074 47.86 184.314 48.28 185.914 48.28H191.014V55.42H186.334ZM167.974 28.54V22.42H191.014V28.54H167.974ZM229.683 56.14C225.603 56.14 222.163 55.36 219.363 53.8C216.563 52.24 214.423 50.06 212.943 47.26C211.503 44.42 210.783 41.1 210.783 37.3V11.2H219.303V37.78C219.303 39.86 219.703 41.7 220.503 43.3C221.303 44.86 222.463 46.08 223.983 46.96C225.543 47.8 227.443 48.22 229.683 48.22C231.883 48.22 233.743 47.8 235.263 46.96C236.823 46.08 237.983 44.86 238.743 43.3C239.543 41.74 239.943 39.9 239.943 37.78V11.2H248.463V37.3C248.463 41.1 247.743 44.42 246.303 47.26C244.903 50.06 242.803 52.24 240.003 53.8C237.203 55.36 233.763 56.14 229.683 56.14ZM269.599 56.02C265.119 56.02 261.599 55.08 259.039 53.2C256.519 51.28 255.199 48.64 255.079 45.28H262.579C262.699 46.4 263.319 47.42 264.439 48.34C265.559 49.26 267.319 49.72 269.719 49.72C271.719 49.72 273.299 49.36 274.459 48.64C275.659 47.92 276.259 46.94 276.259 45.7C276.259 44.62 275.799 43.76 274.879 43.12C273.999 42.48 272.479 42.06 270.319 41.86L267.439 41.56C263.799 41.16 260.999 40.12 259.039 38.44C257.079 36.76 256.099 34.52 256.099 31.72C256.099 29.48 256.659 27.6 257.779 26.08C258.899 24.56 260.439 23.42 262.399 22.66C264.399 21.86 266.679 21.46 269.239 21.46C273.239 21.46 276.479 22.34 278.959 24.1C281.439 25.86 282.739 28.44 282.859 31.84H275.359C275.279 30.72 274.719 29.76 273.679 28.96C272.639 28.16 271.139 27.76 269.179 27.76C267.419 27.76 266.059 28.1 265.099 28.78C264.139 29.46 263.659 30.34 263.659 31.42C263.659 32.46 264.039 33.26 264.799 33.82C265.599 34.38 266.879 34.76 268.639 34.96L271.519 35.26C275.359 35.66 278.359 36.72 280.519 38.44C282.719 40.16 283.819 42.48 283.819 45.4C283.819 47.56 283.219 49.44 282.019 51.04C280.859 52.6 279.219 53.82 277.099 54.7C274.979 55.58 272.479 56.02 269.599 56.02Z"
        fill="white"
      />
      <path
        d="M211 80C233.826 77.8628 261.543 77.3305 286 78.9312"
        stroke="url(#paint0_angular_656_9823)"
        strokeWidth="6"
      />
      <defs>
        <radialGradient
          id="paint0_angular_656_9823"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(248.5 79) rotate(90) scale(1 37.5)"
        >
          <stop offset="0.046875" stopColor="#FFC876" />
          <stop offset="0.395833" stopColor="#79FFF7" />
          <stop offset="0.718753" stopColor="#0182FA" />
          <stop offset="1" stopColor="#FF98E2" />
        </radialGradient>
      </defs>
    </svg>
  );
};

const AboutUsBannerMobile = () => {
  return (
    <svg
      width="188"
      height="59"
      viewBox="0 0 188 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.7075 39L11.6675 9.8H20.9475L31.1875 39H25.3475L16.6675 13.68L18.7075 14.56H13.7075L15.7875 13.68L7.3875 39H1.7075ZM8.6675 31.24L10.4675 26.44H22.3075L24.0675 31.24H8.6675ZM47.045 39.72C45.2583 39.72 43.685 39.3467 42.325 38.6C40.965 37.8267 39.8983 36.7067 39.125 35.24C38.3517 33.7733 37.925 32 37.845 29.92H38.685V39H34.285V9.8H39.845V24.4L38.365 26.68C38.4717 24.44 38.9117 22.5733 39.685 21.08C40.485 19.5867 41.5517 18.4667 42.885 17.72C44.2183 16.9733 45.725 16.6 47.405 16.6C48.8983 16.6 50.2583 16.88 51.485 17.44C52.7117 18 53.765 18.7867 54.645 19.8C55.525 20.7867 56.1917 21.9467 56.645 23.28C57.125 24.6133 57.365 26.0667 57.365 27.64V28.48C57.365 30.0533 57.125 31.52 56.645 32.88C56.165 34.24 55.4717 35.44 54.565 36.48C53.6583 37.4933 52.565 38.2933 51.285 38.88C50.0317 39.44 48.6183 39.72 47.045 39.72ZM45.805 35.04C47.005 35.04 48.045 34.7467 48.925 34.16C49.8317 33.5467 50.5383 32.72 51.045 31.68C51.5517 30.64 51.805 29.44 51.805 28.08C51.805 26.6933 51.5517 25.4933 51.045 24.48C50.5383 23.4667 49.8317 22.68 48.925 22.12C48.045 21.56 47.005 21.28 45.805 21.28C44.7117 21.28 43.6983 21.52 42.765 22C41.8583 22.48 41.1117 23.1867 40.525 24.12C39.965 25.0533 39.685 26.1733 39.685 27.48V29.08C39.685 30.3333 39.9783 31.4 40.565 32.28C41.1517 33.16 41.9117 33.84 42.845 34.32C43.7783 34.8 44.765 35.04 45.805 35.04ZM71.8938 39.76C69.9738 39.76 68.2804 39.4533 66.8138 38.84C65.3471 38.2267 64.1071 37.4 63.0938 36.36C62.0804 35.2933 61.3071 34.0933 60.7738 32.76C60.2671 31.4267 60.0138 30.04 60.0138 28.6V27.76C60.0138 26.2667 60.2804 24.8533 60.8138 23.52C61.3738 22.16 62.1604 20.96 63.1738 19.92C64.2138 18.8533 65.4671 18.0267 66.9338 17.44C68.4004 16.8267 70.0538 16.52 71.8938 16.52C73.7338 16.52 75.3871 16.8267 76.8538 17.44C78.3204 18.0267 79.5604 18.8533 80.5738 19.92C81.6138 20.96 82.4004 22.16 82.9338 23.52C83.4671 24.8533 83.7338 26.2667 83.7338 27.76V28.6C83.7338 30.04 83.4671 31.4267 82.9338 32.76C82.4271 34.0933 81.6671 35.2933 80.6538 36.36C79.6404 37.4 78.4004 38.2267 76.9338 38.84C75.4671 39.4533 73.7871 39.76 71.8938 39.76ZM71.8938 35C73.2538 35 74.4004 34.7067 75.3338 34.12C76.2671 33.5067 76.9738 32.6933 77.4538 31.68C77.9338 30.64 78.1738 29.4667 78.1738 28.16C78.1738 26.8267 77.9204 25.6533 77.4138 24.64C76.9338 23.6 76.2138 22.7867 75.2538 22.2C74.3204 21.5867 73.2004 21.28 71.8938 21.28C70.5871 21.28 69.4538 21.5867 68.4938 22.2C67.5604 22.7867 66.8404 23.6 66.3338 24.64C65.8271 25.6533 65.5738 26.8267 65.5738 28.16C65.5738 29.4667 65.8138 30.64 66.2938 31.68C66.8004 32.6933 67.5204 33.5067 68.4538 34.12C69.3871 34.7067 70.5338 35 71.8938 35ZM95.2022 39.68C92.6955 39.68 90.7489 38.8533 89.3622 37.2C88.0022 35.5467 87.3222 33.0933 87.3222 29.84V17.24H92.8822V30.32C92.8822 31.6533 93.2555 32.72 94.0022 33.52C94.7489 34.2933 95.7622 34.68 97.0422 34.68C98.3222 34.68 99.3622 34.2667 100.162 33.44C100.989 32.6133 101.402 31.4933 101.402 30.08V17.24H106.962V39H102.562V29.76H103.002C103.002 31.9467 102.722 33.7733 102.162 35.24C101.602 36.7067 100.762 37.8133 99.6422 38.56C98.5222 39.3067 97.1222 39.68 95.4422 39.68H95.2022ZM121.989 39.28C119.989 39.28 118.336 39.0267 117.029 38.52C115.749 37.9867 114.789 37.1067 114.149 35.88C113.509 34.6267 113.189 32.9467 113.189 30.84L113.229 11.16H118.429L118.389 31.2C118.389 32.2667 118.669 33.0933 119.229 33.68C119.816 34.24 120.642 34.52 121.709 34.52H125.109V39.28H121.989ZM109.749 21.36V17.28H125.109V21.36H109.749ZM149.288 39.76C146.568 39.76 144.275 39.24 142.408 38.2C140.542 37.16 139.115 35.7067 138.128 33.84C137.168 31.9467 136.688 29.7333 136.688 27.2V9.8H142.368V27.52C142.368 28.9067 142.635 30.1333 143.168 31.2C143.702 32.24 144.475 33.0533 145.488 33.64C146.528 34.2 147.795 34.48 149.288 34.48C150.755 34.48 151.995 34.2 153.008 33.64C154.048 33.0533 154.822 32.24 155.328 31.2C155.862 30.16 156.128 28.9333 156.128 27.52V9.8H161.808V27.2C161.808 29.7333 161.328 31.9467 160.368 33.84C159.435 35.7067 158.035 37.16 156.168 38.2C154.302 39.24 152.008 39.76 149.288 39.76ZM175.099 39.68C172.113 39.68 169.766 39.0533 168.059 37.8C166.379 36.52 165.499 34.76 165.419 32.52H170.419C170.499 33.2667 170.913 33.9467 171.659 34.56C172.406 35.1733 173.579 35.48 175.179 35.48C176.513 35.48 177.566 35.24 178.339 34.76C179.139 34.28 179.539 33.6267 179.539 32.8C179.539 32.08 179.233 31.5067 178.619 31.08C178.033 30.6533 177.019 30.3733 175.579 30.24L173.659 30.04C171.233 29.7733 169.366 29.08 168.059 27.96C166.753 26.84 166.099 25.3467 166.099 23.48C166.099 21.9867 166.473 20.7333 167.219 19.72C167.966 18.7067 168.993 17.9467 170.299 17.44C171.633 16.9067 173.153 16.64 174.859 16.64C177.526 16.64 179.686 17.2267 181.339 18.4C182.993 19.5733 183.859 21.2933 183.939 23.56H178.939C178.886 22.8133 178.513 22.1733 177.819 21.64C177.126 21.1067 176.126 20.84 174.819 20.84C173.646 20.84 172.739 21.0667 172.099 21.52C171.459 21.9733 171.139 22.56 171.139 23.28C171.139 23.9733 171.393 24.5067 171.899 24.88C172.433 25.2533 173.286 25.5067 174.459 25.64L176.379 25.84C178.939 26.1067 180.939 26.8133 182.379 27.96C183.846 29.1067 184.579 30.6533 184.579 32.6C184.579 34.04 184.179 35.2933 183.379 36.36C182.606 37.4 181.513 38.2133 180.099 38.8C178.686 39.3867 177.019 39.68 175.099 39.68Z"
        fill="white"
      />
      <path
        d="M137.5 56C145.981 54.4908 167.654 52.3778 186.5 56"
        stroke="url(#paint0_angular_656_10214)"
        strokeWidth="6"
      />
      <defs>
        <radialGradient
          id="paint0_angular_656_10214"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(162 55) rotate(90) scale(1 24.5)"
        >
          <stop offset="0.0993526" stopColor="#FFC876" />
          <stop offset="0.526122" stopColor="#ACFF8E" />
          <stop offset="0.739587" stopColor="#9453FF" />
          <stop offset="0.913343" stopColor="#FF89C2" />
        </radialGradient>
      </defs>
    </svg>
  );
};

const CardBorderMobile = () => {
  return (
    <svg
      width="343"
      height="451"
      viewBox="0 0 343 451"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_656_10221)">
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H212.824C219.328 0 225.553 2.63964 230.075 7.3146L282 61L335.685 112.925C340.36 117.447 343 123.672 343 130.176V427C343 440.255 332.255 451 319 451H24C10.7452 451 0 440.255 0 427V24Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          d="M281.641 61.3476L281.646 61.3536L281.652 61.3594L335.338 113.285C339.915 117.712 342.5 123.808 342.5 130.176V427C342.5 439.979 331.979 450.5 319 450.5H24C11.0213 450.5 0.5 439.979 0.5 427V24C0.5 11.0213 11.0213 0.5 24 0.5H212.824C219.192 0.5 225.288 3.08465 229.715 7.66221L281.641 61.3476Z"
          stroke="white"
          strokeOpacity="0.15"
        />
        <path
          d="M281.641 61.3476L281.646 61.3536L281.652 61.3594L335.338 113.285C339.915 117.712 342.5 123.808 342.5 130.176V427C342.5 439.979 331.979 450.5 319 450.5H24C11.0213 450.5 0.5 439.979 0.5 427V24C0.5 11.0213 11.0213 0.5 24 0.5H212.824C219.192 0.5 225.288 3.08465 229.715 7.66221L281.641 61.3476Z"
          stroke="url(#paint0_linear_656_10221)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_656_10221"
          x="-64"
          y="-64"
          width="471"
          height="579"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_656_10221"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_656_10221"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_656_10221"
          x1="171.5"
          y1="0"
          x2="171.5"
          y2="451"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const CardBorder = () => {
  return (
    <svg
      width="580"
      height="439"
      viewBox="0 0 580 439"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_656_9830)">
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H412.766C418.103 0 423.287 1.77883 427.5 5.05528L500.5 61.831L570.619 115.684C576.533 120.226 580 127.26 580 134.718V415C580 428.255 569.255 439 556 439H24C10.7452 439 0 428.255 0 415V24Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          d="M500.193 62.2257L500.195 62.2275L570.314 116.081C576.105 120.528 579.5 127.416 579.5 134.718V415C579.5 427.979 568.979 438.5 556 438.5H24C11.0213 438.5 0.5 427.979 0.5 415V24C0.5 11.0213 11.0213 0.5 24 0.5H412.766C417.991 0.5 423.068 2.24177 427.193 5.44996L500.193 62.2257Z"
          stroke="white"
          strokeOpacity="0.15"
        />
        <path
          d="M500.193 62.2257L500.195 62.2275L570.314 116.081C576.105 120.528 579.5 127.416 579.5 134.718V415C579.5 427.979 568.979 438.5 556 438.5H24C11.0213 438.5 0.5 427.979 0.5 415V24C0.5 11.0213 11.0213 0.5 24 0.5H412.766C417.991 0.5 423.068 2.24177 427.193 5.44996L500.193 62.2257Z"
          stroke="url(#paint0_linear_656_9830)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_656_9830"
          x="-64"
          y="-64"
          width="708"
          height="567"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_656_9830"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_656_9830"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_656_9830"
          x1="290"
          y1="0"
          x2="290"
          y2="439"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const CardBorderHover = () => {
  return (
    <svg
      width="580"
      height="568"
      viewBox="0 0 580 568"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2746_17061)">
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H411.015C417.406 0 423.533 2.54926 428.038 7.08272L500.5 80L572.917 151.961C577.451 156.467 580 162.594 580 168.986V544C580 557.255 569.255 568 556 568H24C10.7452 568 0 557.255 0 544V24Z"
          fill="#0E0C15"
        />
        <path
          d="M500.145 80.3524L500.148 80.3547L572.565 152.316C577.004 156.727 579.5 162.727 579.5 168.986V544C579.5 556.979 568.979 567.5 556 567.5H24C11.0213 567.5 0.5 556.979 0.5 544V24C0.5 11.0213 11.0213 0.5 24 0.5H411.015C417.273 0.5 423.273 2.99616 427.684 7.43516L500.145 80.3524Z"
          stroke="white"
          strokeOpacity="0.15"
        />
        <path
          d="M500.145 80.3524L500.148 80.3547L572.565 152.316C577.004 156.727 579.5 162.727 579.5 168.986V544C579.5 556.979 568.979 567.5 556 567.5H24C11.0213 567.5 0.5 556.979 0.5 544V24C0.5 11.0213 11.0213 0.5 24 0.5H411.015C417.273 0.5 423.273 2.99616 427.684 7.43516L500.145 80.3524Z"
          stroke="url(#paint0_linear_2746_17061)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2746_17061"
          x="-64"
          y="-64"
          width="708"
          height="696"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2746_17061"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2746_17061"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2746_17061"
          x1="290"
          y1="0"
          x2="290"
          y2="568"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const OurVisionIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 0C22.4621 0 17.0486 1.64217 12.444 4.71885C7.83947 7.79553 4.25064 12.1685 2.13139 17.2849C0.012132 22.4012 -0.542361 28.0311 0.538025 33.4625C1.61841 38.894 4.28515 43.8831 8.20102 47.799C12.1169 51.7149 17.106 54.3816 22.5375 55.462C27.969 56.5424 33.5988 55.9879 38.7152 53.8686C43.8315 51.7494 48.2045 48.1605 51.2812 43.556C54.3578 38.9514 56 33.5379 56 28C56 20.5739 53.05 13.452 47.799 8.20101C42.548 2.94999 35.4261 0 28 0ZM28 39.6667C15.68 39.6667 8.91335 29.0733 8.63335 28.6067C8.5195 28.4248 8.45912 28.2146 8.45912 28C8.45912 27.7854 8.5195 27.5752 8.63335 27.3933C8.91335 26.9267 15.68 16.3333 28 16.3333C40.32 16.3333 47.0867 26.9267 47.3667 27.3933C47.4805 27.5752 47.5409 27.7854 47.5409 28C47.5409 28.2146 47.4805 28.4248 47.3667 28.6067C47.0867 29.0733 40.32 39.6667 28 39.6667Z"
        fill="url(#paint0_angular_656_10227)"
      />
      <path
        d="M37.3327 28.0001C37.3327 26.1541 36.7853 24.3496 35.7597 22.8148C34.7342 21.2799 33.2765 20.0836 31.5711 19.3772C29.8656 18.6708 27.989 18.486 26.1785 18.8461C24.368 19.2062 22.705 20.0951 21.3997 21.4004C20.0944 22.7057 19.2055 24.3688 18.8454 26.1792C18.4852 27.9897 18.6701 29.8664 19.3765 31.5718C20.0829 33.2772 21.2792 34.7349 22.814 35.7605C24.3489 36.786 26.1534 37.3334 27.9994 37.3334C30.4747 37.3334 32.8487 36.3501 34.599 34.5998C36.3494 32.8494 37.3327 30.4754 37.3327 28.0001ZM27.9994 31.5001C27.3071 31.5001 26.6304 31.2948 26.0549 30.9102C25.4793 30.5256 25.0307 29.979 24.7658 29.3395C24.5009 28.6999 24.4316 27.9962 24.5666 27.3173C24.7017 26.6383 25.035 26.0147 25.5245 25.5252C26.014 25.0357 26.6376 24.7024 27.3165 24.5673C27.9955 24.4323 28.6992 24.5016 29.3387 24.7665C29.9783 25.0314 30.5249 25.48 30.9095 26.0556C31.2941 26.6312 31.4994 27.3079 31.4994 28.0001C31.4994 28.9283 31.1306 29.8186 30.4742 30.475C29.8179 31.1313 28.9276 31.5001 27.9994 31.5001Z"
        fill="url(#paint1_angular_656_10227)"
      />
      <defs>
        <radialGradient
          id="paint0_angular_656_10227"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28 28) rotate(90) scale(28)"
        >
          <stop offset="0.046875" stopColor="#FFC876" />
          <stop offset="0.395833" stopColor="#79FFF7" />
          <stop offset="0.718753" stopColor="#0182FA" />
          <stop offset="1" stopColor="#FF98E2" />
        </radialGradient>
        <radialGradient
          id="paint1_angular_656_10227"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.9994 28.0001) rotate(90) scale(9.33333)"
        >
          <stop offset="0.046875" stopColor="#FFC876" />
          <stop offset="0.395833" stopColor="#79FFF7" />
          <stop offset="0.718753" stopColor="#0182FA" />
          <stop offset="1" stopColor="#FF98E2" />
        </radialGradient>
      </defs>
    </svg>
  );
};

const OurMissionIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_656_10237)">
        <path
          d="M24.0108 29.6567C24.2277 29.8754 24.4858 30.049 24.7701 30.1674C25.0544 30.2859 25.3594 30.3469 25.6674 30.3469C25.9755 30.3469 26.2804 30.2859 26.5648 30.1674C26.8491 30.049 27.1072 29.8754 27.3241 29.6567L38.9908 17.99L39.1541 17.78C39.201 17.6867 39.2753 17.6098 39.367 17.5598C39.4587 17.5098 39.5635 17.4889 39.6674 17.5H43.5874C44.3542 17.5027 45.1139 17.3535 45.8227 17.0612C46.5315 16.7688 47.1755 16.3391 47.7174 15.7967L53.3408 10.15C53.5226 10.0024 53.6525 9.80047 53.7113 9.57373C53.77 9.347 53.7547 9.1074 53.6674 8.89003C53.5826 8.67513 53.4346 8.49098 53.243 8.36186C53.0514 8.23273 52.8251 8.16469 52.5941 8.16669H46.0841C45.9294 8.16669 45.781 8.10524 45.6716 7.99584C45.5622 7.88644 45.5008 7.73807 45.5008 7.58336V1.16669C45.519 0.920738 45.4588 0.675332 45.3288 0.46572C45.1989 0.256108 45.0058 0.0930727 44.7774 2.73213e-05C44.5665 -0.0917836 44.3324 -0.116401 44.1069 -0.0704787C43.8815 -0.0245561 43.6757 0.0896785 43.5174 0.256694L37.8708 5.97336C37.478 6.3727 37.1476 6.82893 36.8908 7.32669C33.3131 5.43308 29.3077 4.49386 25.2612 4.59974C21.2147 4.70563 17.2639 5.85302 13.7902 7.93115C10.3165 10.0093 7.43726 12.9479 5.43052 16.4634C3.42378 19.9788 2.35732 23.9522 2.33411 28C2.32253 34.1015 4.70133 39.9647 8.96077 44.3334C9.05429 44.4398 9.10587 44.5767 9.10587 44.7184C9.10587 44.8601 9.05429 44.9969 8.96077 45.1034L2.89411 52.15C2.49186 52.6203 2.29292 53.2312 2.34106 53.8482C2.38919 54.4652 2.68046 55.0378 3.15077 55.44C3.62109 55.8423 4.23194 56.0412 4.84893 55.9931C5.46592 55.9449 6.03853 55.6537 6.44077 55.1834L12.6474 47.95C12.7349 47.8409 12.86 47.7683 12.9981 47.7468C13.1363 47.7252 13.2776 47.7561 13.3941 47.8334C17.0816 50.114 21.3317 51.3221 25.6674 51.3221C30.0032 51.3221 34.2533 50.114 37.9408 47.8334C38.0573 47.7561 38.1986 47.7252 38.3368 47.7468C38.4749 47.7683 38.6 47.8409 38.6874 47.95L44.8941 55.1834C45.2963 55.6537 45.8689 55.9449 46.4859 55.9931C47.1029 56.0412 47.7138 55.8423 48.1841 55.44C48.6544 55.0378 48.9457 54.4652 48.9938 53.8482C49.042 53.2312 48.843 52.6203 48.4408 52.15L42.3508 45.0334C42.2572 44.9269 42.2057 44.7901 42.2057 44.6484C42.2057 44.5067 42.2572 44.3698 42.3508 44.2634C46.6145 39.9242 49.0028 34.0835 49.0008 28C49.0008 27.3812 48.7549 26.7877 48.3174 26.3501C47.8798 25.9125 47.2863 25.6667 46.6674 25.6667C46.0486 25.6667 45.4551 25.9125 45.0175 26.3501C44.5799 26.7877 44.3341 27.3812 44.3341 28C44.3341 32.9507 42.3674 37.6987 38.8668 41.1994C35.3661 44.7 30.6181 46.6667 25.6674 46.6667C20.7167 46.6667 15.9688 44.7 12.4681 41.1994C8.96743 37.6987 7.00077 32.9507 7.00077 28C7.00077 14.3267 21.7474 4.10669 36.1674 12.2967V14C36.1737 14.1001 36.1506 14.1999 36.1008 14.287C36.0511 14.374 35.9769 14.4446 35.8874 14.49L35.6774 14.6534L33.9274 16.4267C22.9841 9.91669 11.6674 17.64 11.6674 28C11.6674 31.7131 13.1424 35.274 15.7679 37.8995C18.3935 40.525 21.9544 42 25.6674 42C29.3805 42 32.9414 40.525 35.5669 37.8995C38.1924 35.274 39.6674 31.7131 39.6674 28C39.6674 27.3812 39.4216 26.7877 38.984 26.3501C38.5464 25.9125 37.9529 25.6667 37.3341 25.6667C36.7153 25.6667 36.1218 25.9125 35.6842 26.3501C35.2466 26.7877 35.0008 27.3812 35.0008 28C34.9796 30.0573 34.2793 32.05 33.0087 33.6682C31.7381 35.2863 29.9684 36.4393 27.9748 36.9478C25.9812 37.4564 23.8755 37.2919 21.985 36.4801C20.0946 35.6682 18.5253 34.2545 17.5213 32.4587C16.5173 30.6629 16.1349 28.5856 16.4333 26.55C16.7318 24.5144 17.6946 22.6344 19.1719 21.2024C20.6492 19.7704 22.5582 18.8667 24.6022 18.6318C26.6461 18.3969 28.7104 18.8439 30.4741 19.9034L24.0108 26.3434C23.7921 26.5603 23.6185 26.8183 23.5 27.1027C23.3816 27.387 23.3206 27.692 23.3206 28C23.3206 28.3081 23.3816 28.613 23.5 28.8974C23.6185 29.1817 23.7921 29.4398 24.0108 29.6567Z"
          fill="url(#paint0_angular_656_10237)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_angular_656_10237"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.0402 27.9536) rotate(90) scale(28.0466 25.7062)"
        >
          <stop offset="0.046875" stopColor="#FFC876" />
          <stop offset="0.395833" stopColor="#79FFF7" />
          <stop offset="0.718753" stopColor="#0182FA" />
          <stop offset="1" stopColor="#FF98E2" />
        </radialGradient>
        <clipPath id="clip0_656_10237">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const DiscoverBannerMobile = () => {
  return (
    <svg
      width="296"
      height="247"
      viewBox="0 0 296 247"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <path
          d="M203.226 102.442C204.745 101.563 205.944 102.283 205.944 104.041C205.944 105.8 204.745 107.878 203.226 108.758C201.707 109.637 200.508 108.918 200.508 107.159C200.508 105.4 201.707 103.322 203.226 102.442Z"
          fill="url(#paint0_linear_656_10249)"
        />
        <path
          d="M203.386 102.523C201.867 103.403 200.668 105.481 200.668 107.24C200.668 108.039 200.908 108.679 201.387 108.919C200.828 108.679 200.508 108.039 200.508 107.08C200.508 105.321 201.707 103.243 203.226 102.363C204.025 101.884 204.745 101.884 205.224 102.204C204.745 102.044 204.105 102.124 203.386 102.523Z"
          fill="white"
        />
        <path
          d="M196.749 98.6855C198.268 97.8061 199.467 98.5256 199.467 100.284C199.467 102.043 198.268 104.121 196.749 105.001C195.23 105.88 194.031 105.161 194.031 103.402C194.031 101.643 195.23 99.5648 196.749 98.6855Z"
          fill="url(#paint1_linear_656_10249)"
        />
        <path
          d="M190.116 94.8478C191.635 93.9685 192.834 94.688 192.834 96.4467C192.834 98.2054 191.635 100.284 190.116 101.163C188.598 102.043 187.398 101.323 187.398 99.5644C187.398 97.8856 188.598 95.7272 190.116 94.8478Z"
          fill="url(#paint2_linear_656_10249)"
        />
        <path
          d="M201.307 108.918L204.664 110.837C204.185 110.517 203.865 109.957 203.865 109.078C203.865 107.319 205.064 105.241 206.583 104.361C207.302 103.962 207.942 103.882 208.501 104.122L222.811 112.355L218.974 119.071L176.765 94.8484C174.926 93.8092 174.287 91.411 175.326 89.5723C176.365 87.7337 178.763 87.0941 180.602 88.1334L192.034 94.6885C191.554 94.3688 190.834 94.3688 190.035 94.8484C188.516 95.7278 187.317 97.8062 187.317 99.5649C187.317 100.444 187.637 101.084 188.116 101.324L191.474 103.242C190.994 102.922 190.675 102.363 190.675 101.484C190.675 99.7248 191.874 97.6464 193.393 96.767C194.112 96.3673 194.752 96.2874 195.311 96.5272L198.669 98.4458C198.189 98.126 197.47 98.126 196.67 98.6056C195.151 99.485 193.952 101.563 193.952 103.322C193.952 104.202 194.272 104.841 194.752 105.081L198.109 106.999C197.629 106.68 197.31 106.12 197.31 105.241C197.31 103.482 198.509 101.404 200.028 100.524C200.747 100.125 201.387 100.045 201.946 100.284L205.144 102.123C204.664 101.803 203.945 101.803 203.145 102.283C201.626 103.162 200.427 105.241 200.427 106.999C200.507 108.039 200.827 108.598 201.307 108.918Z"
          fill="#BCBEFF"
        />
        <path
          d="M196.909 98.7664C195.39 99.6457 194.191 101.724 194.191 103.483C194.191 104.282 194.431 104.922 194.911 105.162C194.351 104.922 194.031 104.282 194.031 103.323C194.031 101.564 195.23 99.4858 196.749 98.6065C197.549 98.1268 198.268 98.1268 198.748 98.4466C198.268 98.2867 197.629 98.3667 196.909 98.7664Z"
          fill="white"
        />
        <path
          d="M190.276 94.9279C188.757 95.8072 187.558 97.8857 187.558 99.6444C187.558 100.444 187.798 101.083 188.278 101.323C187.718 101.083 187.398 100.444 187.398 99.4845C187.398 97.7258 188.598 95.6473 190.116 94.768C190.916 94.2884 191.635 94.2883 192.115 94.6081C191.635 94.5282 190.996 94.5282 190.276 94.9279Z"
          fill="white"
        />
        <path
          opacity="0.48"
          d="M206.583 104.362C205.064 105.241 203.865 107.32 203.865 109.079C203.865 109.958 204.185 110.597 204.665 110.837L201.307 108.919C200.828 108.599 200.508 108.039 200.508 107.16C200.508 105.401 201.707 103.323 203.226 102.443C204.025 101.964 204.665 101.964 205.224 102.284L208.502 104.202C208.022 103.882 207.383 103.962 206.583 104.362Z"
          fill="url(#paint3_linear_656_10249)"
        />
        <path
          opacity="0.48"
          d="M200.107 100.604C198.588 101.484 197.389 103.562 197.389 105.321C197.389 106.2 197.709 106.84 198.188 107.079L194.831 105.161C194.351 104.841 194.031 104.281 194.031 103.402C194.031 101.643 195.23 99.5649 196.749 98.6856C197.549 98.2059 198.188 98.2059 198.748 98.5257L202.025 100.444C201.466 100.125 200.826 100.204 200.107 100.604Z"
          fill="url(#paint4_linear_656_10249)"
        />
        <path
          opacity="0.48"
          d="M193.474 96.8456C191.955 97.725 190.756 99.8034 190.756 101.562C190.756 102.442 191.076 103.081 191.555 103.321L188.198 101.402C187.718 101.082 187.398 100.523 187.398 99.6436C187.398 97.8849 188.598 95.8064 190.116 94.927C190.916 94.4474 191.555 94.4474 192.115 94.7672L195.393 96.6857C194.913 96.366 194.193 96.366 193.474 96.8456Z"
          fill="url(#paint5_linear_656_10249)"
        />
        <path
          d="M219.135 130.82C219.135 131.06 219.135 131.22 219.135 131.46L227.449 138.414L240.959 143.451L250.472 141.292L259.586 138.654L268.859 131.54L269.099 131.38C269.099 130.82 269.099 130.26 269.019 129.701C270.617 127.543 272.296 125.384 273.895 123.146C274.614 124.105 275.254 125.064 275.734 126.024L276.853 125.144V130.74C276.853 130.82 276.853 130.9 276.853 130.9V131.14C276.693 135.856 273.575 140.573 267.34 144.17C254.549 151.605 233.924 151.605 221.134 144.25C214.819 140.573 211.621 135.856 211.541 131.06C211.541 130.98 211.541 130.98 211.541 130.9V124.984L212.74 125.944C212.98 125.384 213.38 124.825 213.699 124.185C215.058 126.743 216.497 129.781 219.135 130.82Z"
          fill="url(#paint6_linear_656_10249)"
        />
        <path
          d="M266.7 117.23C266.86 117.31 267.02 117.39 267.26 117.55C270.138 119.229 272.376 121.147 273.975 123.146C272.376 125.304 270.697 127.463 269.098 129.701C268.619 126.424 266.22 123.226 261.904 120.748C252.151 115.152 236.323 115.152 226.57 120.828C221.773 123.626 219.375 127.223 219.295 130.9C216.657 129.861 215.218 126.823 213.699 124.345C214.898 122.586 216.577 120.828 218.735 119.309L217.616 119.549C217.616 119.549 225.291 112.914 225.61 112.834C225.93 112.754 241.279 108.677 241.279 108.677L258.626 110.196L266.7 117.23Z"
          fill="url(#paint7_linear_656_10249)"
        />
        <path
          opacity="0.5"
          d="M261.344 116.829C271.097 122.425 271.097 131.538 261.344 137.214C251.591 142.89 235.763 142.89 226.01 137.294C216.257 131.698 216.257 122.585 226.01 116.909C235.763 111.233 251.511 111.153 261.344 116.829Z"
          fill="url(#paint8_linear_656_10249)"
        />
        <path
          opacity="0.48"
          d="M261.264 118.588C271.017 124.184 271.017 133.297 261.264 138.973C251.511 144.649 235.683 144.649 225.93 139.053C216.177 133.457 216.177 124.344 225.93 118.668C235.683 112.992 251.511 112.912 261.264 118.588Z"
          fill="url(#paint9_linear_656_10249)"
        />
        <path
          d="M267.181 111.714C254.39 104.359 233.686 104.439 220.975 111.794C208.184 119.228 208.264 131.14 221.055 138.494C233.845 145.849 254.55 145.769 267.261 138.414C280.051 130.98 279.971 118.989 267.181 111.714ZM261.745 114.832C271.498 120.427 271.498 129.541 261.745 135.217C251.992 140.892 236.164 140.892 226.411 135.296C216.658 129.701 216.658 120.587 226.411 114.912C236.164 109.236 251.992 109.236 261.745 114.832Z"
          fill="#BCBEFF"
        />
        <path
          d="M267.181 111.714C254.39 104.359 233.686 104.439 220.975 111.794C208.184 119.228 208.264 131.14 221.055 138.494C233.845 145.849 254.55 145.769 267.261 138.414C280.051 130.98 279.971 118.989 267.181 111.714ZM261.745 114.832C271.498 120.427 271.498 129.541 261.745 135.217C251.992 140.892 236.164 140.892 226.411 135.296C216.658 129.701 216.658 120.587 226.411 114.912C236.164 109.236 251.992 109.236 261.745 114.832Z"
          fill="#BCBEFF"
        />
        <path
          d="M220.893 137.936C233.683 145.291 254.388 145.211 267.099 137.856C274.933 133.299 277.971 127.064 276.132 121.148C278.29 127.144 275.333 133.699 267.259 138.336C254.468 145.77 233.843 145.77 221.053 138.416C216.176 135.618 213.139 132.1 211.939 128.423C213.219 131.94 216.176 135.298 220.893 137.936Z"
          fill="white"
        />
        <path
          d="M226.249 114.432C236.002 108.757 251.83 108.757 261.583 114.352C265.34 116.511 267.658 119.229 268.538 122.027C267.578 119.389 265.34 116.911 261.743 114.832C251.99 109.236 236.162 109.236 226.409 114.912C220.413 118.35 218.175 123.146 219.454 127.623C217.855 122.986 220.094 118.03 226.249 114.432Z"
          fill="white"
        />
      </g>
      <path
        d="M162.616 225.152C161.897 225.152 161.098 224.992 160.458 224.593L61.8109 167.595C61.1713 167.275 60.8516 166.715 60.8516 166.236C60.8516 165.836 61.0914 165.436 61.571 165.196L120.488 131.222C121.447 130.662 123.206 130.742 124.325 131.381L222.892 188.379C223.531 188.699 223.851 189.259 223.851 189.738C223.851 190.138 223.611 190.538 223.132 190.778L164.215 224.752C163.895 225.072 163.256 225.152 162.616 225.152ZM61.9707 167.355L160.618 224.353C161.657 224.912 163.176 224.992 164.135 224.513L223.052 190.538C223.372 190.298 223.611 190.058 223.611 189.738C223.611 189.339 223.292 189.019 222.812 188.699L124.165 131.701C123.126 131.142 121.607 131.062 120.647 131.541L61.7309 165.516C61.4111 165.756 61.1713 165.996 61.1713 166.316C61.1713 166.715 61.4911 167.115 61.9707 167.355Z"
        fill="#42E8E0"
      />
      <g opacity="0.1">
        <path
          d="M99.5394 135.617C106.174 139.535 111.531 148.888 111.451 156.562C111.451 160.639 109.852 163.437 107.374 164.556L86.1893 176.707L69.002 147.209L90.9058 134.818C90.9857 134.738 91.0657 134.738 91.1456 134.658L91.2255 134.578C93.4639 133.539 96.3418 133.779 99.5394 135.617Z"
          fill="url(#paint10_radial_656_10249)"
        />
        <path
          opacity="0.3"
          d="M99.5394 135.617C103.457 137.935 106.974 142.172 109.132 146.808C105.935 148.567 99.3795 152.085 87.0686 158.8C83.9509 160.478 81.153 162.077 78.5949 163.676L69.002 147.128L90.9058 134.737C90.9857 134.657 91.0657 134.657 91.1456 134.578L91.2255 134.498C93.4639 133.538 96.3418 133.778 99.5394 135.617Z"
          fill="#0F054C"
        />
        <path
          d="M77.3995 147.609C84.2744 151.686 89.8703 161.438 89.7904 169.432C89.7904 173.03 88.5912 175.668 86.6727 177.107H86.5927C86.5927 177.107 86.5927 177.107 86.5128 177.107C86.4328 177.187 86.3529 177.187 86.273 177.267C74.1219 185.341 68.3662 195.733 61.4113 208.604L59.4927 212.281L26.7969 154.164L30.7939 154.404C45.2632 155.203 55.4157 152.885 68.5261 146.729C70.7644 145.37 73.8821 145.61 77.3995 147.609Z"
          fill="url(#paint11_linear_656_10249)"
        />
        <path
          opacity="0.3"
          d="M30.7922 154.404C45.2616 155.203 55.4141 152.885 68.5244 146.729C70.8427 145.37 73.9604 145.61 77.4778 147.609C81.3949 149.927 84.9123 154.164 87.2306 158.8C87.2306 158.8 87.2306 158.8 87.1506 158.8C66.8456 169.832 58.9315 179.025 58.9315 179.025L40.9447 174.389L35.189 168.793L26.9551 154.164L30.7922 154.404Z"
          fill="#0F054C"
        />
        <path
          d="M40.0679 157.361C53.2582 165.115 63.9703 183.822 63.8104 199.17C63.7304 206.845 61.0124 212.201 56.6956 214.679L52.6986 216.917L53.6579 215.878C49.7408 216.837 44.9443 215.878 39.7481 212.84C26.5579 205.086 15.8458 186.38 16.0057 171.031C16.0856 165.035 17.7644 160.399 20.5623 157.521L19.4431 157.601L23.1204 155.522C23.1204 155.522 23.1204 155.522 23.2004 155.522L23.3602 155.442C27.5971 153.124 33.5127 153.524 40.0679 157.361Z"
          fill="url(#paint12_linear_656_10249)"
        />
        <path
          d="M37.1879 158.96C50.3782 166.714 61.0903 185.42 60.9304 200.769C60.8504 208.283 58.2124 213.639 53.9755 216.197L53.336 216.517C53.0962 216.597 52.9363 216.757 52.6965 216.837L53.5758 215.878C49.6587 216.837 44.8623 215.878 39.6661 212.84C26.4758 205.086 15.7638 186.38 15.9236 171.031C16.0036 165.035 17.6823 160.399 20.4803 157.521L19.441 157.601C23.8378 154.643 30.1531 154.883 37.1879 158.96Z"
          fill="white"
        />
        <path
          d="M36.3887 159.439C23.1985 151.685 12.3265 157.84 12.2465 173.189C12.1666 188.538 22.7987 207.244 35.989 214.998C49.1793 222.752 60.0512 216.597 60.1312 201.248C60.2911 185.9 49.579 167.193 36.3887 159.439Z"
          fill="url(#paint13_linear_656_10249)"
        />
        <path
          d="M36.386 162.877C24.7946 156.082 15.2816 161.438 15.2017 174.948C15.1217 188.378 24.4748 204.846 36.0663 211.641C47.6577 218.436 57.1707 213.08 57.2506 199.57C57.3306 186.06 47.9775 169.672 36.386 162.877Z"
          fill="url(#paint14_radial_656_10249)"
        />
        <mask
          id="mask0_656_10249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="15"
          y="159"
          width="43"
          height="56"
        >
          <path
            d="M36.386 162.878C24.7946 156.083 15.2816 161.44 15.2017 174.95C15.1217 188.38 24.4748 204.847 36.0663 211.642C47.6577 218.437 57.1707 213.081 57.2506 199.571C57.3306 186.061 47.9775 169.673 36.386 162.878Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_656_10249)">
          <path
            d="M38.9467 192.456L74.8402 178.066L59.6515 159.2L32.9512 182.223L38.9467 192.456Z"
            fill="url(#paint15_linear_656_10249)"
          />
          <path
            d="M36.2271 182.304C33.9088 180.945 31.9902 181.985 31.9902 184.703C31.9902 187.421 33.8289 190.698 36.1472 192.057C38.4654 193.416 40.384 192.377 40.384 189.659C40.384 186.941 38.5454 183.663 36.2271 182.304Z"
            fill="url(#paint16_radial_656_10249)"
          />
          <g opacity="0.3">
            <path
              d="M48.4581 186.381C48.4581 182.864 46.0599 178.627 43.0221 176.788C41.903 176.149 40.8637 175.909 39.9844 176.069L59.6499 158.322L75.3982 177.827L47.8985 188.859C48.2183 188.3 48.4581 187.42 48.4581 186.381Z"
              fill="#0F054C"
            />
          </g>
        </g>
        <path
          d="M88.1842 111.635L83.9474 109.077C83.9474 109.077 83.9474 109.077 83.8674 109.077L83.7075 108.997C82.9881 108.677 82.1087 108.757 81.0695 109.317L80.43 109.716C78.0317 111.075 76.0332 114.833 76.0332 118.11V146.249L80.2701 148.728L80.9895 142.812L84.9866 140.494V112.354C84.9866 112.275 84.9866 112.195 84.9866 112.115L88.1842 111.635Z"
          fill="url(#paint17_linear_656_10249)"
        />
        <path
          d="M89.7885 143.291L80.3555 148.727V120.588C80.3555 117.39 82.354 113.633 84.7522 112.194L85.3918 111.794C87.79 110.435 89.7885 111.874 89.7885 115.072V143.291Z"
          fill="url(#paint18_linear_656_10249)"
        />
        <path
          opacity="0.3"
          d="M78.4342 126.185L78.2743 126.105C77.9546 125.945 77.7147 125.945 77.5549 126.105L76.5156 126.745L77.2351 126.905C77.2351 126.985 77.2351 126.985 77.2351 127.065V132.98C77.2351 133.78 77.7147 134.739 78.3543 135.059L78.1144 135.858L79.1537 135.219C79.3935 135.139 79.5534 134.739 79.5534 134.259V128.344C79.5534 127.464 79.0737 126.505 78.4342 126.185Z"
          fill="#0F054C"
        />
        <path
          d="M77.3123 135.697L77.1524 135.617C76.5128 135.298 76.0332 134.338 76.0332 133.539V127.623C76.0332 126.824 76.5128 126.424 77.1524 126.744L77.3123 126.824C77.9518 127.144 78.4314 128.103 78.4314 128.902V134.818C78.4314 135.697 77.9518 136.017 77.3123 135.697Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M50.4387 213.449C58.825 208.909 59.2519 193.458 51.3921 178.937C43.5323 164.416 30.3622 156.325 21.9758 160.864C13.5895 165.404 13.1626 180.855 21.0224 195.376C28.8822 209.896 42.0523 217.988 50.4387 213.449Z"
          fill="#42E8E0"
        />
      </g>
      <path
        d="M223.772 179.906L218.336 179.107L124.165 124.747C123.046 124.108 121.447 124.028 120.488 124.587L64.4492 156.963L61.0117 156.484V161.04C61.0117 161.44 61.3315 161.92 61.8911 162.239L160.538 219.237C161.657 219.877 163.256 219.957 164.215 219.397L223.132 185.422C223.532 185.182 223.772 184.863 223.772 184.463V179.906Z"
        fill="url(#paint19_linear_656_10249)"
      />
      <path
        d="M61.8905 157.682L160.538 214.68C161.657 215.32 163.256 215.4 164.215 214.84L223.131 180.865C224.091 180.306 223.931 179.346 222.892 178.787L124.244 121.789C123.125 121.149 121.526 121.069 120.567 121.629L61.6507 155.604C60.6914 156.163 60.8513 157.043 61.8905 157.682Z"
        fill="url(#paint20_linear_656_10249)"
      />
      <path
        opacity="0.3"
        d="M70.4411 158.801L158.616 209.723C159.575 210.283 161.014 210.362 161.894 209.883L214.495 179.505C215.294 179.026 215.214 178.146 214.255 177.587L126.08 126.664C125.121 126.105 123.682 126.025 122.802 126.504L70.2013 156.882C69.4019 157.442 69.4818 158.241 70.4411 158.801Z"
        fill="#24126A"
      />
      <path
        d="M223.129 180.306L164.213 214.281C163.254 214.84 161.655 214.76 160.536 214.121L61.8885 157.123C61.4088 156.883 61.169 156.483 61.0091 156.163C60.8492 156.643 61.169 157.203 61.8885 157.602L160.536 214.6C161.655 215.24 163.254 215.32 164.213 214.76L223.129 180.785C223.689 180.466 223.849 180.066 223.689 179.586C223.609 179.906 223.449 180.146 223.129 180.306Z"
        fill="white"
      />
      <path
        d="M128.003 108.599L109.217 97.8866C107.138 96.6875 105.779 94.4491 105.779 91.971V60.9539H106.099V91.971C106.099 94.2892 107.378 96.4476 109.377 97.5668L128.083 108.279L128.003 108.599Z"
        fill="#42E8E0"
      />
      <path
        d="M123.991 103.961L136.462 29.9359L135.423 29.5362L136.942 28.6568C137.262 28.497 137.661 28.497 138.141 28.7368L237.827 86.2943C238.627 86.7739 239.266 87.973 239.106 88.8524L226.556 163.437C226.476 163.837 226.316 164.077 225.996 164.157L224.557 165.036L224.317 163.677H224.397L125.35 106.439C124.471 106.04 123.831 104.841 123.991 103.961Z"
        fill="url(#paint21_linear_656_10249)"
      />
      <path
        d="M237.268 88.3729L238.947 87.6534C239.107 88.0531 239.187 88.5328 239.187 88.8526L226.556 163.437C226.476 163.837 226.316 164.077 225.996 164.157L224.557 165.036L224.318 163.677H224.398L219.361 160.799L237.268 88.3729Z"
        fill="url(#paint22_linear_656_10249)"
      />
      <path
        d="M123.751 107.398L223.438 164.956C224.237 165.435 224.877 165.116 225.037 164.316L237.587 89.7314C237.747 88.852 237.108 87.6529 236.308 87.1733L136.542 29.6957C135.742 29.2161 135.103 29.5358 134.943 30.3352L122.392 104.92C122.312 105.72 122.872 106.919 123.751 107.398Z"
        fill="#24126A"
      />
      <g opacity="0.51">
        <path
          d="M136.223 31.0552L236.389 88.8525L223.758 163.677L123.672 105.88L136.223 31.0552Z"
          fill="#453C9E"
        />
      </g>
      <path
        d="M61.0781 142.733L66.5141 145.611L121.034 114.115C121.913 113.555 123.512 113.635 124.631 114.274L218.722 168.554C219.601 168.075 223.758 166.076 223.758 166.076L221.759 169.274C221.679 169.514 221.52 169.753 221.2 169.913L163.722 203.089C162.843 203.648 161.244 203.568 160.125 202.929L63.8761 147.37C63.4764 147.13 63.1566 146.81 63.0766 146.491L61.0781 142.733Z"
        fill="url(#paint23_linear_656_10249)"
      />
      <path
        d="M61.8749 143.612L160.522 200.61C161.641 201.25 163.24 201.33 164.199 200.77L223.116 166.795C224.075 166.236 223.915 165.276 222.876 164.717L124.229 107.719C123.11 107.079 121.511 106.999 120.552 107.559L61.635 141.534C60.6758 142.094 60.8356 142.973 61.8749 143.612Z"
        fill="url(#paint24_linear_656_10249)"
      />
      <path
        d="M61.8765 143.213L160.524 200.211C161.643 200.85 163.242 200.93 164.201 200.371L223.117 166.396C223.437 166.236 223.677 165.996 223.677 165.676C223.757 166.076 223.597 166.476 223.117 166.795L164.201 200.77C163.242 201.33 161.643 201.25 160.524 200.61L61.8765 143.613C61.157 143.213 60.9172 142.653 60.9971 142.174C61.157 142.573 61.3968 142.893 61.8765 143.213Z"
        fill="white"
      />
      <g opacity="0.15">
        <mask
          id="mask1_656_10249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="123"
          y="31"
          width="114"
          height="133"
        >
          <path
            d="M236.393 88.8527L136.227 31.0554L123.676 105.88L223.762 163.677L236.393 88.8527Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_656_10249)">
          <path
            d="M123.592 106.918L129.028 109.796L183.548 78.2996C184.427 77.74 186.026 77.82 187.145 78.4595L281.235 132.739C282.115 132.26 286.272 130.261 286.272 130.261L284.273 133.459C284.193 133.699 284.033 133.939 283.714 134.098L226.236 167.274C225.357 167.833 223.758 167.754 222.639 167.114L126.39 111.555C125.99 111.315 125.67 110.995 125.59 110.676L123.592 106.918Z"
            fill="url(#paint25_linear_656_10249)"
          />
          <path
            d="M124.47 107.797L223.117 164.794C224.237 165.434 225.835 165.514 226.795 164.954L285.711 130.979C286.671 130.42 286.511 129.461 285.471 128.901L186.824 71.9031C185.705 71.2636 184.106 71.1836 183.147 71.7432L124.231 105.718C123.271 106.278 123.351 107.237 124.47 107.797Z"
            fill="url(#paint26_linear_656_10249)"
          />
          <path
            d="M285.391 128.821L186.744 71.823C186.024 71.4233 185.145 71.2634 184.266 71.3433C184.905 71.4233 185.465 71.5832 185.944 71.823L284.592 128.821C285.711 129.46 285.791 130.42 284.831 130.899L225.915 164.874C225.595 165.034 225.195 165.194 224.716 165.194C225.435 165.274 226.155 165.114 226.634 164.874L285.551 130.899C286.59 130.42 286.43 129.46 285.391 128.821Z"
            fill="white"
          />
          <g opacity="0.5">
            <path
              d="M176.116 98.0441L172.918 96.2055C172.678 96.0456 172.199 96.0456 171.959 96.2055L168.442 98.284C168.202 98.4438 168.122 98.6837 168.362 98.8435L171.559 100.682C171.799 100.842 172.279 100.842 172.519 100.682L176.036 98.6037C176.356 98.4438 176.356 98.204 176.116 98.0441Z"
              fill="#24126A"
            />
            <path
              d="M180.995 100.843L177.797 99.0041C177.557 98.8442 177.078 98.8442 176.838 99.0041L173.32 101.083C173.081 101.242 173.001 101.482 173.241 101.642L176.438 103.481C176.678 103.641 177.158 103.641 177.397 103.481L180.915 101.402C181.235 101.242 181.235 101.003 180.995 100.843Z"
              fill="#24126A"
            />
            <path
              d="M185.87 103.64L182.672 101.802C182.432 101.642 181.953 101.642 181.713 101.802L178.195 103.88C177.956 104.04 177.876 104.28 178.116 104.44L181.313 106.278C181.553 106.438 182.033 106.438 182.272 106.278L185.79 104.2C186.11 104.04 186.11 103.8 185.87 103.64Z"
              fill="#24126A"
            />
            <path
              d="M182.191 107.398L178.993 105.559C178.754 105.4 178.274 105.4 178.034 105.559L175.076 107.318C174.836 107.478 174.757 107.718 174.996 107.878L178.194 109.716C178.434 109.876 178.913 109.876 179.153 109.716L182.111 107.958C182.431 107.798 182.431 107.558 182.191 107.398Z"
              fill="#24126A"
            />
            <path
              d="M187.07 110.195L183.872 108.356C183.633 108.197 183.153 108.197 182.913 108.356L179.955 110.115C179.715 110.275 179.635 110.515 179.875 110.675L183.073 112.513C183.313 112.673 183.792 112.673 184.032 112.513L186.99 110.755C187.31 110.595 187.31 110.355 187.07 110.195Z"
              fill="#24126A"
            />
            <path
              d="M191.943 113.074L188.745 111.235C188.506 111.075 188.026 111.075 187.786 111.235L184.828 112.994C184.588 113.153 184.508 113.393 184.748 113.553L187.946 115.392C188.186 115.552 188.665 115.552 188.905 115.392L191.863 113.633C192.183 113.473 192.183 113.233 191.943 113.074Z"
              fill="#24126A"
            />
            <path
              d="M196.82 115.87L193.622 114.031C193.382 113.871 192.903 113.871 192.663 114.031L189.705 115.79C189.465 115.95 189.385 116.189 189.625 116.349L192.823 118.188C193.063 118.348 193.542 118.348 193.782 118.188L196.74 116.429C197.06 116.269 197.06 116.03 196.82 115.87Z"
              fill="#24126A"
            />
            <path
              d="M201.697 118.669L198.499 116.83C198.259 116.67 197.78 116.67 197.54 116.83L194.582 118.589C194.342 118.749 194.262 118.989 194.502 119.149L197.7 120.987C197.94 121.147 198.419 121.147 198.659 120.987L201.617 119.229C201.937 119.069 201.937 118.829 201.697 118.669Z"
              fill="#24126A"
            />
            <path
              d="M206.574 121.547L203.376 119.708C203.136 119.548 202.657 119.548 202.417 119.708L199.459 121.467C199.219 121.627 199.139 121.866 199.379 122.026L202.577 123.865C202.817 124.025 203.296 124.025 203.536 123.865L206.494 122.106C206.814 121.946 206.814 121.627 206.574 121.547Z"
              fill="#24126A"
            />
            <path
              d="M211.451 124.345L208.253 122.507C208.013 122.347 207.534 122.347 207.294 122.507L204.336 124.265C204.096 124.425 204.016 124.665 204.256 124.825L207.454 126.664C207.694 126.823 208.173 126.823 208.413 126.664L211.371 124.905C211.691 124.745 211.771 124.505 211.451 124.345Z"
              fill="#24126A"
            />
            <path
              d="M216.328 127.143L213.13 125.304C212.89 125.144 212.411 125.144 212.171 125.304L209.213 127.063C208.973 127.223 208.893 127.463 209.133 127.623L212.331 129.461C212.571 129.621 213.05 129.621 213.29 129.461L216.248 127.703C216.568 127.543 216.648 127.303 216.328 127.143Z"
              fill="#24126A"
            />
            <path
              d="M221.281 129.941L218.083 128.103C217.843 127.943 217.364 127.943 217.124 128.103L214.166 129.862C213.926 130.021 213.846 130.261 214.086 130.421L217.284 132.26C217.524 132.42 218.003 132.42 218.243 132.26L221.201 130.501C221.521 130.341 221.521 130.101 221.281 129.941Z"
              fill="#24126A"
            />
            <path
              d="M226.16 132.818L222.962 130.98C222.722 130.82 222.243 130.82 222.003 130.98L219.045 132.738C218.805 132.898 218.725 133.138 218.965 133.298L222.163 135.137C222.403 135.297 222.882 135.297 223.122 135.137L226.08 133.378C226.4 133.218 226.4 132.978 226.16 132.818Z"
              fill="#24126A"
            />
            <path
              d="M180.113 111.475L176.915 109.636C176.675 109.476 176.196 109.476 175.956 109.636L172.998 111.395C172.758 111.555 172.678 111.795 172.918 111.955L176.116 113.793C176.356 113.953 176.835 113.953 177.075 113.793L180.033 112.034C180.353 111.795 180.353 111.555 180.113 111.475Z"
              fill="#24126A"
            />
            <path
              d="M175.158 108.596L171.96 106.758C171.72 106.598 171.241 106.598 171.001 106.758L168.043 108.516C167.803 108.676 167.723 108.916 167.963 109.076L171.161 110.915C171.401 111.075 171.88 111.075 172.12 110.915L175.078 109.156C175.398 108.996 175.398 108.756 175.158 108.596Z"
              fill="#24126A"
            />
            <path
              d="M170.201 105.719L163.406 101.802C163.166 101.642 162.686 101.642 162.446 101.802L159.488 103.561C159.249 103.72 159.169 103.96 159.408 104.12L166.203 108.037C166.443 108.197 166.923 108.197 167.163 108.037L170.121 106.278C170.44 106.119 170.44 105.879 170.201 105.719Z"
              fill="#24126A"
            />
            <path
              d="M164.445 107.557L158.929 104.36C158.689 104.2 158.209 104.2 157.97 104.36L155.012 106.118C154.772 106.278 154.692 106.518 154.932 106.678L160.448 109.876C160.688 110.035 161.167 110.035 161.407 109.876L164.365 108.117C164.685 107.957 164.685 107.717 164.445 107.557Z"
              fill="#24126A"
            />
            <path
              d="M184.99 114.271L181.792 112.432C181.552 112.272 181.073 112.272 180.833 112.432L177.875 114.191C177.635 114.351 177.555 114.591 177.795 114.751L180.993 116.589C181.233 116.749 181.712 116.749 181.952 116.589L184.91 114.831C185.23 114.671 185.31 114.431 184.99 114.271Z"
              fill="#24126A"
            />
            <path
              d="M189.867 117.07L186.669 115.231C186.429 115.071 185.95 115.071 185.71 115.231L182.752 116.99C182.512 117.149 182.432 117.389 182.672 117.549L185.87 119.388C186.11 119.548 186.589 119.548 186.829 119.388L189.787 117.629C190.107 117.469 190.187 117.229 189.867 117.07Z"
              fill="#24126A"
            />
            <path
              d="M194.822 119.868L191.624 118.029C191.384 117.87 190.905 117.87 190.665 118.029L187.707 119.788C187.467 119.948 187.387 120.188 187.627 120.348L190.825 122.186C191.065 122.346 191.544 122.346 191.784 122.186L194.742 120.428C195.062 120.268 195.062 120.028 194.822 119.868Z"
              fill="#24126A"
            />
            <path
              d="M199.699 122.747L196.501 120.908C196.261 120.748 195.782 120.748 195.542 120.908L192.584 122.667C192.344 122.826 192.264 123.066 192.504 123.226L195.702 125.065C195.942 125.225 196.421 125.225 196.661 125.065L199.619 123.306C199.939 123.146 199.939 122.826 199.699 122.747Z"
              fill="#24126A"
            />
            <path
              d="M204.576 125.544L201.378 123.706C201.138 123.546 200.659 123.546 200.419 123.706L197.461 125.464C197.221 125.624 197.141 125.864 197.381 126.024L200.579 127.863C200.819 128.022 201.298 128.022 201.538 127.863L204.496 126.104C204.816 125.944 204.816 125.704 204.576 125.544Z"
              fill="#24126A"
            />
            <path
              d="M209.453 128.343L206.255 126.504C206.015 126.344 205.536 126.344 205.296 126.504L202.338 128.263C202.098 128.423 202.018 128.663 202.258 128.822L205.456 130.661C205.696 130.821 206.175 130.821 206.415 130.661L209.373 128.902C209.693 128.743 209.693 128.503 209.453 128.343Z"
              fill="#24126A"
            />
            <path
              d="M214.328 131.139L211.13 129.3C210.89 129.14 210.411 129.14 210.171 129.3L207.213 131.059C206.973 131.219 206.893 131.459 207.133 131.619L210.331 133.457C210.571 133.617 211.05 133.617 211.29 133.457L214.248 131.699C214.568 131.539 214.568 131.299 214.328 131.139Z"
              fill="#24126A"
            />
            <path
              d="M219.207 134.018L216.009 132.18C215.769 132.02 215.29 132.02 215.05 132.18L212.092 133.938C211.852 134.098 211.772 134.338 212.012 134.498L215.21 136.337C215.449 136.496 215.929 136.496 216.169 136.337L219.127 134.578C219.446 134.418 219.446 134.178 219.207 134.018Z"
              fill="#24126A"
            />
            <path
              d="M224.08 136.815L220.882 134.976C220.642 134.817 220.163 134.817 219.923 134.976L216.965 136.735C216.725 136.895 216.645 137.135 216.885 137.295L220.083 139.133C220.322 139.293 220.802 139.293 221.042 139.133L224 137.375C224.32 137.215 224.32 136.975 224.08 136.815Z"
              fill="#24126A"
            />
            <path
              d="M232.796 141.852L225.921 137.855C225.681 137.695 225.202 137.695 224.962 137.855L222.004 139.614C221.764 139.774 221.684 140.013 221.924 140.173L228.799 144.17C229.039 144.33 229.519 144.33 229.758 144.17L232.716 142.412C233.036 142.252 233.036 142.012 232.796 141.852Z"
              fill="#24126A"
            />
            <path
              d="M223.843 147.047L218.007 143.689C217.767 143.529 217.288 143.529 217.048 143.689L214.09 145.448C213.85 145.608 213.77 145.848 214.01 146.008L219.846 149.365C220.086 149.525 220.565 149.525 220.805 149.365L223.763 147.606C224.083 147.447 224.083 147.207 223.843 147.047Z"
              fill="#24126A"
            />
            <path
              d="M184.349 119.068L181.152 117.229C180.912 117.069 180.432 117.069 180.192 117.229L177.235 118.988C176.995 119.148 176.915 119.388 177.155 119.548L180.352 121.386C180.592 121.546 181.072 121.546 181.312 121.386L184.269 119.628C184.589 119.468 184.589 119.228 184.349 119.068Z"
              fill="#24126A"
            />
            <path
              d="M179.316 116.191L176.118 114.352C175.879 114.193 175.399 114.193 175.159 114.352L172.201 116.111C171.961 116.271 171.882 116.511 172.121 116.671L175.319 118.509C175.559 118.669 176.038 118.669 176.278 118.509L179.236 116.751C179.556 116.591 179.556 116.351 179.316 116.191Z"
              fill="#24126A"
            />
            <path
              d="M174.357 113.313L171.159 111.474C170.92 111.314 170.44 111.314 170.2 111.474L167.242 113.233C167.003 113.392 166.923 113.632 167.162 113.792L170.36 115.631C170.6 115.791 171.079 115.791 171.319 115.631L174.277 113.872C174.597 113.712 174.597 113.472 174.357 113.313Z"
              fill="#24126A"
            />
            <path
              d="M169.322 110.435L166.124 108.596C165.884 108.436 165.405 108.436 165.165 108.596L162.207 110.355C161.967 110.515 161.887 110.755 162.127 110.915L165.325 112.753C165.565 112.913 166.044 112.913 166.284 112.753L169.242 110.994C169.562 110.755 169.562 110.515 169.322 110.435Z"
              fill="#24126A"
            />
            <path
              d="M189.228 121.866L186.031 120.027C185.791 119.867 185.311 119.867 185.071 120.027L182.113 121.786C181.874 121.946 181.794 122.185 182.033 122.345L185.231 124.184C185.471 124.344 185.951 124.344 186.19 124.184L189.148 122.425C189.468 122.265 189.468 122.026 189.228 121.866Z"
              fill="#24126A"
            />
            <path
              d="M194.101 124.745L190.904 122.906C190.664 122.746 190.184 122.746 189.944 122.906L186.986 124.665C186.747 124.825 186.667 125.065 186.907 125.225L190.104 127.063C190.344 127.223 190.824 127.223 191.063 127.063L194.021 125.305C194.341 125.065 194.341 124.825 194.101 124.745Z"
              fill="#24126A"
            />
            <path
              d="M198.978 127.543L195.781 125.704C195.541 125.544 195.061 125.544 194.821 125.704L191.863 127.463C191.624 127.623 191.544 127.862 191.783 128.022L194.981 129.861C195.221 130.021 195.701 130.021 195.94 129.861L198.898 128.102C199.218 127.942 199.218 127.703 198.978 127.543Z"
              fill="#24126A"
            />
            <path
              d="M203.855 130.34L200.657 128.502C200.418 128.342 199.938 128.342 199.698 128.502L196.74 130.26C196.501 130.42 196.421 130.66 196.66 130.82L199.858 132.659C200.098 132.819 200.578 132.819 200.817 132.659L203.775 130.9C204.095 130.74 204.095 130.5 203.855 130.34Z"
              fill="#24126A"
            />
            <path
              d="M208.734 133.14L205.536 131.301C205.297 131.141 204.817 131.141 204.577 131.301L201.619 133.06C201.379 133.22 201.3 133.459 201.539 133.619L204.737 135.458C204.977 135.618 205.456 135.618 205.696 135.458L208.654 133.699C208.974 133.539 209.054 133.3 208.734 133.14Z"
              fill="#24126A"
            />
            <path
              d="M213.687 136.016L210.49 134.177C210.25 134.017 209.77 134.017 209.53 134.177L206.572 135.936C206.333 136.096 206.253 136.336 206.492 136.495L209.69 138.334C209.93 138.494 210.41 138.494 210.649 138.334L213.607 136.575C213.847 136.416 213.927 136.096 213.687 136.016Z"
              fill="#24126A"
            />
            <path
              d="M218.564 138.814L215.366 136.976C215.127 136.816 214.647 136.816 214.407 136.976L211.449 138.734C211.21 138.894 211.13 139.134 211.369 139.294L214.567 141.133C214.807 141.292 215.287 141.292 215.526 141.133L218.484 139.374C218.804 139.214 218.804 138.974 218.564 138.814Z"
              fill="#24126A"
            />
            <path
              d="M223.443 141.611L220.245 139.773C220.006 139.613 219.526 139.613 219.286 139.773L216.328 141.531C216.088 141.691 216.009 141.931 216.248 142.091L219.446 143.93C219.686 144.089 220.165 144.089 220.405 143.93L223.363 142.171C223.683 142.011 223.683 141.771 223.443 141.611Z"
              fill="#24126A"
            />
            <path
              d="M228.318 144.41L225.12 142.571C224.881 142.411 224.401 142.411 224.161 142.571L221.203 144.33C220.963 144.49 220.883 144.729 221.123 144.889L224.321 146.728C224.561 146.888 225.04 146.888 225.28 146.728L228.238 144.969C228.558 144.809 228.558 144.57 228.318 144.41Z"
              fill="#24126A"
            />
            <path
              d="M172.519 117.469L169.322 115.631C169.082 115.471 168.602 115.471 168.362 115.631L165.404 117.389C165.165 117.549 165.085 117.789 165.324 117.949L168.522 119.787C168.762 119.947 169.242 119.947 169.481 119.787L172.439 118.029C172.759 117.869 172.759 117.629 172.519 117.469Z"
              fill="#24126A"
            />
            <path
              d="M167.642 114.672L164.445 112.834C164.205 112.674 163.725 112.674 163.485 112.834L160.527 114.592C160.288 114.752 160.208 114.992 160.448 115.152L163.645 116.991C163.885 117.15 164.365 117.15 164.604 116.991L167.562 115.232C167.882 115.072 167.962 114.832 167.642 114.672Z"
              fill="#24126A"
            />
            <path
              d="M162.843 111.874L159.646 110.035C159.406 109.875 158.926 109.875 158.686 110.035L155.729 111.794C155.489 111.954 155.409 112.193 155.649 112.353L158.846 114.192C159.086 114.352 159.566 114.352 159.806 114.192L162.763 112.433C163.083 112.273 163.083 111.954 162.843 111.874Z"
              fill="#24126A"
            />
            <path
              d="M157.97 108.996L154.773 107.157C154.533 106.998 154.053 106.998 153.813 107.157L150.856 108.916C150.616 109.076 150.536 109.316 150.776 109.476L153.973 111.314C154.213 111.474 154.693 111.474 154.933 111.314L157.89 109.556C158.21 109.396 158.21 109.156 157.97 108.996Z"
              fill="#24126A"
            />
            <path
              d="M153.253 111.794L150.055 109.955C149.816 109.795 149.336 109.795 149.096 109.955L148.137 110.515C147.897 110.675 147.817 110.914 148.057 111.074L151.255 112.913C151.494 113.073 151.974 113.073 152.214 112.913L153.173 112.353C153.493 112.193 153.493 111.954 153.253 111.794Z"
              fill="#24126A"
            />
            <path
              d="M159.568 115.472L156.37 113.633C156.13 113.473 155.65 113.473 155.411 113.633L154.451 114.193C154.211 114.352 154.132 114.592 154.371 114.752L157.569 116.591C157.809 116.751 158.288 116.751 158.528 116.591L159.488 116.031C159.807 115.871 159.887 115.631 159.568 115.472Z"
              fill="#24126A"
            />
            <path
              d="M164.446 118.269L161.249 116.431C161.009 116.271 160.529 116.271 160.29 116.431L159.33 116.99C159.09 117.15 159.01 117.39 159.25 117.55L162.448 119.389C162.688 119.548 163.167 119.548 163.407 119.389L164.366 118.829C164.686 118.669 164.686 118.349 164.446 118.269Z"
              fill="#24126A"
            />
            <path
              d="M169.241 121.068L166.044 119.229C165.804 119.069 165.324 119.069 165.084 119.229L164.125 119.789C163.885 119.949 163.805 120.189 164.045 120.348L167.243 122.187C167.483 122.347 167.962 122.347 168.202 122.187L169.161 121.628C169.481 121.468 169.561 121.148 169.241 121.068Z"
              fill="#24126A"
            />
            <path
              d="M174.12 123.864L170.923 122.025C170.683 121.865 170.203 121.865 169.963 122.025L169.004 122.585C168.764 122.745 168.684 122.985 168.924 123.144L172.122 124.983C172.362 125.143 172.841 125.143 173.081 124.983L174.04 124.424C174.36 124.184 174.36 123.944 174.12 123.864Z"
              fill="#24126A"
            />
            <path
              d="M201.138 139.453L197.94 137.614C197.7 137.454 197.221 137.454 196.981 137.614L196.022 138.174C195.782 138.334 195.702 138.574 195.942 138.733L199.139 140.572C199.379 140.732 199.859 140.732 200.099 140.572L201.058 140.013C201.378 139.853 201.378 139.613 201.138 139.453Z"
              fill="#24126A"
            />
            <path
              d="M206.015 142.252L202.817 140.413C202.577 140.253 202.098 140.253 201.858 140.413L200.899 140.972C200.659 141.132 200.579 141.372 200.819 141.532L204.016 143.371C204.256 143.531 204.736 143.531 204.976 143.371L205.935 142.811C206.175 142.651 206.255 142.331 206.015 142.252Z"
              fill="#24126A"
            />
            <path
              d="M210.812 145.05L207.614 143.211C207.374 143.052 206.895 143.052 206.655 143.211L205.695 143.771C205.456 143.931 205.376 144.171 205.616 144.331L208.813 146.169C209.053 146.329 209.533 146.329 209.772 146.169L210.732 145.61C211.051 145.45 211.051 145.13 210.812 145.05Z"
              fill="#24126A"
            />
            <path
              d="M215.687 147.847L212.489 146.008C212.249 145.848 211.77 145.848 211.53 146.008L210.57 146.568C210.331 146.728 210.251 146.968 210.491 147.128L213.688 148.966C213.928 149.126 214.408 149.126 214.647 148.966L215.607 148.407C215.926 148.247 215.926 147.927 215.687 147.847Z"
              fill="#24126A"
            />
            <path
              d="M177.394 120.268L174.197 118.429C173.957 118.269 173.477 118.269 173.237 118.429L170.279 120.188C170.04 120.348 169.96 120.588 170.199 120.747L173.397 122.586C173.637 122.746 174.117 122.746 174.356 122.586L177.314 120.827C177.634 120.667 177.714 120.428 177.394 120.268Z"
              fill="#24126A"
            />
            <path
              d="M182.273 123.065L179.075 121.226C178.836 121.066 178.356 121.066 178.116 121.226L175.158 122.985C174.919 123.145 174.839 123.384 175.078 123.544L178.276 125.383C178.516 125.543 178.995 125.543 179.235 125.383L182.193 123.624C182.513 123.464 182.593 123.225 182.273 123.065Z"
              fill="#24126A"
            />
            <path
              d="M187.228 125.945L184.031 124.106C183.791 123.946 183.311 123.946 183.071 124.106L180.113 125.865C179.874 126.025 179.794 126.265 180.033 126.424L183.231 128.263C183.471 128.423 183.951 128.423 184.19 128.263L187.148 126.504C187.468 126.344 187.468 126.025 187.228 125.945Z"
              fill="#24126A"
            />
            <path
              d="M192.103 128.742L188.906 126.903C188.666 126.743 188.186 126.743 187.946 126.903L184.988 128.662C184.749 128.822 184.669 129.061 184.908 129.221L188.106 131.06C188.346 131.22 188.826 131.22 189.065 131.06L192.023 129.301C192.343 129.141 192.343 128.902 192.103 128.742Z"
              fill="#24126A"
            />
            <path
              d="M196.98 131.54L193.782 129.702C193.543 129.542 193.063 129.542 192.823 129.702L189.865 131.46C189.626 131.62 189.546 131.86 189.785 132.02L192.983 133.859C193.223 134.018 193.703 134.018 193.942 133.859L196.9 132.1C197.22 131.94 197.22 131.7 196.98 131.54Z"
              fill="#24126A"
            />
            <path
              d="M201.859 134.337L198.661 132.498C198.422 132.339 197.942 132.339 197.702 132.498L194.744 134.257C194.504 134.417 194.425 134.657 194.664 134.817L197.862 136.655C198.102 136.815 198.581 136.815 198.821 136.655L201.779 134.897C202.099 134.737 202.099 134.497 201.859 134.337Z"
              fill="#24126A"
            />
            <path
              d="M206.734 137.216L203.536 135.377C203.297 135.217 202.817 135.217 202.577 135.377L199.619 137.136C199.379 137.296 199.3 137.535 199.539 137.695L202.737 139.534C202.977 139.694 203.456 139.694 203.696 139.534L206.654 137.775C206.974 137.615 206.974 137.376 206.734 137.216Z"
              fill="#24126A"
            />
            <path
              d="M211.611 140.012L208.413 138.173C208.174 138.013 207.694 138.013 207.454 138.173L204.496 139.932C204.256 140.092 204.176 140.332 204.416 140.491L207.614 142.33C207.854 142.49 208.333 142.49 208.573 142.33L211.531 140.571C211.851 140.411 211.851 140.172 211.611 140.012Z"
              fill="#24126A"
            />
            <path
              d="M216.486 142.811L213.288 140.972C213.049 140.813 212.569 140.813 212.329 140.972L209.371 142.731C209.131 142.891 209.051 143.131 209.291 143.291L212.489 145.129C212.729 145.289 213.208 145.289 213.448 145.129L216.406 143.371C216.726 143.211 216.726 142.971 216.486 142.811Z"
              fill="#24126A"
            />
            <path
              d="M177.155 104.52L167.802 99.1639C167.562 99.004 167.083 99.004 166.843 99.1639L163.885 100.923C163.645 101.082 163.565 101.322 163.805 101.482L173.158 106.838C173.398 106.998 173.878 106.998 174.117 106.838L177.075 105.079C177.395 104.92 177.475 104.68 177.155 104.52Z"
              fill="#24126A"
            />
            <path
              d="M237.19 139.213L227.837 133.857C227.597 133.697 227.118 133.697 226.878 133.857L223.92 135.616C223.68 135.776 223.6 136.016 223.84 136.176L233.193 141.532C233.433 141.692 233.913 141.692 234.153 141.532L237.11 139.773C237.43 139.613 237.43 139.293 237.19 139.213Z"
              fill="#24126A"
            />
            <path
              d="M228.157 128.021L224.959 126.183C224.719 126.023 224.24 126.023 224 126.183L220.483 128.261C220.243 128.421 220.163 128.661 220.403 128.821L223.6 130.659C223.84 130.819 224.32 130.819 224.56 130.659L228.077 128.581C228.397 128.421 228.397 128.181 228.157 128.021Z"
              fill="#24126A"
            />
            <path
              d="M192.665 107.556L187.629 104.599C187.389 104.439 186.91 104.439 186.67 104.599L183.152 106.677C182.913 106.837 182.833 107.077 183.073 107.237L188.109 110.195C188.349 110.354 188.828 110.354 189.068 110.195L192.586 108.116C192.905 107.956 192.905 107.716 192.665 107.556Z"
              fill="#24126A"
            />
            <path
              d="M223.443 125.304L218.407 122.346C218.167 122.186 217.687 122.186 217.447 122.346L213.93 124.424C213.69 124.584 213.61 124.824 213.85 124.984L218.886 127.942C219.126 128.102 219.606 128.102 219.845 127.942L223.363 125.863C223.683 125.703 223.683 125.464 223.443 125.304Z"
              fill="#24126A"
            />
            <path
              d="M199.697 111.633L194.66 108.675C194.421 108.515 193.941 108.515 193.701 108.675L190.184 110.754C189.944 110.914 189.864 111.154 190.104 111.313L195.14 114.271C195.38 114.431 195.86 114.431 196.099 114.271L199.617 112.193C199.937 112.033 199.937 111.793 199.697 111.633Z"
              fill="#24126A"
            />
            <path
              d="M190.188 111.393L212.171 124.104C212.411 124.264 212.891 124.264 213.131 124.104L216.728 122.025C216.968 121.866 216.968 121.626 216.728 121.466L194.744 108.755L190.188 111.393Z"
              fill="#24126A"
            />
            <path
              d="M232.233 133.058L235.75 135.057C235.99 135.217 236.31 135.137 236.549 135.057L237.988 134.177C238.228 134.018 238.228 133.858 237.988 133.698L234.471 131.699C234.231 131.539 233.911 131.619 233.672 131.699L232.233 132.579C231.993 132.738 231.993 132.898 232.233 133.058Z"
              fill="#24126A"
            />
            <path
              d="M227.358 130.181L230.875 132.18C231.115 132.34 231.435 132.26 231.674 132.18L233.113 131.301C233.353 131.141 233.353 130.981 233.113 130.821L229.596 128.822C229.356 128.663 229.036 128.742 228.797 128.822L227.358 129.702C227.118 129.862 227.118 130.101 227.358 130.181Z"
              fill="#24126A"
            />
            <path
              d="M229.675 134.497L233.192 136.496C233.432 136.655 233.752 136.576 233.992 136.496L235.431 135.616C235.67 135.456 235.67 135.296 235.431 135.137L231.913 133.138C231.673 132.978 231.354 133.058 231.114 133.138L229.675 134.017C229.515 134.177 229.435 134.417 229.675 134.497Z"
              fill="#24126A"
            />
          </g>
        </g>
      </g>
      <g opacity="0.8">
        <path
          d="M107.291 137.297L104.173 135.458C103.933 135.298 103.933 135.059 104.253 134.899L107.93 132.74C108.25 132.58 108.65 132.58 108.889 132.66L112.007 134.499C112.247 134.659 112.247 134.899 111.927 135.059L108.25 137.217C108.01 137.457 107.53 137.457 107.291 137.297Z"
          fill="#24126A"
        />
        <path
          d="M112.087 140.095L108.97 138.257C108.73 138.097 108.73 137.857 109.05 137.697L112.727 135.539C113.047 135.379 113.446 135.379 113.686 135.459L116.804 137.298C117.044 137.457 117.044 137.697 116.724 137.857L113.047 140.016C112.807 140.255 112.407 140.255 112.087 140.095Z"
          fill="#24126A"
        />
        <path
          d="M116.961 142.892L113.843 141.054C113.603 140.894 113.603 140.654 113.923 140.494L117.6 138.336C117.92 138.176 118.32 138.176 118.559 138.256L121.677 140.094C121.917 140.254 121.917 140.494 121.597 140.654L117.92 142.812C117.68 143.052 117.2 143.052 116.961 142.892Z"
          fill="#24126A"
        />
        <path
          d="M123.679 140.574L120.562 138.736C120.322 138.576 120.322 138.336 120.642 138.176L123.759 136.417C124.079 136.257 124.479 136.257 124.719 136.337L127.836 138.176C128.076 138.336 128.076 138.576 127.756 138.736L124.639 140.494C124.319 140.734 123.919 140.734 123.679 140.574Z"
          fill="#24126A"
        />
        <path
          d="M128.476 143.372L125.358 141.533C125.119 141.373 125.119 141.134 125.438 140.974L128.556 139.215C128.876 139.055 129.276 139.055 129.515 139.135L132.633 140.974C132.873 141.134 132.873 141.373 132.553 141.533L129.435 143.292C129.196 143.532 128.716 143.532 128.476 143.372Z"
          fill="#24126A"
        />
        <path
          d="M133.349 146.17L130.231 144.331C129.992 144.171 129.992 143.931 130.311 143.771L133.429 142.013C133.749 141.853 134.149 141.853 134.388 141.933L137.506 143.771C137.746 143.931 137.746 144.171 137.426 144.331L134.308 146.09C133.989 146.33 133.589 146.33 133.349 146.17Z"
          fill="#24126A"
        />
        <path
          d="M138.148 148.968L135.03 147.13C134.79 146.97 134.791 146.73 135.11 146.57L138.228 144.811C138.548 144.651 138.947 144.651 139.187 144.731L142.305 146.57C142.545 146.73 142.545 146.97 142.225 147.13L139.107 148.888C138.867 149.128 138.388 149.128 138.148 148.968Z"
          fill="#24126A"
        />
        <path
          d="M143.025 151.766L139.907 149.927C139.667 149.767 139.667 149.528 139.987 149.368L143.105 147.609C143.425 147.449 143.824 147.449 144.064 147.529L147.182 149.368C147.422 149.528 147.422 149.767 147.102 149.927L143.984 151.686C143.664 151.926 143.265 151.926 143.025 151.766Z"
          fill="#24126A"
        />
        <path
          d="M147.82 154.564L144.702 152.725C144.462 152.565 144.462 152.325 144.782 152.165L147.9 150.407C148.22 150.247 148.619 150.247 148.859 150.327L151.977 152.165C152.217 152.325 152.217 152.565 151.897 152.725L148.779 154.484C148.539 154.644 148.06 154.724 147.82 154.564Z"
          fill="#24126A"
        />
        <path
          d="M152.697 157.362L149.579 155.524C149.339 155.364 149.339 155.124 149.659 154.964L152.777 153.205C153.097 153.045 153.496 153.045 153.736 153.125L156.854 154.964C157.094 155.124 157.094 155.364 156.774 155.524L153.656 157.282C153.336 157.442 152.937 157.522 152.697 157.362Z"
          fill="#24126A"
        />
        <path
          d="M157.494 160.16L154.376 158.321C154.136 158.161 154.136 157.922 154.456 157.762L157.574 156.003C157.893 155.843 158.293 155.843 158.533 155.923L161.651 157.762C161.89 157.922 161.89 158.161 161.571 158.321L158.453 160.08C158.213 160.24 157.734 160.32 157.494 160.16Z"
          fill="#24126A"
        />
        <path
          d="M162.371 162.959L159.253 161.12C159.013 160.96 159.013 160.72 159.333 160.56L162.451 158.802C162.77 158.642 163.17 158.642 163.41 158.722L166.528 160.56C166.767 160.72 166.767 160.96 166.448 161.12L163.33 162.879C163.01 163.039 162.61 163.118 162.371 162.959Z"
          fill="#24126A"
        />
        <path
          d="M167.168 165.755L164.05 163.917C163.81 163.757 163.81 163.517 164.13 163.357L167.247 161.599C167.567 161.439 167.967 161.439 168.207 161.519L171.324 163.357C171.564 163.517 171.564 163.757 171.245 163.917L168.127 165.676C167.887 165.835 167.407 165.835 167.168 165.755Z"
          fill="#24126A"
        />
        <path
          d="M130.793 139.295L127.675 137.457C127.435 137.297 127.435 137.057 127.755 136.897L130.872 135.138C131.192 134.978 131.592 134.978 131.832 135.058L134.949 136.897C135.189 137.057 135.189 137.297 134.87 137.457L131.752 139.215C131.432 139.375 131.032 139.375 130.793 139.295Z"
          fill="#24126A"
        />
        <path
          d="M125.836 136.418L122.718 134.579C122.478 134.419 122.478 134.179 122.798 134.019L125.915 132.261C126.235 132.101 126.635 132.101 126.875 132.181L129.992 134.019C130.232 134.179 130.232 134.419 129.913 134.579L126.795 136.338C126.555 136.577 126.155 136.577 125.836 136.418Z"
          fill="#24126A"
        />
        <path
          d="M120.96 133.62L114.245 129.703C114.005 129.543 114.005 129.303 114.325 129.143L117.443 127.385C117.763 127.225 118.162 127.225 118.402 127.305L125.117 131.222C125.357 131.382 125.357 131.622 125.037 131.781L121.92 133.54C121.68 133.7 121.2 133.78 120.96 133.62Z"
          fill="#24126A"
        />
        <path
          d="M124.4 130.183L118.964 126.985C118.724 126.825 118.724 126.585 119.044 126.426L122.162 124.667C122.481 124.507 122.881 124.507 123.121 124.587L128.557 127.785C128.797 127.944 128.797 128.184 128.477 128.344L125.359 130.103C125.119 130.263 124.64 130.263 124.4 130.183Z"
          fill="#24126A"
        />
        <path
          d="M135.591 142.094L132.474 140.255C132.234 140.095 132.234 139.855 132.554 139.696L135.671 137.937C135.991 137.777 136.391 137.777 136.631 137.857L139.748 139.696C139.988 139.855 139.988 140.095 139.668 140.255L136.551 142.014C136.311 142.174 135.831 142.174 135.591 142.094Z"
          fill="#24126A"
        />
        <path
          d="M140.464 144.892L137.347 143.053C137.107 142.893 137.107 142.653 137.427 142.493L140.544 140.735C140.864 140.575 141.264 140.575 141.504 140.655L144.621 142.493C144.861 142.653 144.861 142.893 144.541 143.053L141.424 144.812C141.184 144.971 140.704 144.971 140.464 144.892Z"
          fill="#24126A"
        />
        <path
          d="M145.261 147.61L142.144 145.851C141.904 145.692 141.904 145.452 142.224 145.292L145.341 143.533C145.661 143.373 146.061 143.373 146.301 143.453L149.418 145.292C149.658 145.452 149.658 145.692 149.338 145.851L146.221 147.61C145.981 147.77 145.581 147.77 145.261 147.61Z"
          fill="#24126A"
        />
        <path
          d="M150.14 150.406L147.023 148.568C146.783 148.408 146.783 148.168 147.102 148.008L150.22 146.249C150.54 146.089 150.94 146.089 151.179 146.169L154.297 148.008C154.537 148.168 154.537 148.408 154.217 148.568L151.1 150.326C150.86 150.566 150.38 150.566 150.14 150.406Z"
          fill="#24126A"
        />
        <path
          d="M154.933 153.204L151.815 151.365C151.576 151.205 151.576 150.966 151.895 150.806L155.013 149.047C155.333 148.887 155.733 148.887 155.972 148.967L159.09 150.806C159.33 150.966 159.33 151.205 159.01 151.365L155.892 153.124C155.653 153.364 155.253 153.364 154.933 153.204Z"
          fill="#24126A"
        />
        <path
          d="M159.812 156.003L156.694 154.164C156.455 154.004 156.455 153.764 156.774 153.604L159.892 151.846C160.212 151.686 160.611 151.686 160.851 151.766L163.969 153.604C164.209 153.764 164.209 154.004 163.889 154.164L160.771 155.923C160.532 156.162 160.052 156.162 159.812 156.003Z"
          fill="#24126A"
        />
        <path
          d="M164.605 158.801L161.487 156.962C161.248 156.803 161.248 156.563 161.567 156.403L164.685 154.644C165.005 154.484 165.404 154.484 165.644 154.564L168.762 156.403C169.002 156.563 169.002 156.803 168.682 156.962L165.564 158.721C165.325 158.961 164.925 158.961 164.605 158.801Z"
          fill="#24126A"
        />
        <path
          d="M169.486 161.599L166.368 159.76C166.128 159.6 166.128 159.36 166.448 159.201L169.566 157.442C169.886 157.282 170.285 157.282 170.525 157.362L173.643 159.201C173.883 159.36 173.883 159.6 173.563 159.76L170.445 161.519C170.205 161.759 169.726 161.759 169.486 161.599Z"
          fill="#24126A"
        />
        <path
          d="M174.283 164.397L171.165 162.558C170.925 162.398 170.925 162.158 171.245 161.998L174.363 160.24C174.682 160.08 175.082 160.08 175.322 160.16L178.44 161.998C178.68 162.158 178.68 162.398 178.36 162.558L175.242 164.317C175.002 164.556 174.603 164.556 174.283 164.397Z"
          fill="#24126A"
        />
        <path
          d="M182.915 169.353L176.12 165.436C175.88 165.276 175.88 165.037 176.2 164.877L179.318 163.118C179.638 162.958 180.037 162.958 180.277 163.038L187.072 166.955C187.312 167.115 187.312 167.355 186.992 167.515L183.874 169.274C183.635 169.513 183.155 169.513 182.915 169.353Z"
          fill="#24126A"
        />
        <path
          d="M192.349 163.917L186.593 160.56C186.353 160.4 186.353 160.16 186.673 160L189.79 158.241C190.11 158.081 190.51 158.081 190.75 158.161L196.505 161.519C196.745 161.679 196.745 161.919 196.426 162.078L193.308 163.837C192.988 164.077 192.588 164.077 192.349 163.917Z"
          fill="#24126A"
        />
        <path
          d="M144.064 141.533L140.946 139.695C140.707 139.535 140.707 139.295 141.026 139.135L144.144 137.376C144.464 137.217 144.863 137.217 145.103 137.297L148.221 139.135C148.461 139.295 148.461 139.535 148.141 139.695L145.023 141.453C144.784 141.613 144.304 141.693 144.064 141.533Z"
          fill="#24126A"
        />
        <path
          d="M139.109 138.655L135.991 136.816C135.751 136.656 135.751 136.417 136.071 136.257L139.189 134.498C139.509 134.338 139.908 134.338 140.148 134.418L143.266 136.257C143.506 136.417 143.506 136.656 143.186 136.816L140.068 138.575C139.828 138.815 139.349 138.815 139.109 138.655Z"
          fill="#24126A"
        />
        <path
          d="M134.152 135.778L131.034 133.94C130.794 133.78 130.794 133.54 131.114 133.38L134.232 131.621C134.552 131.461 134.951 131.461 135.191 131.541L138.309 133.38C138.549 133.54 138.549 133.78 138.229 133.94L135.111 135.698C134.871 135.938 134.392 135.938 134.152 135.778Z"
          fill="#24126A"
        />
        <path
          d="M129.195 132.9L126.077 131.062C125.837 130.902 125.837 130.662 126.157 130.502L129.275 128.744C129.595 128.584 129.994 128.584 130.234 128.664L133.352 130.502C133.592 130.662 133.592 130.902 133.272 131.062L130.154 132.821C129.914 133.06 129.435 133.06 129.195 132.9Z"
          fill="#24126A"
        />
        <path
          d="M148.937 144.332L145.819 142.493C145.58 142.333 145.58 142.094 145.899 141.934L149.017 140.175C149.337 140.015 149.736 140.015 149.976 140.095L153.094 141.934C153.334 142.094 153.334 142.333 153.014 142.493L149.896 144.252C149.577 144.412 149.177 144.492 148.937 144.332Z"
          fill="#24126A"
        />
        <path
          d="M153.736 147.13L150.618 145.291C150.378 145.131 150.378 144.891 150.698 144.731L153.816 142.973C154.136 142.813 154.535 142.813 154.775 142.893L157.893 144.731C158.133 144.891 158.133 145.131 157.813 145.291L154.695 147.05C154.455 147.21 153.976 147.21 153.736 147.13Z"
          fill="#24126A"
        />
        <path
          d="M158.611 149.928L155.493 148.09C155.253 147.93 155.253 147.69 155.573 147.53L158.691 145.771C159.011 145.611 159.41 145.611 159.65 145.691L162.768 147.53C163.008 147.69 163.008 147.93 162.688 148.09L159.57 149.848C159.25 150.008 158.851 150.008 158.611 149.928Z"
          fill="#24126A"
        />
        <path
          d="M163.408 152.725L160.29 150.887C160.05 150.727 160.05 150.487 160.37 150.327L163.488 148.568C163.808 148.408 164.207 148.408 164.447 148.488L167.565 150.327C167.805 150.487 167.805 150.727 167.485 150.887L164.367 152.645C164.127 152.805 163.728 152.805 163.408 152.725Z"
          fill="#24126A"
        />
        <path
          d="M168.287 155.443L165.169 153.604C164.929 153.444 164.929 153.205 165.249 153.045L168.367 151.286C168.686 151.126 169.086 151.126 169.326 151.206L172.444 153.045C172.683 153.205 172.683 153.444 172.364 153.604L169.246 155.363C169.006 155.603 168.527 155.603 168.287 155.443Z"
          fill="#24126A"
        />
        <path
          d="M173.084 158.241L169.966 156.402C169.726 156.242 169.726 156.002 170.046 155.842L173.164 154.084C173.483 153.924 173.883 153.924 174.123 154.004L177.241 155.842C177.48 156.002 177.48 156.242 177.161 156.402L174.043 158.161C173.803 158.401 173.403 158.401 173.084 158.241Z"
          fill="#24126A"
        />
        <path
          d="M177.961 161.038L174.843 159.2C174.603 159.04 174.603 158.8 174.923 158.64L178.04 156.881C178.36 156.722 178.76 156.722 179 156.802L182.117 158.64C182.357 158.8 182.357 159.04 182.038 159.2L178.92 161.038C178.68 161.198 178.2 161.198 177.961 161.038Z"
          fill="#24126A"
        />
        <path
          d="M182.755 163.837L179.638 161.998C179.398 161.838 179.398 161.599 179.718 161.439L182.835 159.68C183.155 159.52 183.555 159.52 183.795 159.6L186.912 161.439C187.152 161.599 187.152 161.838 186.832 161.998L183.715 163.757C183.475 163.997 183.075 163.997 182.755 163.837Z"
          fill="#24126A"
        />
        <path
          d="M187.632 166.635L184.515 164.796C184.275 164.636 184.275 164.396 184.595 164.236L187.712 162.478C188.032 162.318 188.432 162.318 188.672 162.398L191.789 164.236C192.029 164.396 192.029 164.636 191.709 164.796L188.592 166.555C188.352 166.795 187.872 166.795 187.632 166.635Z"
          fill="#24126A"
        />
        <path
          d="M141.505 134.578L138.388 132.74C138.148 132.58 138.148 132.34 138.468 132.18L141.585 130.421C141.905 130.262 142.305 130.262 142.545 130.341L145.662 132.18C145.902 132.34 145.902 132.58 145.582 132.74L142.465 134.498C142.225 134.738 141.825 134.738 141.505 134.578Z"
          fill="#24126A"
        />
        <path
          d="M136.709 131.86L133.591 130.022C133.351 129.862 133.351 129.622 133.671 129.462L136.789 127.703C137.108 127.544 137.508 127.544 137.748 127.624L140.866 129.462C141.105 129.622 141.105 129.862 140.786 130.022L137.668 131.78C137.428 131.94 136.948 131.94 136.709 131.86Z"
          fill="#24126A"
        />
        <path
          d="M131.912 129.063L128.794 127.224C128.554 127.064 128.554 126.824 128.874 126.664L131.992 124.906C132.311 124.746 132.711 124.746 132.951 124.826L136.069 126.664C136.308 126.824 136.308 127.064 135.989 127.224L132.871 128.983C132.631 129.143 132.152 129.223 131.912 129.063Z"
          fill="#24126A"
        />
        <path
          d="M127.117 126.264L123.999 124.426C123.759 124.266 123.759 124.026 124.079 123.866L127.197 122.107C127.516 121.947 127.916 121.947 128.156 122.027L131.274 123.866C131.514 124.026 131.514 124.266 131.194 124.426L128.076 126.184C127.756 126.424 127.357 126.424 127.117 126.264Z"
          fill="#24126A"
        />
        <path
          d="M132.072 123.387L128.954 121.549C128.714 121.389 128.714 121.149 129.034 120.989L130.073 120.429C130.393 120.27 130.793 120.27 131.033 120.35L134.15 122.188C134.39 122.348 134.39 122.588 134.07 122.748L133.031 123.307C132.711 123.547 132.312 123.547 132.072 123.387Z"
          fill="#24126A"
        />
        <path
          d="M138.306 127.065L135.189 125.226C134.949 125.067 134.949 124.827 135.268 124.667L136.308 124.107C136.627 123.947 137.027 123.947 137.267 124.027L140.385 125.866C140.625 126.026 140.625 126.266 140.305 126.426L139.266 126.985C139.026 127.145 138.546 127.225 138.306 127.065Z"
          fill="#24126A"
        />
        <path
          d="M143.103 129.782L139.985 127.943C139.746 127.784 139.746 127.544 140.065 127.384L141.105 126.824C141.424 126.664 141.824 126.664 142.064 126.744L145.182 128.583C145.421 128.743 145.421 128.983 145.102 129.143L144.062 129.702C143.823 129.942 143.343 129.942 143.103 129.782Z"
          fill="#24126A"
        />
        <path
          d="M147.9 132.58L144.782 130.741C144.542 130.581 144.542 130.341 144.862 130.182L145.901 129.622C146.221 129.462 146.621 129.462 146.861 129.542L149.978 131.381C150.218 131.541 150.218 131.78 149.899 131.94L148.859 132.5C148.619 132.74 148.14 132.74 147.9 132.58Z"
          fill="#24126A"
        />
        <path
          d="M152.697 135.378L149.579 133.54C149.339 133.38 149.339 133.14 149.659 132.98L150.698 132.421C151.018 132.261 151.418 132.261 151.658 132.341L154.775 134.179C155.015 134.339 155.015 134.579 154.695 134.739L153.656 135.298C153.416 135.458 152.937 135.458 152.697 135.378Z"
          fill="#24126A"
        />
        <path
          d="M179.478 150.807L176.36 148.968C176.121 148.808 176.121 148.568 176.44 148.408L177.48 147.849C177.799 147.689 178.199 147.689 178.439 147.769L181.557 149.608C181.796 149.767 181.796 150.007 181.477 150.167L180.437 150.727C180.198 150.887 179.718 150.967 179.478 150.807Z"
          fill="#24126A"
        />
        <path
          d="M184.275 153.525L181.157 151.687C180.917 151.527 180.917 151.287 181.237 151.127L182.276 150.568C182.596 150.408 182.996 150.408 183.236 150.488L186.353 152.326C186.593 152.486 186.593 152.726 186.274 152.886L185.234 153.445C184.994 153.685 184.515 153.685 184.275 153.525Z"
          fill="#24126A"
        />
        <path
          d="M189.07 156.322L185.952 154.484C185.712 154.324 185.712 154.084 186.032 153.924L187.071 153.364C187.391 153.204 187.791 153.205 188.031 153.284L191.148 155.123C191.388 155.283 191.388 155.523 191.068 155.683L190.029 156.242C189.789 156.482 189.31 156.482 189.07 156.322Z"
          fill="#24126A"
        />
        <path
          d="M193.869 159.122L190.751 157.283C190.511 157.123 190.511 156.883 190.831 156.723L191.87 156.164C192.19 156.004 192.59 156.004 192.829 156.084L195.947 157.922C196.187 158.082 196.187 158.322 195.867 158.482L194.828 159.042C194.508 159.201 194.109 159.201 193.869 159.122Z"
          fill="#24126A"
        />
        <path
          d="M146.382 137.377L143.265 135.538C143.025 135.378 143.025 135.138 143.345 134.979L146.462 133.22C146.782 133.06 147.182 133.06 147.422 133.14L150.539 134.979C150.779 135.138 150.779 135.378 150.459 135.538L147.342 137.297C147.102 137.537 146.622 137.537 146.382 137.377Z"
          fill="#24126A"
        />
        <path
          d="M151.177 140.175L148.06 138.336C147.82 138.176 147.82 137.936 148.14 137.776L151.257 136.018C151.577 135.858 151.977 135.858 152.217 135.938L155.334 137.776C155.574 137.936 155.574 138.176 155.254 138.336L152.137 140.095C151.897 140.334 151.497 140.334 151.177 140.175Z"
          fill="#24126A"
        />
        <path
          d="M156.054 142.973L152.937 141.134C152.697 140.975 152.697 140.735 153.017 140.575L156.134 138.816C156.454 138.656 156.854 138.656 157.094 138.736L160.211 140.575C160.451 140.735 160.451 140.975 160.131 141.134L157.014 142.893C156.774 143.133 156.294 143.133 156.054 142.973Z"
          fill="#24126A"
        />
        <path
          d="M160.931 145.77L157.814 143.931C157.574 143.771 157.574 143.532 157.893 143.372L161.011 141.613C161.331 141.453 161.731 141.453 161.97 141.533L165.088 143.372C165.328 143.532 165.328 143.771 165.008 143.931L161.891 145.69C161.571 145.93 161.171 145.93 160.931 145.77Z"
          fill="#24126A"
        />
        <path
          d="M165.726 148.569L162.608 146.73C162.369 146.57 162.369 146.33 162.688 146.17L165.806 144.412C166.126 144.252 166.526 144.252 166.765 144.332L169.883 146.17C170.123 146.33 170.123 146.57 169.803 146.73L166.685 148.489C166.446 148.728 165.966 148.728 165.726 148.569Z"
          fill="#24126A"
        />
        <path
          d="M170.601 151.365L167.483 149.527C167.244 149.367 167.244 149.127 167.563 148.967L170.681 147.208C171.001 147.049 171.401 147.049 171.64 147.129L174.758 148.967C174.998 149.127 174.998 149.367 174.678 149.527L171.56 151.285C171.241 151.525 170.841 151.525 170.601 151.365Z"
          fill="#24126A"
        />
        <path
          d="M175.398 154.165L172.28 152.326C172.041 152.166 172.04 151.927 172.36 151.767L175.478 150.008C175.798 149.848 176.197 149.848 176.437 149.928L179.555 151.767C179.795 151.927 179.795 152.166 179.475 152.326L176.357 154.085C176.117 154.325 175.638 154.325 175.398 154.165Z"
          fill="#24126A"
        />
        <path
          d="M180.277 156.962L177.159 155.123C176.919 154.963 176.919 154.723 177.239 154.564L180.357 152.805C180.677 152.645 181.076 152.645 181.316 152.725L184.434 154.564C184.674 154.723 184.674 154.963 184.354 155.123L181.236 156.882C180.916 157.042 180.517 157.122 180.277 156.962Z"
          fill="#24126A"
        />
        <path
          d="M185.074 159.76L181.956 157.922C181.716 157.762 181.716 157.522 182.036 157.362L185.154 155.603C185.474 155.444 185.873 155.444 186.113 155.523L189.231 157.362C189.471 157.522 189.471 157.762 189.151 157.922L186.033 159.68C185.793 159.84 185.314 159.92 185.074 159.76Z"
          fill="#24126A"
        />
        <path
          d="M118.722 137.776L109.528 132.42C109.289 132.26 109.289 132.02 109.608 131.86L112.726 130.102C113.046 129.942 113.445 129.942 113.685 130.022L122.879 135.378C123.118 135.538 123.118 135.777 122.799 135.937L119.681 137.696C119.441 137.856 118.961 137.856 118.722 137.776Z"
          fill="#24126A"
        />
        <path
          d="M178.116 172.072L168.923 166.716C168.683 166.556 168.683 166.316 169.003 166.157L172.121 164.398C172.44 164.238 172.84 164.238 173.08 164.318L182.273 169.674C182.513 169.834 182.513 170.074 182.193 170.234L179.075 171.992C178.836 172.152 178.436 172.232 178.116 172.072Z"
          fill="#24126A"
        />
        <path
          d="M158.773 167.034L155.655 165.196C155.415 165.036 155.416 164.796 155.735 164.636L159.413 162.478C159.732 162.318 160.132 162.318 160.372 162.398L163.49 164.236C163.729 164.396 163.729 164.636 163.41 164.796L159.732 166.954C159.492 167.194 159.093 167.194 158.773 167.034Z"
          fill="#24126A"
        />
        <path
          d="M123.68 146.809L118.644 143.931C118.404 143.771 118.404 143.532 118.724 143.372L122.401 141.213C122.721 141.053 123.12 141.054 123.36 141.133L128.396 144.011C128.636 144.171 128.636 144.411 128.316 144.571L124.639 146.729C124.399 146.889 123.92 146.889 123.68 146.809Z"
          fill="#24126A"
        />
        <path
          d="M154.135 164.398L149.099 161.52C148.859 161.36 148.859 161.12 149.179 160.96L152.856 158.802C153.176 158.642 153.575 158.642 153.815 158.722L158.851 161.6C159.091 161.759 159.091 161.999 158.772 162.159L155.094 164.318C154.854 164.477 154.375 164.477 154.135 164.398Z"
          fill="#24126A"
        />
        <path
          d="M130.631 150.807L125.595 147.929C125.355 147.769 125.355 147.529 125.675 147.369L129.352 145.211C129.672 145.051 130.071 145.051 130.311 145.131L135.348 148.009C135.587 148.169 135.587 148.409 135.268 148.568L131.59 150.727C131.351 150.967 130.871 150.967 130.631 150.807Z"
          fill="#24126A"
        />
        <path
          d="M130.394 145.211L152.138 157.761C152.378 157.921 152.378 158.161 152.138 158.321L148.381 160.479C148.141 160.639 147.662 160.639 147.422 160.479L125.678 147.929L130.394 145.211Z"
          fill="#24126A"
        />
        <path
          d="M172.361 172.15L175.879 174.149C176.119 174.229 176.039 174.469 175.799 174.629L174.28 175.508C174.04 175.668 173.72 175.668 173.481 175.508L169.963 173.509C169.723 173.429 169.803 173.19 170.043 173.03L171.562 172.15C171.722 171.991 172.122 171.991 172.361 172.15Z"
          fill="#24126A"
        />
        <path
          d="M167.488 169.273L171.006 171.272C171.246 171.352 171.166 171.591 170.926 171.751L169.407 172.631C169.167 172.791 168.847 172.791 168.608 172.631L165.09 170.632C164.85 170.552 164.93 170.312 165.17 170.153L166.689 169.273C166.849 169.193 167.249 169.193 167.488 169.273Z"
          fill="#24126A"
        />
        <path
          d="M162.611 166.475L166.129 168.473C166.369 168.553 166.289 168.793 166.049 168.953L164.53 169.832C164.29 169.992 163.97 169.992 163.731 169.832L160.213 167.834C159.973 167.754 160.053 167.514 160.293 167.354L161.812 166.475C162.052 166.395 162.372 166.395 162.611 166.475Z"
          fill="#24126A"
        />
        <path
          d="M170.125 167.755L173.642 169.754C173.882 169.834 173.802 170.074 173.563 170.233L172.044 171.113C171.804 171.273 171.484 171.273 171.244 171.113L167.727 169.114C167.487 169.034 167.567 168.795 167.807 168.635L169.326 167.755C169.565 167.675 169.885 167.675 170.125 167.755Z"
          fill="#24126A"
        />
      </g>
      <path
        d="M219.454 92.5295C219.214 92.5295 218.974 92.4495 218.734 92.2897C218.015 91.8899 217.535 90.9307 217.695 90.1312C217.775 89.7315 218.015 89.4917 218.334 89.3318C218.654 89.172 219.134 89.2519 219.534 89.4917C220.253 89.8914 220.733 90.8507 220.573 91.6501C220.493 92.0498 220.253 92.2896 219.933 92.4495C219.773 92.4495 219.613 92.5295 219.454 92.5295ZM218.734 89.5717C218.654 89.5717 218.494 89.5717 218.414 89.6516C218.175 89.7315 218.015 89.9714 218.015 90.2112C217.855 90.8507 218.254 91.6501 218.894 91.9699C219.214 92.1298 219.534 92.2097 219.773 92.0498C220.013 91.9699 220.173 91.7301 220.173 91.4902C220.333 90.8507 219.933 90.0513 219.294 89.7315C219.134 89.6516 218.974 89.5717 218.734 89.5717Z"
        fill="#42E8E0"
      />
      <path
        d="M223.45 94.7685C223.21 94.7685 222.97 94.6885 222.73 94.5287C222.011 94.129 221.531 93.1697 221.691 92.3703C221.771 91.9706 222.011 91.7307 222.33 91.5709C222.65 91.411 223.13 91.4909 223.53 91.7307C224.249 92.1304 224.729 93.0897 224.569 93.8891C224.489 94.2888 224.249 94.5287 223.929 94.6885C223.769 94.7685 223.61 94.7685 223.45 94.7685ZM222.73 91.8906C222.65 91.8906 222.49 91.8906 222.41 91.9706C222.171 92.0505 222.011 92.2903 222.011 92.5301C221.851 93.1697 222.251 93.9691 222.89 94.2888C223.21 94.4487 223.53 94.5287 223.769 94.3688C224.009 94.2888 224.169 94.049 224.169 93.8092C224.329 93.1697 223.929 92.3703 223.29 92.0505C223.13 91.9705 222.97 91.8906 222.73 91.8906Z"
        fill="#42E8E0"
      />
      <path
        d="M228.33 96.2065C228.17 96.9259 227.45 97.1658 226.811 96.766C226.091 96.3663 225.692 95.487 225.851 94.7675C226.011 94.0481 226.731 93.8082 227.37 94.2079C228.09 94.6076 228.489 95.487 228.33 96.2065Z"
        fill="#42E8E0"
      />
      <path
        d="M151.819 52.1594L149.74 50.9603L149.9 50.001L151.979 51.2001L151.819 52.1594Z"
        fill="#42E8E0"
      />
      <path
        d="M154.94 53.9979L152.861 52.7188L153.021 51.7595L155.1 52.9586L154.94 53.9979Z"
        fill="#42E8E0"
      />
      <path
        d="M148.783 50.4009L144.146 47.6829L144.306 46.7236L148.943 49.4416L148.783 50.4009Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.4"
        d="M119.952 56.1066C125.304 53.0161 125.295 42.979 119.931 33.6881C114.567 24.3973 105.879 19.3709 100.526 22.4614C95.1733 25.5519 95.1826 35.589 100.547 44.8799C105.911 54.1707 114.599 59.1971 119.952 56.1066Z"
        fill="#42E8E0"
      />
      <path
        d="M116.331 57.1968C114.412 57.1968 112.334 56.5572 110.095 55.2782C102.501 50.8814 96.2656 40.1693 96.2656 31.2959C96.2656 26.9791 97.7046 23.7815 100.343 22.2626C102.981 20.7437 106.498 21.0635 110.255 23.2219C117.85 27.6186 124.085 38.3307 124.085 47.2042C124.085 51.521 122.646 54.7186 120.008 56.2375C118.969 56.957 117.69 57.1968 116.331 57.1968ZM104.1 21.703C102.821 21.703 101.622 22.0228 100.582 22.5823C98.0243 24.0213 96.6653 27.139 96.6653 31.3758C96.6653 40.0894 102.821 50.7216 110.335 55.0384C113.933 57.1168 117.37 57.4366 119.848 55.9977C122.406 54.5587 123.765 51.441 123.765 47.2042C123.765 38.4906 117.61 27.8584 110.095 23.5416C108.017 22.3425 105.938 21.703 104.1 21.703Z"
        fill="#42E8E0"
      />
      <path
        d="M108.737 61.5132C106.818 61.5132 104.74 60.8737 102.502 59.5946C94.9073 55.1978 88.6719 44.4858 88.6719 35.6123C88.6719 31.2955 90.1108 28.0979 92.7489 26.579C95.3869 25.0601 98.9043 25.3799 102.662 27.5383C110.256 31.935 116.491 42.6471 116.491 51.5206C116.491 55.8374 115.052 59.035 112.414 60.5539C111.295 61.2734 110.016 61.5132 108.737 61.5132ZM96.4261 26.0194C95.1471 26.0194 93.948 26.3392 92.9087 26.8987C90.3506 28.3377 88.9916 31.4554 88.9916 35.6123C88.9916 44.3259 95.1471 54.958 102.662 59.2748C106.259 61.3533 109.696 61.6731 112.175 60.2341C114.733 58.7952 116.092 55.6775 116.092 51.4406C116.092 42.7271 109.936 32.0949 102.422 27.7781C100.343 26.6589 98.2648 26.0194 96.4261 26.0194Z"
        fill="#42E8E0"
      />
      <path
        d="M85.7106 95.4067V91.4096L90.4272 67.6672L85.7906 64.7893L76.4375 69.9855V100.603C76.4375 102.681 77.2369 104.04 78.3561 104.52L82.513 107.158L82.9927 105.159L83.7121 101.562C84.9112 99.8034 85.7106 97.4852 85.7106 95.4067Z"
        fill="url(#paint27_linear_656_10249)"
      />
      <path
        d="M85.7127 106.998C83.1546 108.437 81.0762 106.838 81.0762 103.481V72.8632L90.4293 67.667V98.2844C90.3493 101.722 88.2708 105.559 85.7127 106.998Z"
        fill="url(#paint28_linear_656_10249)"
      />
      <path
        d="M79.0768 86.2146L78.9169 86.1347C78.5971 85.9748 78.3573 85.9748 78.1974 86.1347L77.1582 86.7742L77.8777 86.9341C77.8777 87.014 77.8777 87.014 77.8777 87.094V93.0096C77.8777 93.809 78.3573 94.7683 78.9968 95.0881L78.757 95.8875L79.7963 95.2479C80.0361 95.168 80.196 94.7683 80.196 94.2887V88.373C80.196 87.4937 79.7163 86.5344 79.0768 86.2146Z"
        fill="url(#paint29_linear_656_10249)"
      />
      <path
        opacity="0.3"
        d="M79.0768 86.2146L78.9169 86.1347C78.5971 85.9748 78.3573 85.9748 78.1974 86.1347L77.1582 86.7742L77.8777 86.9341C77.8777 87.014 77.8777 87.014 77.8777 87.094V93.0096C77.8777 93.809 78.3573 94.7683 78.9968 95.0881L78.757 95.8875L79.7963 95.2479C80.0361 95.168 80.196 94.7683 80.196 94.2887V88.373C80.196 87.4937 79.7163 86.5344 79.0768 86.2146Z"
        fill="#0F054C"
      />
      <path
        d="M78.0369 95.6467L77.877 95.5667C77.2375 95.247 76.7578 94.2877 76.7578 93.4883V87.5726C76.7578 86.7732 77.2375 86.3735 77.877 86.6933L78.0369 86.7732C78.6764 87.093 79.156 88.0523 79.156 88.8517V94.7673C79.0761 95.6467 78.5965 96.0464 78.0369 95.6467Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M85.7141 106.998C88.2722 105.56 90.3507 101.642 90.3507 98.2849V72.7038V69.1864L85.874 70.1457L81.5572 72.5439L80.5979 71.4248L76.6009 72.9436L76.2012 81.0177V81.1775C76.2012 83.6557 78.0398 85.7342 80.438 86.1339L80.9177 86.2138V103.481C81.0776 106.839 83.156 108.437 85.7141 106.998Z"
        fill="#0F054C"
      />
      <path
        d="M106.739 55.1173C106.978 47.443 101.782 37.93 95.227 33.933C91.7096 31.7746 88.512 31.6147 86.2737 33.1336L64.7695 44.8049L80.6778 74.9427L102.821 62.9515C102.901 62.8716 102.981 62.8716 103.061 62.7917L103.141 62.7117C105.3 61.4327 106.659 58.7946 106.739 55.1173Z"
        fill="url(#paint30_radial_656_10249)"
      />
      <path
        opacity="0.3"
        d="M106.739 55.1172C106.899 50.5606 105.14 45.3644 102.262 41.0476C99.0646 42.8862 92.5893 46.4836 80.4383 53.4385C77.4006 55.1972 74.5227 56.716 71.8047 57.9951L80.7581 74.8626L102.902 62.8715C102.982 62.7915 103.062 62.7915 103.142 62.7116L103.221 62.6317C105.3 61.4326 106.659 58.7945 106.739 55.1172Z"
        fill="#0F054C"
      />
      <path
        d="M84.6739 67.0284C84.434 74.7027 78.998 77.6605 72.4429 73.6635C65.8877 69.6664 60.7715 60.1534 60.9314 52.4791C61.1712 44.8048 66.6072 41.847 73.1624 45.844C79.7175 49.8411 84.8337 59.354 84.6739 67.0284Z"
        fill="url(#paint31_radial_656_10249)"
      />
      <path
        d="M84.8348 67.5083C85.0746 59.5142 79.7185 49.6815 72.9235 45.4446C69.8058 43.526 66.928 43.1263 64.7696 44.0056H64.6896C64.6896 44.0056 64.6896 44.0056 64.6097 44.0056C64.5298 44.0856 64.4498 44.0856 64.2899 44.1655C51.0197 50.241 39.1085 49.6015 24.5593 48.6422L20.4023 48.4024L52.4587 106.919L54.3772 103.482C61.3321 90.8511 68.6867 83.4165 80.8377 75.5823C83.2359 74.3832 84.7548 71.5853 84.8348 67.5083Z"
        fill="url(#paint32_linear_656_10249)"
      />
      <path
        opacity="0.3"
        d="M54.3763 103.481C61.3312 90.8508 68.6858 83.4163 80.8368 75.5821C83.1551 74.383 84.6739 71.5851 84.7539 67.5081C84.9138 62.9514 83.1551 57.7553 80.4371 53.3585C80.4371 53.3585 80.4371 53.3585 80.3571 53.3585C60.292 64.7901 48.2209 66.6287 48.2209 66.6287L42.625 84.3756L44.3038 92.2098L52.3778 106.919L54.3763 103.481Z"
        fill="#0F054C"
      />
      <path
        d="M56.776 94.0484C57.1757 78.6997 46.9432 59.7537 33.9128 51.7597C27.3577 47.7626 21.442 47.203 16.9654 49.6012L12.9683 51.8396L14.3273 51.5998C11.4494 54.4776 9.69074 59.0343 9.53085 65.0298C9.13115 80.3785 19.3636 99.3245 32.394 107.319C37.5102 110.436 42.3066 111.476 46.3037 110.596L45.6642 111.476L49.3414 109.477C49.3414 109.477 49.3414 109.477 49.4214 109.477L49.5813 109.397C53.8181 106.919 56.5361 101.643 56.776 94.0484Z"
        fill="url(#paint33_linear_656_10249)"
      />
      <path
        d="M53.896 95.6481C54.2957 80.2994 44.0633 61.3534 31.0329 53.3593C24.6376 49.4422 18.722 48.8027 14.3252 51.121L13.6857 51.4407C13.4459 51.6006 13.286 51.6806 13.0462 51.8404L14.2453 51.6006C11.3674 54.4785 9.6087 59.0351 9.44882 65.0307C9.04912 80.3794 19.2816 99.3254 32.3119 107.319C37.4282 110.437 42.2246 111.476 46.2217 110.597L45.6621 111.396C50.5385 109.238 53.6562 103.722 53.896 95.6481Z"
        fill="white"
      />
      <path
        d="M53.0971 96.0473C52.6974 111.396 41.7455 117.312 28.7151 109.238C15.6848 101.243 5.37237 82.2975 5.85202 66.9488C6.25172 51.6002 17.2036 45.6845 30.234 53.7586C43.2644 61.8326 53.4968 80.7786 53.0971 96.0473Z"
        fill="url(#paint34_linear_656_10249)"
      />
      <path
        d="M50.2209 94.2881C49.8212 107.718 40.2283 112.914 28.7967 105.879C17.3651 98.8447 8.33182 82.217 8.73152 68.7869C9.13123 55.3568 18.7241 50.1606 30.1557 57.1954C41.5872 64.2303 50.5406 80.858 50.2209 94.2881Z"
        fill="url(#paint35_radial_656_10249)"
      />
      <path
        opacity="0.3"
        d="M32.4735 104.12C30.7148 103.081 29.116 101.802 27.5171 100.363C24.2396 97.3254 23.9997 92.2092 26.9575 88.8517C30.5549 84.9346 36.2307 79.6585 45.0242 73.9827C41.3469 67.0278 36.1508 60.7924 30.1552 57.1151C25.1189 53.9974 20.4024 53.278 16.7251 54.557C16.5652 54.6369 16.4853 54.6369 16.3254 54.7169H16.2455C16.0856 54.7968 16.0056 54.7968 15.8458 54.8768H15.7658C15.6059 54.9567 15.526 55.0367 15.3661 55.0367C15.0463 55.1965 14.8065 55.3564 14.5667 55.5163C14.4068 55.5962 14.3269 55.6762 14.2469 55.7561C14.2469 55.7561 14.167 55.7561 14.167 55.8361C14.0871 55.916 13.9272 55.9959 13.8472 56.0759L13.7673 56.1558C13.6874 56.2358 13.5275 56.3157 13.4475 56.3956C13.4475 56.3956 13.4475 56.3956 13.3676 56.4756C13.1278 56.7154 12.8879 56.9552 12.6481 57.1951C12.5682 57.275 12.4882 57.4349 12.3284 57.5148L12.2484 57.5948C12.1685 57.6747 12.0885 57.7546 12.0086 57.9145L11.9287 57.9945C11.8487 58.0744 11.7688 58.2343 11.6888 58.3142L11.6089 58.3942C11.5289 58.5541 11.449 58.634 11.3691 58.7939C11.2891 58.9538 11.2092 59.1136 11.1293 59.2735C11.1293 59.2735 11.1293 59.2735 11.1293 59.3535C11.0493 59.5133 10.9694 59.5933 10.8894 59.7532C10.8894 59.8331 10.8095 59.8331 10.8095 59.913C10.7295 59.993 10.7295 60.1529 10.6496 60.2328C10.6496 60.3128 10.5697 60.3128 10.5697 60.3927C10.4897 60.4726 10.4897 60.6325 10.4098 60.7125C10.4098 60.7924 10.3298 60.7924 10.3298 60.8723C10.2499 61.0322 10.2499 61.1122 10.1699 61.272V61.352C10.09 61.5119 10.0101 61.6718 10.0101 61.9116V61.9915C9.93013 62.1514 9.93013 62.3113 9.85019 62.4712C9.85019 62.5511 9.85019 62.5511 9.77024 62.631C9.77024 62.7909 9.69031 62.8709 9.69031 63.0307C9.69031 63.1107 9.69031 63.1906 9.61037 63.2706C9.61037 63.4305 9.53043 63.5104 9.53043 63.6703C9.53043 63.7502 9.53043 63.8302 9.45049 63.9101C9.45049 64.07 9.37054 64.2299 9.37054 64.3098C9.37054 64.3897 9.37054 64.3897 9.37054 64.4697C9.2906 64.7095 9.29061 64.8694 9.29061 65.1092V65.1892C9.29061 65.349 9.21066 65.5889 9.21066 65.7487C9.21066 65.8287 9.21066 65.9086 9.21066 65.9886C9.21066 66.1484 9.21067 66.3083 9.13073 66.3883C9.13073 66.4682 9.13073 66.5482 9.13073 66.6281C9.13073 66.788 9.13072 66.9479 9.05078 67.0278C9.05078 67.1077 9.05078 67.1877 9.05078 67.2676C9.05078 67.4275 9.05078 67.5874 9.05078 67.7473C9.05078 67.8272 9.05078 67.9071 9.05078 67.9871C9.05078 68.2269 9.05078 68.4667 9.05078 68.7066C9.05078 69.1063 9.05078 69.506 9.05078 69.8257C9.05078 69.9856 9.05078 70.0656 9.05078 70.2254C9.05078 70.4653 9.05078 70.7051 9.05078 71.0248C9.05078 71.1847 9.05078 71.2647 9.05078 71.4245C9.05078 71.7443 9.13073 71.9841 9.13073 72.3039C9.13073 72.3838 9.13073 72.4638 9.13073 72.6237C9.13073 73.0234 9.21067 73.3431 9.29061 73.7428C9.29061 73.9027 9.37054 74.0626 9.37054 74.2225C9.37054 74.4623 9.45049 74.7021 9.45049 74.942C9.45049 75.1018 9.53043 75.3417 9.53043 75.5015C9.53043 75.7414 9.61037 75.9012 9.61037 76.1411C9.61037 76.301 9.69031 76.5408 9.69031 76.7007C9.77025 77.0204 9.8502 77.3402 9.93014 77.58C10.0101 77.8198 10.09 78.1396 10.1699 78.3794C10.1699 78.5393 10.2499 78.6992 10.2499 78.8591C10.3298 79.0989 10.4098 79.3387 10.4897 79.5785C10.4897 79.7384 10.5697 79.8184 10.5697 79.9782C10.8095 80.8576 11.1292 81.8169 11.449 82.6962C11.449 82.7762 11.449 82.7762 11.529 82.8561C11.6089 83.1759 11.7688 83.4157 11.8487 83.7355C11.8487 83.8154 11.9287 83.8953 11.9287 83.9753C15.4461 92.9287 21.7614 101.322 29.036 105.879C35.4313 109.796 41.187 109.956 45.1841 106.918C41.4269 107.798 37.1101 106.998 32.4735 104.12Z"
        fill="#0F054C"
      />
      <mask
        id="mask2_656_10249"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="54"
        width="43"
        height="55"
      >
        <path
          d="M43.6106 107.725C51.9581 103.206 52.3705 87.8036 44.5318 73.3217C36.693 58.8397 23.5714 50.7626 15.2239 55.2809C6.87637 59.7992 6.46396 75.202 14.3027 89.684C22.1415 104.166 35.2631 112.243 43.6106 107.725Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_656_10249)">
        <path
          d="M26.4004 76.3801L57.6573 53.5969L65.6514 76.46L31.9163 86.9323L26.4004 76.3801Z"
          fill="url(#paint36_linear_656_10249)"
        />
        <path
          d="M33.5938 84.0544C33.5139 86.7724 31.5953 87.8116 29.277 86.3727C26.9587 84.9337 25.2 81.6562 25.28 78.9382C25.3599 76.2202 27.2785 75.1809 29.5968 76.6199C31.9151 78.0588 33.6738 81.4163 33.5938 84.0544Z"
          fill="url(#paint37_radial_656_10249)"
        />
        <g opacity="0.3">
          <path
            d="M36.6323 71.5047C39.5901 73.3434 41.9884 77.6602 41.9084 81.1776C41.9084 82.4566 41.5087 83.4959 40.8692 84.1354L66.2904 76.8608L58.0565 53.1982L34.0742 70.7053C34.8736 70.7053 35.753 71.0251 36.6323 71.5047Z"
            fill="#0F054C"
          />
        </g>
      </g>
      <path
        d="M219.299 137.778L211.944 133.701C210.265 132.741 208.826 130.743 208.347 128.664L201.951 102.364C201.232 99.2461 198.674 97.0078 196.915 96.9278H196.835C195.956 96.9278 195.396 97.4075 195.076 98.3668L193.158 104.282C192.918 104.922 192.518 105.402 191.959 105.641C191.239 105.881 190.44 105.801 189.56 105.242L188.201 104.442C186.683 103.563 185.244 101.644 184.764 99.6458C183.885 96.6081 181.566 94.6096 179.888 94.4497C179.808 94.4497 179.728 94.4497 179.728 94.4497C179.008 94.4497 178.449 94.8494 178.049 95.5689L175.971 100.046C175.731 100.605 175.331 100.925 174.771 101.085C174.132 101.325 173.332 101.165 172.453 100.685L170.934 99.8057C169.255 98.8464 167.817 96.768 167.337 94.6895L160.942 66.3105C160.222 63.1928 157.744 60.8745 155.905 60.7945C155.026 60.7146 154.386 61.1942 153.987 62.0736L143.674 90.2927C143.435 90.9323 143.035 91.332 142.475 91.5718C141.836 91.8116 140.956 91.6517 140.077 91.1721L134.881 88.1343L134.961 88.0544L140.157 91.0922C140.956 91.5718 141.756 91.7317 142.395 91.4919C142.875 91.332 143.275 90.9323 143.514 90.2927L153.827 62.0736C154.147 61.1942 154.786 60.6346 155.666 60.6346C155.745 60.6346 155.745 60.6346 155.825 60.6346C157.664 60.7945 160.222 63.1128 160.942 66.3105L167.337 94.6895C167.817 96.768 169.255 98.8464 170.854 99.7258L172.373 100.605C173.173 101.085 173.972 101.245 174.612 101.005C175.091 100.845 175.491 100.525 175.731 99.9656L177.809 95.4889C178.209 94.6895 178.928 94.2098 179.808 94.2898C181.566 94.4497 183.965 96.5281 184.764 99.5659C185.324 101.484 186.683 103.403 188.201 104.282L189.56 105.082C190.44 105.561 191.239 105.721 191.879 105.482C192.438 105.242 192.758 104.842 192.998 104.202L194.917 98.2868C195.236 97.2476 195.956 96.768 196.915 96.768C198.754 96.8479 201.312 99.0862 202.111 102.284L208.506 128.584C208.986 130.663 210.425 132.661 212.024 133.541L219.378 137.618L219.299 137.778Z"
        fill="#42E8E0"
      />
      <path
        d="M213.779 140.976L206.424 136.899C204.746 135.94 203.307 133.941 202.827 131.863L196.432 105.562C195.712 102.444 193.154 100.206 191.396 100.126C190.516 100.126 189.877 100.606 189.557 101.565L187.638 107.481C187.398 108.12 186.999 108.6 186.439 108.84C185.72 109.079 184.92 109 184.041 108.44L182.682 107.641C181.163 106.761 179.724 104.843 179.244 102.844C178.365 99.8063 176.047 97.8078 174.368 97.6479C173.489 97.568 172.849 97.9677 172.529 98.7671L170.451 103.244C170.211 103.803 169.811 104.123 169.252 104.283C168.612 104.523 167.813 104.363 166.934 103.883L165.415 103.004C163.736 102.045 162.297 99.9662 161.817 97.8877L155.422 69.5087C154.703 66.391 152.224 64.0727 150.386 63.9928C149.506 63.9128 148.867 64.3925 148.467 65.2718L138.155 93.491C137.915 94.1305 137.515 94.5302 136.956 94.77C136.316 95.0099 135.437 94.85 134.557 94.3703L129.361 91.3326L129.441 91.2526L134.637 94.2904C135.437 94.77 136.236 94.9299 136.876 94.6901C137.355 94.5302 137.755 94.1305 137.995 93.491L148.307 65.2718C148.627 64.3125 149.347 63.8329 150.306 63.8329C152.145 63.9928 154.703 66.3111 155.422 69.5087L161.817 97.8877C162.297 99.9662 163.736 102.045 165.335 102.924L166.854 103.803C167.653 104.283 168.452 104.443 169.092 104.203C169.572 104.043 169.971 103.723 170.211 103.164L172.29 98.6871C172.689 97.8877 173.409 97.4081 174.288 97.488C176.047 97.6479 178.445 99.7264 179.244 102.764C179.804 104.683 181.163 106.601 182.682 107.481L184.041 108.28C184.92 108.76 185.72 108.92 186.359 108.68C186.919 108.44 187.239 108.04 187.478 107.401L189.397 101.485C189.717 100.526 190.356 99.9662 191.316 99.9662H191.396C193.234 100.046 195.792 102.284 196.592 105.482L202.987 131.783C203.467 133.861 204.906 135.86 206.504 136.739L213.859 140.816L213.779 140.976Z"
        fill="#42E8E0"
      />
      <path
        d="M154.893 60.7187L149.277 63.9414L149.436 64.2187L155.052 60.996L154.893 60.7187Z"
        fill="#42E8E0"
      />
      <path
        d="M178.634 94.5185L172.953 97.7882L173.113 98.0653L178.794 94.7956L178.634 94.5185Z"
        fill="#42E8E0"
      />
      <path
        d="M196.131 96.824L190.168 100.245L190.327 100.522L196.29 97.1014L196.131 96.824Z"
        fill="#42E8E0"
      />
      <path
        d="M219.299 137.857L211.944 133.78C210.265 132.821 208.826 130.822 208.267 128.664L201.871 102.363C201.152 99.3256 198.674 97.0873 196.915 97.0073C196.036 97.0073 195.476 97.407 195.156 98.3663L193.318 104.282C193.078 105.001 192.678 105.481 192.039 105.721C191.319 105.961 190.44 105.881 189.56 105.321L188.201 104.522C186.603 103.642 185.244 101.724 184.684 99.7253C183.885 96.7675 181.566 94.769 179.888 94.6091C179.088 94.5292 178.449 94.9289 178.129 95.6483L176.05 100.125C175.811 100.685 175.331 101.084 174.771 101.244C174.052 101.484 173.253 101.324 172.373 100.844L170.854 99.9651C169.176 99.0059 167.737 96.9274 167.257 94.769L160.862 66.3899C160.142 63.2722 157.744 61.0339 155.905 60.954C155.026 60.874 154.466 61.3537 154.147 62.233L143.834 90.4522C143.594 91.0917 143.195 91.5713 142.555 91.8112C141.836 92.051 140.956 91.8911 140.077 91.4115L134.881 88.3737L135.041 88.0539L140.237 91.0917C141.036 91.5713 141.836 91.6513 142.395 91.4914C142.875 91.3315 143.275 90.9318 143.435 90.3722L153.747 62.1531C154.147 61.1138 154.866 60.6342 155.905 60.7141C157.824 60.874 160.382 63.1923 161.102 66.4699L167.497 94.8489C167.976 96.8474 169.335 98.9259 170.934 99.8053L172.453 100.685C173.253 101.164 173.972 101.244 174.612 101.084C175.091 100.924 175.411 100.605 175.651 100.125L177.729 95.6483C178.129 94.769 178.848 94.3693 179.808 94.4492C181.566 94.6091 184.045 96.6876 184.844 99.8053C185.404 101.724 186.763 103.562 188.201 104.442L189.56 105.241C190.36 105.721 191.159 105.881 191.799 105.641C192.278 105.481 192.678 105.001 192.838 104.442L194.757 98.5262C195.076 97.487 195.876 96.9274 196.835 96.9274C198.754 97.0073 201.312 99.2457 202.111 102.523L208.506 128.824C208.986 130.822 210.425 132.821 212.024 133.7L219.378 137.777L219.299 137.857Z"
        fill="#42E8E0"
      />
      <path
        d="M213.701 141.135L206.346 137.058C204.668 136.099 203.229 134.101 202.669 131.942L196.274 105.642C195.554 102.604 193.076 100.365 191.317 100.286C190.438 100.286 189.878 100.685 189.559 101.644L187.72 107.48C187.48 108.2 187.081 108.679 186.441 108.919C185.722 109.159 184.842 109.079 183.963 108.519L182.604 107.72C181.005 106.841 179.646 104.922 179.086 102.924C178.287 99.9657 175.969 97.9672 174.29 97.8073C173.491 97.7274 172.851 98.1271 172.531 98.8466L170.453 103.323C170.213 103.883 169.733 104.283 169.174 104.442C168.454 104.682 167.655 104.522 166.776 104.043L165.257 103.163C163.578 102.204 162.139 100.126 161.659 97.9672L155.264 69.5882C154.545 66.4705 152.146 64.2321 150.308 64.1522C149.428 64.0723 148.869 64.5519 148.549 65.4313L138.237 93.6504C137.997 94.2899 137.597 94.7696 136.958 95.0094C136.238 95.2492 135.359 95.0893 134.479 94.6097L129.283 91.5719L129.443 91.2522L134.639 94.2899C135.439 94.7696 136.238 94.8495 136.798 94.6896C137.277 94.5298 137.677 94.1301 137.837 93.5705L148.149 65.3513C148.549 64.3121 149.268 63.8324 150.308 63.9124C152.226 64.0723 154.784 66.3905 155.504 69.6681L161.899 98.0472C162.379 100.046 163.738 102.124 165.337 103.003L166.855 103.883C167.655 104.362 168.374 104.442 169.014 104.283C169.494 104.123 169.813 103.803 170.053 103.323L172.132 98.8466C172.531 97.9672 173.251 97.5675 174.21 97.6475C175.969 97.8073 178.447 99.8858 179.246 103.003C179.806 104.922 181.165 106.761 182.604 107.64L183.963 108.439C184.762 108.919 185.562 109.079 186.201 108.839C186.681 108.679 187.081 108.2 187.24 107.64L189.159 101.724C189.479 100.685 190.198 100.126 191.158 100.126H191.237C193.156 100.206 195.714 102.444 196.514 105.721L202.909 132.022C203.388 134.021 204.827 136.019 206.426 136.898L213.781 140.975L213.701 141.135Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M135.037 88.0534L140.233 91.0911C141.832 91.9705 143.191 91.6507 143.751 90.2118L154.063 61.9926C155.262 58.795 160.059 61.6728 161.098 66.2295L167.493 94.6085C167.973 96.687 169.412 98.7655 171.011 99.7247L172.529 100.604C173.968 101.483 175.327 101.244 175.887 99.9646L177.965 95.4879C179.244 92.6899 183.641 95.328 184.84 99.5649C185.4 101.563 186.759 103.402 188.278 104.281L189.637 105.081C191.236 106.04 192.675 105.64 193.154 104.122L195.073 98.2059C196.192 94.8483 200.988 97.6463 202.108 102.203L208.503 128.503C208.982 130.582 210.421 132.58 212.1 133.54L219.455 137.617L135.037 88.0534Z"
        fill="url(#paint38_linear_656_10249)"
      />
      <path
        opacity="0.5"
        d="M129.443 91.1717L134.64 94.2094C136.238 95.0888 137.597 94.769 138.157 93.3301L148.469 65.1109C149.668 61.9133 154.465 64.7911 155.504 69.3478L161.899 97.7268C162.379 99.8053 163.818 101.884 165.417 102.843L166.936 103.722C168.375 104.602 169.734 104.362 170.293 103.083L172.372 98.6062C173.651 95.8082 178.047 98.4463 179.247 102.683C179.806 104.682 181.165 106.52 182.684 107.4L184.043 108.199C185.642 109.158 187.081 108.759 187.56 107.24L189.479 101.324C190.598 97.9666 195.395 100.765 196.514 105.321L202.909 131.622C203.389 133.7 204.828 135.699 206.506 136.658L213.861 140.735L129.443 91.1717Z"
        fill="url(#paint39_linear_656_10249)"
      />
      <path
        opacity="0.4"
        d="M43.6476 107.798C52.034 103.259 52.4608 87.8072 44.6011 73.2864C36.7413 58.7656 23.5712 50.6741 15.1848 55.2134C6.79848 59.7527 6.37162 75.204 14.2314 89.7248C22.0912 104.246 35.2613 112.337 43.6476 107.798Z"
        fill="#42E8E0"
      />
      <path
        d="M244.075 71.9866C235.681 71.9866 227.367 70.148 220.972 66.4707C214.736 62.8734 211.299 58.0769 211.299 52.9607C211.299 47.8445 214.736 43.048 220.972 39.4507C233.762 32.0162 254.547 32.0162 267.337 39.3707C273.573 42.9681 277.01 47.7645 277.01 52.8807C277.01 57.997 273.573 62.7934 267.337 66.3908C260.942 70.068 252.468 71.9866 244.075 71.9866ZM244.155 34.2545C235.761 34.2545 227.367 36.0931 221.052 39.7704C214.976 43.2878 211.539 48.0043 211.619 52.9607C211.619 57.917 214.976 62.6335 221.132 66.1509C233.842 73.4256 254.547 73.4256 267.178 66.071C273.253 62.5536 276.691 57.8371 276.611 52.8807C276.611 47.9244 273.253 43.2079 267.098 39.6905C260.782 36.0132 252.468 34.2545 244.155 34.2545Z"
        fill="#42E8E0"
      />
      <path
        d="M203.226 15.3068C204.745 14.4275 205.944 15.1469 205.944 16.9056C205.944 18.6643 204.745 20.7428 203.226 21.6222C201.707 22.5015 200.508 21.782 200.508 20.0233C200.508 18.2646 201.707 16.1862 203.226 15.3068Z"
        fill="url(#paint40_linear_656_10249)"
      />
      <path
        d="M203.386 15.3877C201.867 16.2671 200.668 18.3455 200.668 20.1042C200.668 20.9036 200.908 21.5432 201.387 21.783C200.828 21.5432 200.508 20.9036 200.508 19.9443C200.508 18.1856 201.707 16.1072 203.226 15.2278C204.025 14.7482 204.745 14.7482 205.224 15.0679C204.745 14.9081 204.105 14.988 203.386 15.3877Z"
        fill="white"
      />
      <path
        d="M196.749 11.5499C198.268 10.6705 199.467 11.39 199.467 13.1487C199.467 14.9074 198.268 16.9858 196.749 17.8652C195.23 18.7445 194.031 18.0251 194.031 16.2664C194.031 14.5077 195.23 12.4292 196.749 11.5499Z"
        fill="url(#paint41_linear_656_10249)"
      />
      <path
        d="M190.116 7.71222C191.635 6.83286 192.834 7.55233 192.834 9.31103C192.834 11.0697 191.635 13.1482 190.116 14.0275C188.598 14.9069 187.398 14.1874 187.398 12.4287C187.398 10.75 188.598 8.59157 190.116 7.71222Z"
        fill="url(#paint42_linear_656_10249)"
      />
      <path
        d="M201.307 21.7824L204.664 23.701C204.185 23.3812 203.865 22.8216 203.865 21.9423C203.865 20.1836 205.064 18.1051 206.583 17.2258C207.302 16.8261 207.942 16.7461 208.501 16.986L222.811 25.2199L218.974 31.9349L176.765 7.7128C174.926 6.67357 174.287 4.27534 175.326 2.4367C176.365 0.598057 178.763 -0.041472 180.602 0.99776L192.034 7.55292C191.554 7.23316 190.834 7.23316 190.035 7.7128C188.516 8.59215 187.317 10.6706 187.317 12.4293C187.317 13.3087 187.637 13.9482 188.116 14.188L191.474 16.1066C190.994 15.7868 190.675 15.2273 190.675 14.3479C190.675 12.5892 191.874 10.5107 193.393 9.63138C194.112 9.23168 194.752 9.15174 195.311 9.39156L198.669 11.3101C198.189 10.9904 197.47 10.9904 196.67 11.47C195.151 12.3494 193.952 14.4278 193.952 16.1865C193.952 17.0659 194.272 17.7054 194.752 17.9452L198.109 19.8638C197.629 19.5441 197.31 18.9845 197.31 18.1051C197.31 16.3464 198.509 14.268 200.028 13.3886C200.747 12.9889 201.387 12.909 201.946 13.1488L205.144 14.9874C204.664 14.6677 203.945 14.6677 203.145 15.1473C201.626 16.0267 200.427 18.1051 200.427 19.8638C200.507 20.9031 200.827 21.5426 201.307 21.7824Z"
        fill="#BCBEFF"
      />
      <path
        d="M196.909 11.6308C195.39 12.5101 194.191 14.5886 194.191 16.3473C194.191 17.1467 194.431 17.7862 194.911 18.026C194.351 17.7862 194.031 17.1467 194.031 16.1874C194.031 14.4287 195.23 12.3502 196.749 11.4709C197.549 10.9912 198.268 10.9912 198.748 11.311C198.268 11.1511 197.629 11.231 196.909 11.6308Z"
        fill="white"
      />
      <path
        d="M190.276 7.79225C188.757 8.6716 187.558 10.7501 187.558 12.5088C187.558 13.3082 187.798 13.9477 188.278 14.1875C187.718 13.9477 187.398 13.3082 187.398 12.3489C187.398 10.5902 188.598 8.51172 190.116 7.63237C190.916 7.15272 191.635 7.15273 192.115 7.47249C191.635 7.39255 190.996 7.39255 190.276 7.79225Z"
        fill="white"
      />
      <path
        opacity="0.48"
        d="M206.583 17.2264C205.064 18.1057 203.865 20.1842 203.865 21.9429C203.865 22.8222 204.185 23.4618 204.665 23.7016L201.307 21.783C200.828 21.4632 200.508 20.9037 200.508 20.0243C200.508 18.2656 201.707 16.1871 203.226 15.3078C204.025 14.8281 204.665 14.8281 205.224 15.1479L208.502 17.0665C208.022 16.7467 207.383 16.8267 206.583 17.2264Z"
        fill="url(#paint43_linear_656_10249)"
      />
      <path
        opacity="0.48"
        d="M200.107 13.4686C198.588 14.3479 197.389 16.4264 197.389 18.1851C197.389 19.0644 197.709 19.704 198.188 19.9438L194.831 18.0252C194.351 17.7054 194.031 17.1458 194.031 16.2665C194.031 14.5078 195.23 12.4293 196.749 11.55C197.549 11.0703 198.188 11.0703 198.748 11.3901L202.025 13.3087C201.466 12.9889 200.826 13.0689 200.107 13.4686Z"
        fill="url(#paint44_linear_656_10249)"
      />
      <path
        opacity="0.48"
        d="M193.474 9.71001C191.955 10.5894 190.756 12.6678 190.756 14.4265C190.756 15.3059 191.076 15.9454 191.555 16.1852L188.198 14.2666C187.718 13.9469 187.398 13.3873 187.398 12.5079C187.398 10.7492 188.598 8.67078 190.116 7.79143C190.916 7.31178 191.555 7.31178 192.115 7.63155L195.393 9.55013C194.913 9.23037 194.193 9.23037 193.474 9.71001Z"
        fill="url(#paint45_linear_656_10249)"
      />
      <path
        d="M219.135 43.6868C219.135 43.9266 219.135 44.0865 219.135 44.3263L227.449 51.2812L240.959 56.3175L250.472 54.1591L259.586 51.521L268.859 44.4063L269.099 44.2464C269.099 43.6868 269.099 43.1272 269.019 42.5676C270.617 40.4092 272.296 38.2508 273.895 36.0125C274.614 36.9717 275.254 37.931 275.734 38.8903L276.853 38.011V43.6068C276.853 43.6868 276.853 43.7667 276.853 43.7667V44.0065C276.693 48.7231 273.575 53.4396 267.34 57.0369C254.549 64.4714 233.924 64.4714 221.134 57.1169C214.819 53.4396 211.621 48.7231 211.541 43.9266C211.541 43.8467 211.541 43.8467 211.541 43.7667V37.8511L212.74 38.8104C212.98 38.2508 213.38 37.6912 213.699 37.0517C215.058 39.6098 216.497 42.6475 219.135 43.6868Z"
        fill="url(#paint46_linear_656_10249)"
      />
      <path
        d="M266.7 30.097C266.86 30.177 267.02 30.2569 267.26 30.4168C270.138 32.0955 272.376 34.0141 273.975 36.0126C272.376 38.1711 270.697 40.3295 269.098 42.5678C268.619 39.2902 266.22 36.0926 261.904 33.6144C252.151 28.0186 236.323 28.0185 226.57 33.6944C221.773 36.4923 219.375 40.0896 219.295 43.7669C216.657 42.7277 215.218 39.6899 213.699 37.2118C214.898 35.4531 216.577 33.6944 218.735 32.1755L217.616 32.4153C217.616 32.4153 225.291 25.7802 225.61 25.7003C225.93 25.6203 241.279 21.5433 241.279 21.5433L258.626 23.0622L266.7 30.097Z"
        fill="url(#paint47_linear_656_10249)"
      />
      <path
        opacity="0.5"
        d="M261.344 29.6961C271.097 35.292 271.097 44.4052 261.344 50.0811C251.591 55.7569 235.763 55.7569 226.01 50.161C216.257 44.5651 216.257 35.4519 226.01 29.7761C235.763 24.1002 251.511 24.1003 261.344 29.6961Z"
        fill="url(#paint48_linear_656_10249)"
      />
      <path
        opacity="0.48"
        d="M261.264 31.4546C271.017 37.0505 271.017 46.1638 261.264 51.8396C251.511 57.5154 235.683 57.5154 225.93 51.9195C216.177 46.3237 216.177 37.2104 225.93 31.5346C235.683 25.8588 251.511 25.7788 261.264 31.4546Z"
        fill="url(#paint49_linear_656_10249)"
      />
      <path
        d="M267.181 24.5806C254.39 17.226 233.686 17.306 220.975 24.6606C208.184 32.0951 208.264 44.0063 221.055 51.3608C233.845 58.7154 254.55 58.6355 267.261 51.2809C280.051 43.8464 279.971 31.9352 267.181 24.5806ZM261.745 27.6983C271.498 33.2942 271.498 42.4074 261.745 48.0832C251.992 53.7591 236.164 53.7591 226.411 48.1632C216.658 42.5673 216.658 33.4541 226.411 27.7782C236.164 22.1024 251.992 22.1024 261.745 27.6983Z"
        fill="#BCBEFF"
      />
      <path
        d="M267.181 24.5806C254.39 17.226 233.686 17.306 220.975 24.6606C208.184 32.0951 208.264 44.0063 221.055 51.3608C233.845 58.7154 254.55 58.6355 267.261 51.2809C280.051 43.8464 279.971 31.9352 267.181 24.5806ZM261.745 27.6983C271.498 33.2942 271.498 42.4074 261.745 48.0832C251.992 53.7591 236.164 53.7591 226.411 48.1632C216.658 42.5673 216.658 33.4541 226.411 27.7782C236.164 22.1024 251.992 22.1024 261.745 27.6983Z"
        fill="#BCBEFF"
      />
      <path
        d="M220.893 50.8015C233.683 58.1561 254.388 58.0761 267.099 50.7216C274.933 46.1649 277.971 39.9295 276.132 34.0139C278.29 40.0095 275.333 46.5646 267.259 51.2012C254.468 58.6357 233.843 58.6357 221.053 51.2812C216.176 48.4832 213.139 44.9658 211.939 41.2885C213.219 44.8059 216.176 48.1635 220.893 50.8015Z"
        fill="white"
      />
      <path
        d="M226.249 27.2979C236.002 21.6221 251.83 21.6221 261.583 27.218C265.34 29.3764 267.658 32.0944 268.538 34.8923C267.578 32.2542 265.34 29.7761 261.743 27.6976C251.99 22.1017 236.162 22.1017 226.409 27.7776C220.413 31.215 218.175 36.0115 219.454 40.4882C217.855 35.8516 220.094 30.8953 226.249 27.2979Z"
        fill="white"
      />
      <path
        d="M195.481 206.542L195.324 206.821L212.879 216.702L213.036 216.423L195.481 206.542Z"
        fill="#42E8E0"
      />
      <path
        d="M223.771 246.896C222.971 246.896 222.092 246.657 221.373 246.257L193.393 230.109C192.914 229.869 192.674 229.389 192.674 228.91C192.674 228.43 192.914 227.95 193.393 227.711L234.803 203.808C236.242 202.929 238.08 202.929 239.599 203.808L267.578 219.956C268.058 220.196 268.298 220.676 268.298 221.155C268.298 221.635 268.058 222.115 267.578 222.355L226.169 246.257C225.37 246.657 224.57 246.896 223.771 246.896ZM237.121 203.488C236.322 203.488 235.602 203.648 234.883 204.048L193.473 227.95C193.153 228.11 192.914 228.51 192.914 228.91C192.914 229.309 193.153 229.629 193.473 229.869L221.453 246.017C222.812 246.816 224.49 246.816 225.929 246.017L267.339 222.115C267.658 221.955 267.898 221.555 267.898 221.155C267.898 220.756 267.738 220.436 267.339 220.196L239.359 204.048C238.72 203.648 237.92 203.488 237.121 203.488Z"
        fill="#42E8E0"
      />
      <path
        d="M230.487 219.717L226.09 217.159L227.129 216.599L231.526 219.077L230.487 219.717Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M234.244 221.876L232.006 220.597L233.125 219.957L235.283 221.236L234.244 221.876Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M227.926 221.236L223.529 218.678L224.569 218.039L228.965 220.597L227.926 221.236Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M231.686 223.394L229.447 222.115L230.566 221.475L232.725 222.754L231.686 223.394Z"
        fill="#42E8E0"
      />
      <path
        d="M225.371 222.674L220.975 220.116L222.014 219.477L226.411 222.035L225.371 222.674Z"
        fill="#42E8E0"
      />
      <path
        d="M229.131 224.834L226.893 223.555L228.012 222.916L230.17 224.195L229.131 224.834Z"
        fill="#42E8E0"
      />
      <path
        d="M222.813 224.195L218.416 221.637L219.455 220.997L223.852 223.555L222.813 224.195Z"
        fill="#42E8E0"
      />
      <path
        d="M226.568 226.351L224.33 225.072L225.449 224.433L227.608 225.712L226.568 226.351Z"
        fill="#42E8E0"
      />
      <path
        d="M220.256 225.632L215.859 223.074L216.899 222.434L221.295 224.992L220.256 225.632Z"
        fill="#42E8E0"
      />
      <path
        d="M224.012 227.79L221.773 226.511L222.893 225.871L225.051 227.151L224.012 227.79Z"
        fill="#42E8E0"
      />
      <path
        d="M217.694 227.071L213.297 224.593L214.336 223.953L218.733 226.511L217.694 227.071Z"
        fill="#42E8E0"
      />
      <path
        d="M221.455 229.309L219.217 228.03L220.336 227.39L222.494 228.669L221.455 229.309Z"
        fill="#42E8E0"
      />
      <path
        d="M215.139 228.59L210.742 226.032L211.781 225.393L216.178 227.951L215.139 228.59Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M218.897 230.748L216.658 229.469L217.777 228.83L219.936 230.109L218.897 230.748Z"
        fill="#42E8E0"
      />
      <path
        d="M212.58 230.029L208.184 227.551L209.223 226.911L213.62 229.47L212.58 230.029Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M216.338 232.267L214.1 230.988L215.219 230.349L217.377 231.628L216.338 232.267Z"
        fill="#42E8E0"
      />
      <path
        d="M240.237 225.392L235.84 222.914L236.879 222.274L241.276 224.753L240.237 225.392Z"
        fill="#42E8E0"
      />
      <path
        d="M243.994 227.551L241.756 226.272L242.875 225.712L245.033 226.912L243.994 227.551Z"
        fill="#42E8E0"
      />
      <path
        d="M237.676 226.909L233.279 224.351L234.319 223.712L238.715 226.27L237.676 226.909Z"
        fill="#42E8E0"
      />
      <path
        d="M241.436 229.07L239.197 227.791L240.316 227.151L242.475 228.43L241.436 229.07Z"
        fill="#42E8E0"
      />
      <path
        d="M235.121 228.35L230.725 225.792L231.764 225.232L236.161 227.71L235.121 228.35Z"
        fill="#42E8E0"
      />
      <path
        d="M238.881 230.509L236.643 229.23L237.762 228.67L239.92 229.869L238.881 230.509Z"
        fill="#42E8E0"
      />
      <path
        d="M238.078 215.319L233.682 212.761L234.801 212.122L239.198 214.68L238.078 215.319Z"
        fill="#42E8E0"
      />
      <path
        d="M241.834 217.478L239.676 216.199L240.715 215.559L242.953 216.838L241.834 217.478Z"
        fill="#42E8E0"
      />
      <path
        d="M235.52 216.759L231.123 214.281L232.242 213.641L236.639 216.199L235.52 216.759Z"
        fill="#42E8E0"
      />
      <path
        d="M239.276 218.997L237.117 217.718L238.156 217.079L240.395 218.358L239.276 218.997Z"
        fill="#42E8E0"
      />
      <path
        d="M232.961 218.278L228.564 215.72L229.684 215.08L234.08 217.638L232.961 218.278Z"
        fill="#42E8E0"
      />
      <path
        d="M236.721 220.436L234.562 219.157L235.602 218.517L237.84 219.797L236.721 220.436Z"
        fill="#42E8E0"
      />
      <path
        d="M247.83 220.995L243.434 218.437L244.553 217.877L248.95 220.355L247.83 220.995Z"
        fill="#42E8E0"
      />
      <path
        d="M251.59 223.153L249.432 221.874L250.471 221.234L252.709 222.513L251.59 223.153Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M245.276 222.515L240.879 219.957L241.998 219.318L246.395 221.876L245.276 222.515Z"
        fill="#42E8E0"
      />
      <path
        d="M249.03 224.672L246.871 223.393L247.91 222.753L250.149 224.032L249.03 224.672Z"
        fill="#42E8E0"
      />
      <path
        d="M242.713 223.953L238.316 221.395L239.436 220.756L243.832 223.314L242.713 223.953Z"
        fill="#42E8E0"
      />
      <path
        d="M246.471 226.111L244.312 224.832L245.352 224.193L247.59 225.472L246.471 226.111Z"
        fill="#42E8E0"
      />
      <path
        d="M232.563 229.869L228.166 227.31L229.205 226.671L233.602 229.229L232.563 229.869Z"
        fill="#42E8E0"
      />
      <path
        d="M236.318 232.026L234.08 230.747L235.199 230.107L237.358 231.386L236.318 232.026Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M230.006 231.308L225.609 228.75L226.649 228.19L231.045 230.669L230.006 231.308Z"
        fill="#42E8E0"
      />
      <path
        d="M233.762 233.465L231.523 232.186L232.643 231.547L234.801 232.826L233.762 233.465Z"
        fill="#42E8E0"
      />
      <path
        d="M227.444 232.827L223.047 230.269L224.086 229.629L228.483 232.187L227.444 232.827Z"
        fill="#42E8E0"
      />
      <path
        d="M231.205 234.985L228.967 233.706L230.086 233.067L232.244 234.346L231.205 234.985Z"
        fill="#42E8E0"
      />
      <path
        d="M224.889 234.266L220.492 231.708L221.531 231.068L225.928 233.626L224.889 234.266Z"
        fill="#42E8E0"
      />
      <path
        d="M228.647 236.424L226.408 235.145L227.527 234.505L229.686 235.784L228.647 236.424Z"
        fill="#42E8E0"
      />
      <path
        d="M222.33 235.704L217.934 233.226L219.053 232.586L223.45 235.064L222.33 235.704Z"
        fill="#42E8E0"
      />
      <path
        d="M226.088 237.864L223.93 236.584L224.969 236.025L227.207 237.224L226.088 237.864Z"
        fill="#42E8E0"
      />
      <path
        d="M251.993 211.242L251.833 211.002L266.942 201.969C267.502 201.649 267.901 201.01 267.901 200.29C267.901 199.571 267.502 199.011 266.942 198.691L247.916 187.819C247.197 187.42 246.797 186.7 246.797 185.901C246.797 185.102 247.197 184.382 247.916 183.982L293.802 157.602C294.362 157.282 294.681 156.722 294.681 156.083C294.681 155.443 294.362 154.884 293.802 154.564L285.968 149.927C283.57 148.489 282.051 145.85 282.051 143.053V75.3426C282.051 72.6246 280.612 70.0665 278.214 68.7075L270.459 64.1508L270.619 63.911L278.374 68.4676C280.852 69.9066 282.371 72.5446 282.371 75.3426V143.053C282.371 145.771 283.81 148.329 286.208 149.688L294.042 154.324C294.682 154.724 295.001 155.363 295.001 156.083C295.001 156.802 294.602 157.442 293.962 157.842L248.076 184.222C247.516 184.542 247.117 185.181 247.117 185.901C247.117 186.62 247.436 187.18 248.076 187.58L267.102 198.452C267.821 198.851 268.221 199.571 268.221 200.29C268.221 201.09 267.821 201.809 267.182 202.209L251.993 211.242Z"
        fill="#42E8E0"
      />
      <defs>
        <linearGradient
          id="paint0_linear_656_10249"
          x1="203.243"
          y1="108.729"
          x2="200.501"
          y2="103.999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_656_10249"
          x1="196.733"
          y1="104.988"
          x2="193.991"
          y2="100.258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_656_10249"
          x1="190.112"
          y1="101.18"
          x2="187.37"
          y2="96.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_656_10249"
          x1="202.037"
          y1="109.341"
          x2="205.888"
          y2="102.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_656_10249"
          x1="195.526"
          y1="105.598"
          x2="199.378"
          y2="98.898"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_656_10249"
          x1="188.906"
          y1="101.789"
          x2="192.757"
          y2="95.0893"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_656_10249"
          x1="218.771"
          y1="146.506"
          x2="268.765"
          y2="117.635"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.3076" stopColor="#9297EE" />
          <stop offset="0.5949" stopColor="#727AE2" />
          <stop offset="0.8355" stopColor="#5E67DA" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_656_10249"
          x1="268.325"
          y1="111.821"
          x2="217.372"
          y2="134.398"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_656_10249"
          x1="234.86"
          y1="142.354"
          x2="252.47"
          y2="111.721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_656_10249"
          x1="234.817"
          y1="144.102"
          x2="252.427"
          y2="113.469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(97.856 182.207) rotate(-59.6141) scale(48.6448 48.6447)"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_656_10249"
          x1="79.3106"
          y1="194.556"
          x2="50.1744"
          y2="149.806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.1237" stopColor="#B4B6FC" />
          <stop offset="0.3207" stopColor="#9CA1F2" />
          <stop offset="0.5651" stopColor="#777EE4" />
          <stop offset="0.744" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_656_10249"
          x1="50.3491"
          y1="211.154"
          x2="27.7139"
          y2="155.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_656_10249"
          x1="24.0344"
          y1="207.945"
          x2="48.3619"
          y2="166.456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint14_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(47.993 204.454) scale(54.8863 54.8863)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint15_linear_656_10249"
          x1="44.1704"
          y1="195.733"
          x2="64.9086"
          y2="162.499"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint16_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(37.1164 201.031) rotate(-58.0359) scale(31.3376 31.3376)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint17_linear_656_10249"
          x1="76.1577"
          y1="128.772"
          x2="88.2228"
          y2="128.772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_656_10249"
          x1="80.3711"
          y1="130.024"
          x2="89.7749"
          y2="130.024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_656_10249"
          x1="220.686"
          y1="171.993"
          x2="57.9577"
          y2="171.993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_656_10249"
          x1="169.058"
          y1="168.205"
          x2="6.33017"
          y2="168.205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_656_10249"
          x1="239.121"
          y1="96.8217"
          x2="123.963"
          y2="96.8217"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_656_10249"
          x1="239.121"
          y1="126.355"
          x2="219.347"
          y2="126.355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_656_10249"
          x1="223.693"
          y1="158.578"
          x2="61.0518"
          y2="158.578"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_656_10249"
          x1="169.042"
          y1="154.13"
          x2="6.31455"
          y2="154.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_656_10249"
          x1="286.234"
          y1="122.783"
          x2="123.592"
          y2="122.783"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_656_10249"
          x1="231.585"
          y1="118.334"
          x2="68.8569"
          y2="118.334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_656_10249"
          x1="76.0003"
          y1="85.7359"
          x2="89.9128"
          y2="86.1187"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_656_10249"
          x1="51.2217"
          y1="86.6212"
          x2="95.3956"
          y2="87.8364"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_656_10249"
          x1="77.1077"
          y1="90.8453"
          x2="80.23"
          y2="90.8453"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <radialGradient
          id="paint30_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(66.3325 31.8625) rotate(1.57587) scale(48.6445 48.6444)"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.7689 59.7705) rotate(31.576) scale(13.9322 12.066)"
        >
          <stop stopColor="#F9636B" />
          <stop offset="1" stopColor="#B6246E" />
        </radialGradient>
        <linearGradient
          id="paint32_linear_656_10249"
          x1="46.0364"
          y1="41.0606"
          x2="68.5786"
          y2="89.4683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.1237" stopColor="#B4B6FC" />
          <stop offset="0.3207" stopColor="#9CA1F2" />
          <stop offset="0.5651" stopColor="#777EE4" />
          <stop offset="0.744" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_656_10249"
          x1="16.6234"
          y1="56.845"
          x2="52.1873"
          y2="105.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_656_10249"
          x1="5.41502"
          y1="80.8684"
          x2="53.4907"
          y2="82.191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint35_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.8204 99.0611) rotate(1.57587) scale(54.9154 54.9154)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint36_linear_656_10249"
          x1="26.4386"
          y1="70.2477"
          x2="65.6126"
          y2="70.2477"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint37_radial_656_10249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.2105 73.4269) scale(31.3377 31.3377)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint38_linear_656_10249"
          x1="148.803"
          y1="76.1177"
          x2="251.261"
          y2="137.224"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1055" stopColor="#37B6BF" />
          <stop offset="0.2197" stopColor="#2C87A1" />
          <stop offset="0.338" stopColor="#235F87" />
          <stop offset="0.4587" stopColor="#1C3F72" />
          <stop offset="0.5824" stopColor="#162561" />
          <stop offset="0.7105" stopColor="#121355" />
          <stop offset="0.8458" stopColor="#10084E" />
          <stop offset="1" stopColor="#0F054C" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_656_10249"
          x1="143.232"
          y1="79.2467"
          x2="215.645"
          y2="122.457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1055" stopColor="#37B6BF" />
          <stop offset="0.2197" stopColor="#2C87A1" />
          <stop offset="0.338" stopColor="#235F87" />
          <stop offset="0.4587" stopColor="#1C3F72" />
          <stop offset="0.5824" stopColor="#162561" />
          <stop offset="0.7105" stopColor="#121355" />
          <stop offset="0.8458" stopColor="#10084E" />
          <stop offset="1" stopColor="#0F054C" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_656_10249"
          x1="203.243"
          y1="21.5979"
          x2="200.501"
          y2="16.8683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_656_10249"
          x1="196.733"
          y1="17.8563"
          x2="193.991"
          y2="13.1268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_656_10249"
          x1="190.112"
          y1="14.0484"
          x2="187.37"
          y2="9.31883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_656_10249"
          x1="202.037"
          y1="22.2094"
          x2="205.888"
          y2="15.5092"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_656_10249"
          x1="195.526"
          y1="18.4671"
          x2="199.378"
          y2="11.7667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_656_10249"
          x1="188.906"
          y1="14.6581"
          x2="192.757"
          y2="7.95798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_656_10249"
          x1="218.771"
          y1="59.3767"
          x2="268.765"
          y2="30.5061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.3076" stopColor="#9297EE" />
          <stop offset="0.5949" stopColor="#727AE2" />
          <stop offset="0.8355" stopColor="#5E67DA" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_656_10249"
          x1="268.325"
          y1="24.6924"
          x2="217.372"
          y2="47.269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_656_10249"
          x1="234.86"
          y1="55.2255"
          x2="252.47"
          y2="24.5922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_656_10249"
          x1="234.817"
          y1="56.9733"
          x2="252.427"
          y2="26.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const DiscoverBanner = () => {
  return (
    <svg
      width="452"
      height="376"
      viewBox="0 0 452 376"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <path
          d="M310.96 155.563C313.278 154.221 315.108 155.319 315.108 158.003C315.108 160.686 313.278 163.858 310.96 165.2C308.642 166.542 306.812 165.444 306.812 162.76C306.812 160.076 308.642 156.905 310.96 155.563Z"
          fill="url(#paint0_linear_656_9840)"
        />
        <path
          d="M311.204 155.686C308.886 157.028 307.056 160.2 307.056 162.884C307.056 164.104 307.422 165.08 308.154 165.445C307.3 165.08 306.812 164.104 306.812 162.64C306.812 159.956 308.642 156.784 310.96 155.442C312.18 154.71 313.278 154.71 314.01 155.198C313.278 154.954 312.302 155.076 311.204 155.686Z"
          fill="white"
        />
        <path
          d="M301.075 149.83C303.393 148.488 305.223 149.586 305.223 152.27C305.223 154.954 303.393 158.126 301.075 159.467C298.758 160.809 296.928 159.711 296.928 157.028C296.928 154.344 298.758 151.172 301.075 149.83Z"
          fill="url(#paint1_linear_656_9840)"
        />
        <path
          d="M290.954 143.973C293.272 142.632 295.102 143.729 295.102 146.413C295.102 149.097 293.272 152.269 290.954 153.611C288.636 154.953 286.807 153.855 286.807 151.171C286.807 148.609 288.636 145.315 290.954 143.973Z"
          fill="url(#paint2_linear_656_9840)"
        />
        <path
          d="M308.029 165.444L313.153 168.372C312.421 167.884 311.933 167.03 311.933 165.688C311.933 163.005 313.763 159.833 316.081 158.491C317.179 157.881 318.154 157.759 319.008 158.125L340.844 170.69L334.989 180.937L270.578 143.974C267.773 142.388 266.797 138.729 268.383 135.923C269.968 133.117 273.628 132.141 276.434 133.727L293.878 143.73C293.147 143.242 292.049 143.242 290.829 143.974C288.511 145.316 286.681 148.488 286.681 151.172C286.681 152.514 287.169 153.489 287.901 153.855L293.025 156.783C292.293 156.295 291.805 155.441 291.805 154.099C291.805 151.416 293.635 148.244 295.952 146.902C297.05 146.292 298.026 146.17 298.88 146.536L304.004 149.464C303.272 148.976 302.174 148.976 300.954 149.708C298.636 151.05 296.806 154.221 296.806 156.905C296.806 158.247 297.294 159.223 298.026 159.589L303.15 162.517C302.418 162.029 301.93 161.175 301.93 159.833C301.93 157.149 303.76 153.977 306.077 152.636C307.175 152.026 308.151 151.904 309.005 152.27L313.885 155.075C313.153 154.587 312.055 154.587 310.835 155.319C308.517 156.661 306.687 159.833 306.687 162.517C306.809 164.103 307.297 164.956 308.029 165.444Z"
          fill="#BCBEFF"
        />
        <path
          d="M301.319 149.953C299.002 151.294 297.172 154.466 297.172 157.15C297.172 158.37 297.538 159.346 298.27 159.712C297.416 159.346 296.928 158.37 296.928 156.906C296.928 154.222 298.758 151.05 301.075 149.709C302.295 148.977 303.393 148.977 304.125 149.465C303.393 149.221 302.417 149.343 301.319 149.953Z"
          fill="white"
        />
        <path
          d="M291.198 144.096C288.88 145.438 287.051 148.609 287.051 151.293C287.051 152.513 287.417 153.489 288.149 153.855C287.295 153.489 286.807 152.513 286.807 151.049C286.807 148.365 288.636 145.194 290.954 143.852C292.174 143.12 293.272 143.12 294.004 143.608C293.272 143.486 292.296 143.486 291.198 144.096Z"
          fill="white"
        />
        <path
          opacity="0.48"
          d="M316.084 158.492C313.766 159.834 311.936 163.006 311.936 165.689C311.936 167.031 312.424 168.007 313.156 168.373L308.032 165.445C307.3 164.957 306.812 164.104 306.812 162.762C306.812 160.078 308.642 156.906 310.96 155.564C312.18 154.832 313.156 154.832 314.01 155.32L319.011 158.248C318.28 157.76 317.304 157.882 316.084 158.492Z"
          fill="url(#paint3_linear_656_9840)"
        />
        <path
          opacity="0.48"
          d="M306.199 152.757C303.881 154.099 302.051 157.271 302.051 159.955C302.051 161.297 302.539 162.272 303.271 162.638L298.148 159.711C297.416 159.223 296.928 158.369 296.928 157.027C296.928 154.343 298.758 151.171 301.075 149.83C302.295 149.098 303.271 149.098 304.125 149.586L309.127 152.513C308.273 152.025 307.297 152.147 306.199 152.757Z"
          fill="url(#paint4_linear_656_9840)"
        />
        <path
          opacity="0.48"
          d="M296.078 147.022C293.76 148.364 291.93 151.536 291.93 154.22C291.93 155.562 292.418 156.538 293.15 156.904L288.027 153.976C287.295 153.488 286.807 152.634 286.807 151.292C286.807 148.608 288.636 145.437 290.954 144.095C292.174 143.363 293.15 143.363 294.004 143.851L299.006 146.778C298.274 146.29 297.176 146.29 296.078 147.022Z"
          fill="url(#paint5_linear_656_9840)"
        />
        <path
          d="M335.234 198.87C335.234 199.236 335.234 199.48 335.234 199.846L347.921 210.459L368.537 218.144L383.054 214.85L396.96 210.825L411.111 199.968L411.477 199.724C411.477 198.87 411.477 198.016 411.355 197.162C413.795 193.868 416.357 190.575 418.796 187.159C419.894 188.623 420.87 190.087 421.602 191.55L423.31 190.209V198.748C423.31 198.87 423.31 198.992 423.31 198.992V199.358C423.066 206.555 418.309 213.753 408.793 219.242C389.275 230.587 357.802 230.587 338.283 219.364C328.646 213.753 323.767 206.555 323.645 199.236C323.645 199.114 323.645 199.114 323.645 198.992V189.965L325.474 191.428C325.84 190.575 326.45 189.721 326.938 188.745C329.012 192.648 331.208 197.284 335.234 198.87Z"
          fill="url(#paint6_linear_656_9840)"
        />
        <path
          d="M407.817 178.131C408.061 178.253 408.305 178.375 408.671 178.619C413.062 181.181 416.478 184.108 418.918 187.158C416.478 190.452 413.916 193.745 411.476 197.161C410.744 192.16 407.085 187.28 400.497 183.498C385.615 174.959 361.461 174.959 346.578 183.62C339.258 187.89 335.599 193.379 335.477 198.991C331.451 197.405 329.255 192.77 326.938 188.988C328.767 186.304 331.329 183.62 334.623 181.303L332.915 181.668C332.915 181.668 344.626 171.543 345.114 171.421C345.602 171.299 369.024 165.078 369.024 165.078L395.496 167.396L407.817 178.131Z"
          fill="url(#paint7_linear_656_9840)"
        />
        <path
          opacity="0.5"
          d="M399.644 177.52C414.527 186.059 414.527 199.966 399.644 208.627C384.761 217.288 360.607 217.288 345.725 208.749C330.842 200.21 330.842 186.303 345.725 177.641C360.607 168.98 384.639 168.858 399.644 177.52Z"
          fill="url(#paint8_linear_656_9840)"
        />
        <path
          opacity="0.48"
          d="M399.521 180.203C414.404 188.743 414.404 202.649 399.521 211.311C384.638 219.972 360.484 219.972 345.602 211.433C330.719 202.893 330.719 188.987 345.602 180.325C360.484 171.664 384.638 171.542 399.521 180.203Z"
          fill="url(#paint9_linear_656_9840)"
        />
        <path
          d="M408.551 169.713C389.032 158.49 357.437 158.612 338.041 169.835C318.522 181.18 318.644 199.357 338.163 210.58C357.681 221.803 389.276 221.681 408.673 210.458C428.191 199.113 428.069 180.814 408.551 169.713ZM400.256 174.471C415.138 183.01 415.138 196.917 400.256 205.578C385.373 214.239 361.219 214.239 346.336 205.7C331.453 197.161 331.453 183.254 346.336 174.593C361.219 165.931 385.373 165.931 400.256 174.471Z"
          fill="#BCBEFF"
        />
        <path
          d="M408.551 169.713C389.032 158.49 357.437 158.612 338.041 169.835C318.522 181.18 318.644 199.357 338.163 210.58C357.681 221.803 389.276 221.681 408.673 210.458C428.191 199.113 428.069 180.814 408.551 169.713ZM400.256 174.471C415.138 183.01 415.138 196.917 400.256 205.578C385.373 214.239 361.219 214.239 346.336 205.7C331.453 197.161 331.453 183.254 346.336 174.593C361.219 165.931 385.373 165.931 400.256 174.471Z"
          fill="#BCBEFF"
        />
        <path
          d="M337.917 209.727C357.435 220.95 389.03 220.828 408.427 209.605C420.382 202.652 425.017 193.137 422.212 184.109C425.505 193.259 420.992 203.262 408.671 210.337C389.152 221.682 357.679 221.682 338.161 210.459C330.719 206.189 326.084 200.822 324.254 195.21C326.206 200.578 330.719 205.702 337.917 209.727Z"
          fill="white"
        />
        <path
          d="M346.089 173.861C360.972 165.2 385.126 165.2 400.009 173.739C405.742 177.033 409.28 181.181 410.622 185.45C409.158 181.425 405.742 177.643 400.253 174.471C385.37 165.932 361.216 165.932 346.333 174.593C337.184 179.839 333.768 187.158 335.72 193.99C333.281 186.914 336.696 179.351 346.089 173.861Z"
          fill="white"
        />
      </g>
      <path
        d="M248.984 342.819C247.886 342.819 246.666 342.575 245.691 341.965L95.1553 254.987C94.1794 254.499 93.6914 253.645 93.6914 252.913C93.6914 252.303 94.0574 251.693 94.7893 251.327L184.696 199.481C186.16 198.627 188.843 198.749 190.551 199.725L340.965 286.704C341.94 287.192 342.428 288.046 342.428 288.778C342.428 289.388 342.062 289.998 341.33 290.364L251.424 342.209C250.936 342.697 249.96 342.819 248.984 342.819ZM95.3993 254.621L245.935 341.599C247.52 342.453 249.838 342.575 251.302 341.843L341.208 289.998C341.696 289.632 342.062 289.266 342.062 288.778C342.062 288.168 341.574 287.68 340.843 287.192L190.307 200.213C188.721 199.359 186.404 199.237 184.94 199.969L95.0333 251.815C94.5453 252.181 94.1794 252.547 94.1794 253.035C94.1794 253.645 94.6673 254.255 95.3993 254.621Z"
        fill="#42E8E0"
      />
      <g opacity="0.1">
        <path
          d="M152.731 206.19C162.856 212.167 171.029 226.44 170.907 238.151C170.907 244.372 168.468 248.642 164.686 250.35L132.359 268.892L106.131 223.878L139.556 204.97C139.678 204.848 139.8 204.848 139.922 204.726L140.044 204.604C143.46 203.018 147.851 203.384 152.731 206.19Z"
          fill="url(#paint10_radial_656_9840)"
        />
        <path
          opacity="0.3"
          d="M152.731 206.189C158.708 209.726 164.076 216.192 167.37 223.267C162.49 225.951 152.487 231.319 133.701 241.566C128.943 244.127 124.673 246.567 120.77 249.007L106.131 223.755L139.556 204.847C139.678 204.725 139.8 204.725 139.922 204.603L140.044 204.481C143.46 203.017 147.851 203.383 152.731 206.189Z"
          fill="#0F054C"
        />
        <path
          d="M118.944 224.488C129.435 230.709 137.974 245.592 137.852 257.791C137.852 263.281 136.023 267.306 133.095 269.502H132.973C132.973 269.502 132.973 269.502 132.851 269.502C132.729 269.624 132.607 269.624 132.485 269.746C113.943 282.067 105.159 297.926 94.5461 317.566L91.6184 323.178L41.7246 234.491L47.8241 234.857C69.9042 236.077 85.3969 232.539 105.403 223.146C108.819 221.072 113.577 221.438 118.944 224.488Z"
          fill="url(#paint11_linear_656_9840)"
        />
        <path
          opacity="0.3"
          d="M47.8223 234.857C69.9024 236.077 85.3951 232.539 105.401 223.146C108.939 221.072 113.697 221.438 119.064 224.488C125.042 228.026 130.409 234.491 133.947 241.566C133.947 241.566 133.947 241.566 133.825 241.566C102.84 258.401 90.7627 272.43 90.7627 272.43L63.315 265.354L54.5317 256.815L41.9668 234.491L47.8223 234.857Z"
          fill="#0F054C"
        />
        <path
          d="M61.9775 239.37C82.1058 251.203 98.4524 279.749 98.2084 303.171C98.0864 314.882 93.9388 323.055 87.3513 326.837L81.2518 330.252L82.7157 328.667C76.7382 330.13 69.4188 328.667 61.4895 324.031C41.3612 312.198 25.0146 283.652 25.2586 260.23C25.3805 251.081 27.9423 244.006 32.212 239.614L30.5041 239.736L36.1156 236.564C36.1156 236.564 36.1156 236.564 36.2376 236.564L36.4816 236.442C42.9471 232.905 51.9743 233.515 61.9775 239.37Z"
          fill="url(#paint12_linear_656_9840)"
        />
        <path
          d="M57.5808 241.809C77.7091 253.642 94.0557 282.188 93.8118 305.61C93.6898 317.077 89.6641 325.25 83.1987 329.154L82.2228 329.642C81.8568 329.764 81.6128 330.008 81.2468 330.13L82.5887 328.666C76.6112 330.13 69.2919 328.666 61.3625 324.03C41.2342 312.197 24.8876 283.652 25.1316 260.23C25.2536 251.08 27.8154 244.005 32.085 239.613L30.4991 239.735C37.2086 235.222 46.8458 235.588 57.5808 241.809Z"
          fill="white"
        />
        <path
          d="M56.3631 242.542C36.2348 230.709 19.6442 240.102 19.5222 263.524C19.4002 286.946 35.6248 315.492 55.7531 327.325C75.8814 339.158 92.472 329.765 92.594 306.343C92.838 282.921 76.4914 254.375 56.3631 242.542Z"
          fill="url(#paint13_linear_656_9840)"
        />
        <path
          d="M56.3612 247.788C38.6727 237.419 24.156 245.592 24.034 266.208C23.912 286.702 38.1848 311.832 55.8733 322.201C73.5618 332.571 88.0786 324.397 88.2006 303.781C88.3225 283.165 74.0497 258.157 56.3612 247.788Z"
          fill="url(#paint14_radial_656_9840)"
        />
        <mask
          id="mask0_656_9840"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="24"
          y="243"
          width="65"
          height="84"
        >
          <path
            d="M56.3632 247.789C38.6747 237.42 24.1579 245.593 24.0359 266.209C23.9139 286.703 38.1867 311.833 55.8752 322.202C73.5637 332.571 88.0805 324.398 88.2025 303.782C88.3245 283.166 74.0517 258.158 56.3632 247.789Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_656_9840)">
          <path
            d="M60.2684 292.925L115.042 270.967L91.8637 242.177L51.1191 277.31L60.2684 292.925Z"
            fill="url(#paint15_linear_656_9840)"
          />
          <path
            d="M56.1178 277.433C52.5801 275.359 49.6523 276.945 49.6523 281.092C49.6523 285.24 52.4581 290.242 55.9958 292.315C59.5335 294.389 62.4613 292.803 62.4613 288.656C62.4613 284.508 59.6555 279.506 56.1178 277.433Z"
            fill="url(#paint16_radial_656_9840)"
          />
          <g opacity="0.3">
            <path
              d="M74.7825 283.654C74.7825 278.287 71.1228 271.821 66.4872 269.016C64.7793 268.04 63.1934 267.674 61.8516 267.918L91.861 240.836L115.893 270.601L73.9286 287.436C74.4165 286.582 74.7825 285.24 74.7825 283.654Z"
              fill="#0F054C"
            />
          </g>
        </g>
        <path
          d="M135.404 169.592L128.938 165.689C128.938 165.689 128.938 165.689 128.816 165.689L128.572 165.567C127.474 165.079 126.133 165.201 124.547 166.055L123.571 166.665C119.911 168.739 116.861 174.472 116.861 179.474V222.414L123.327 226.196L124.425 217.168L130.524 213.631V170.69C130.524 170.568 130.524 170.446 130.524 170.324L135.404 169.592Z"
          fill="url(#paint17_linear_656_9840)"
        />
        <path
          d="M137.85 217.899L123.455 226.195V183.254C123.455 178.375 126.505 172.641 130.165 170.445L131.14 169.835C134.8 167.762 137.85 169.957 137.85 174.837V217.899Z"
          fill="url(#paint18_linear_656_9840)"
        />
        <path
          opacity="0.3"
          d="M120.523 191.796L120.279 191.674C119.792 191.43 119.426 191.43 119.182 191.674L117.596 192.65L118.694 192.894C118.694 193.016 118.694 193.016 118.694 193.138V202.165C118.694 203.385 119.426 204.849 120.401 205.337L120.035 206.557L121.621 205.581C121.987 205.459 122.231 204.849 122.231 204.117V195.09C122.231 193.748 121.499 192.284 120.523 191.796Z"
          fill="#0F054C"
        />
        <path
          d="M118.813 206.313L118.569 206.191C117.593 205.703 116.861 204.239 116.861 203.02V193.992C116.861 192.772 117.593 192.162 118.569 192.65L118.813 192.772C119.789 193.26 120.521 194.724 120.521 195.944V204.971C120.521 206.313 119.789 206.801 118.813 206.313Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M77.8034 324.96C90.601 318.033 91.2524 294.454 79.2584 272.296C67.2643 250.137 47.1668 237.789 34.3693 244.716C21.5717 251.643 20.9203 275.222 32.9144 297.381C44.9084 319.539 65.0059 331.887 77.8034 324.96Z"
          fill="#42E8E0"
        />
      </g>
      <path
        d="M342.303 273.775L334.007 272.555L190.303 189.602C188.596 188.626 186.156 188.504 184.692 189.358L99.1772 238.763L93.9316 238.032V244.985C93.9316 245.595 94.4196 246.327 95.2735 246.815L245.809 333.793C247.517 334.769 249.956 334.891 251.42 334.037L341.327 282.192C341.937 281.826 342.303 281.338 342.303 280.728V273.775Z"
        fill="url(#paint19_linear_656_9840)"
      />
      <path
        d="M95.2716 239.86L245.807 326.839C247.515 327.815 249.955 327.937 251.418 327.083L341.325 275.237C342.789 274.383 342.545 272.919 340.959 272.065L190.424 185.087C188.716 184.111 186.276 183.989 184.812 184.843L94.9057 236.688C93.4418 237.542 93.6858 238.884 95.2716 239.86Z"
        fill="url(#paint20_linear_656_9840)"
      />
      <path
        opacity="0.3"
        d="M108.321 241.567L242.875 319.274C244.339 320.128 246.535 320.25 247.877 319.518L328.146 273.162C329.366 272.43 329.244 271.088 327.78 270.234L193.226 192.527C191.762 191.673 189.566 191.551 188.224 192.283L107.955 238.639C106.735 239.493 106.857 240.713 108.321 241.567Z"
        fill="#24126A"
      />
      <path
        d="M341.324 274.383L251.417 326.229C249.954 327.083 247.514 326.961 245.806 325.985L95.2707 239.006C94.5387 238.64 94.1727 238.03 93.9288 237.542C93.6848 238.274 94.1727 239.128 95.2707 239.738L245.806 326.717C247.514 327.693 249.954 327.815 251.417 326.961L341.324 275.115C342.178 274.627 342.422 274.017 342.178 273.285C342.056 273.773 341.812 274.139 341.324 274.383Z"
        fill="white"
      />
      <path
        d="M196.163 164.959L167.496 148.612C164.324 146.782 162.25 143.366 162.25 139.585V92.2527H162.738V139.585C162.738 143.122 164.69 146.416 167.74 148.124L196.285 164.471L196.163 164.959Z"
        fill="#42E8E0"
      />
      <path
        d="M190.053 157.882L209.084 44.9196L207.498 44.3097L209.815 42.9678C210.303 42.7238 210.913 42.7238 211.645 43.0898L363.766 130.922C364.986 131.654 365.962 133.484 365.718 134.826L346.566 248.642C346.444 249.252 346.2 249.618 345.712 249.74L343.516 251.082L343.15 249.008H343.272L192.127 161.664C190.785 161.054 189.809 159.224 190.053 157.882Z"
        fill="url(#paint21_linear_656_9840)"
      />
      <path
        d="M362.912 134.094L365.473 132.996C365.717 133.606 365.839 134.338 365.839 134.826L346.565 248.642C346.443 249.252 346.199 249.618 345.711 249.74L343.515 251.082L343.149 249.008H343.271L335.586 244.617L362.912 134.094Z"
        fill="url(#paint22_linear_656_9840)"
      />
      <path
        d="M189.687 163.127L341.808 250.959C343.028 251.691 344.004 251.203 344.248 249.983L363.4 136.167C363.644 134.825 362.668 132.995 361.448 132.263L209.205 44.5528C207.985 43.8208 207.009 44.3088 206.766 45.5287L187.613 159.345C187.491 160.565 188.345 162.395 189.687 163.127Z"
        fill="#24126A"
      />
      <g opacity="0.51">
        <path
          d="M208.719 46.6267L361.572 134.825L342.297 249.008L189.566 160.809L208.719 46.6267Z"
          fill="#453C9E"
        />
      </g>
      <path
        d="M94.0488 217.048L102.344 221.44L185.541 173.376C186.883 172.522 189.323 172.644 191.031 173.62L334.612 256.451C335.954 255.719 342.298 252.669 342.298 252.669L339.248 257.549C339.126 257.915 338.882 258.281 338.394 258.525L250.684 309.15C249.342 310.004 246.902 309.882 245.194 308.906L98.3185 224.124C97.7085 223.758 97.2206 223.27 97.0986 222.782L94.0488 217.048Z"
        fill="url(#paint23_linear_656_9840)"
      />
      <path
        d="M95.2638 218.39L245.799 305.368C247.507 306.344 249.947 306.466 251.411 305.612L341.317 253.767C342.781 252.913 342.537 251.449 340.951 250.595L190.416 163.616C188.708 162.641 186.268 162.519 184.804 163.372L94.8978 215.218C93.434 216.072 93.6779 217.414 95.2638 218.39Z"
        fill="url(#paint24_linear_656_9840)"
      />
      <path
        d="M95.2667 217.78L245.802 304.758C247.51 305.734 249.95 305.856 251.413 305.002L341.32 253.157C341.808 252.913 342.174 252.547 342.174 252.059C342.296 252.669 342.052 253.279 341.32 253.767L251.413 305.612C249.95 306.466 247.51 306.344 245.802 305.368L95.2667 218.39C94.1687 217.78 93.8028 216.926 93.9248 216.194C94.1687 216.804 94.5347 217.292 95.2667 217.78Z"
        fill="white"
      />
      <g opacity="0.15">
        <mask
          id="mask1_656_9840"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="189"
          y="46"
          width="173"
          height="204"
        >
          <path
            d="M361.576 134.825L208.723 46.6266L189.57 160.809L342.301 249.007L361.576 134.825Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_656_9840)">
          <path
            d="M189.443 162.394L197.739 166.786L280.936 118.722C282.278 117.868 284.717 117.99 286.425 118.966L430.007 201.797C431.349 201.065 437.692 198.015 437.692 198.015L434.643 202.895C434.521 203.261 434.277 203.627 433.789 203.871L346.078 254.496C344.736 255.35 342.296 255.228 340.589 254.252L193.713 169.47C193.103 169.104 192.615 168.616 192.493 168.128L189.443 162.394Z"
            fill="url(#paint25_linear_656_9840)"
          />
          <path
            d="M190.786 163.735L341.321 250.713C343.029 251.689 345.469 251.811 346.932 250.957L436.839 199.112C438.303 198.258 438.059 196.794 436.473 195.94L285.938 108.961C284.23 107.985 281.79 107.863 280.326 108.717L190.42 160.563C188.956 161.417 189.078 162.881 190.786 163.735Z"
            fill="url(#paint26_linear_656_9840)"
          />
          <path
            d="M436.352 195.818L285.817 108.839C284.719 108.23 283.377 107.986 282.035 108.108C283.011 108.23 283.865 108.473 284.597 108.839L435.132 195.818C436.84 196.794 436.962 198.258 435.498 198.99L345.592 250.835C345.104 251.079 344.494 251.323 343.762 251.323C344.86 251.445 345.958 251.201 346.69 250.835L436.596 198.99C438.182 198.258 437.938 196.794 436.352 195.818Z"
            fill="white"
          />
          <g opacity="0.5">
            <path
              d="M269.595 148.852L264.715 146.046C264.349 145.802 263.617 145.802 263.252 146.046L257.884 149.218C257.518 149.462 257.396 149.828 257.762 150.072L262.642 152.878C263.008 153.122 263.739 153.122 264.105 152.878L269.473 149.706C269.961 149.462 269.961 149.096 269.595 148.852Z"
              fill="#24126A"
            />
            <path
              d="M277.036 153.123L272.157 150.317C271.791 150.073 271.059 150.073 270.693 150.317L265.325 153.489C264.959 153.733 264.837 154.099 265.203 154.343L270.083 157.149C270.449 157.393 271.181 157.393 271.547 157.149L276.914 153.977C277.402 153.733 277.402 153.367 277.036 153.123Z"
              fill="#24126A"
            />
            <path
              d="M284.478 157.392L279.598 154.586C279.232 154.342 278.5 154.342 278.134 154.586L272.767 157.758C272.401 158.002 272.279 158.368 272.645 158.611L277.524 161.417C277.89 161.661 278.622 161.661 278.988 161.417L284.356 158.246C284.844 158.002 284.844 157.636 284.478 157.392Z"
              fill="#24126A"
            />
            <path
              d="M278.864 163.126L273.985 160.321C273.619 160.077 272.887 160.077 272.521 160.321L268.007 163.004C267.641 163.248 267.519 163.614 267.885 163.858L272.765 166.664C273.131 166.908 273.863 166.908 274.228 166.664L278.742 163.98C279.23 163.736 279.23 163.37 278.864 163.126Z"
              fill="#24126A"
            />
            <path
              d="M286.307 167.394L281.428 164.588C281.062 164.344 280.33 164.344 279.964 164.588L275.45 167.272C275.084 167.516 274.962 167.882 275.328 168.126L280.208 170.932C280.574 171.176 281.306 171.176 281.672 170.932L286.185 168.248C286.673 168.004 286.673 167.638 286.307 167.394Z"
              fill="#24126A"
            />
            <path
              d="M293.747 171.787L288.867 168.981C288.501 168.737 287.769 168.737 287.403 168.981L282.89 171.665C282.524 171.909 282.402 172.275 282.768 172.519L287.647 175.325C288.013 175.569 288.745 175.569 289.111 175.325L293.625 172.641C294.113 172.397 294.113 172.031 293.747 171.787Z"
              fill="#24126A"
            />
            <path
              d="M301.188 176.054L296.309 173.249C295.943 173.005 295.211 173.005 294.845 173.249L290.331 175.932C289.965 176.176 289.843 176.542 290.209 176.786L295.089 179.592C295.455 179.836 296.187 179.836 296.553 179.592L301.066 176.908C301.554 176.664 301.554 176.298 301.188 176.054Z"
              fill="#24126A"
            />
            <path
              d="M308.63 180.325L303.75 177.52C303.384 177.276 302.652 177.276 302.286 177.52L297.773 180.203C297.407 180.447 297.285 180.813 297.651 181.057L302.53 183.863C302.896 184.107 303.628 184.107 303.994 183.863L308.508 181.179C308.996 180.935 308.996 180.569 308.63 180.325Z"
              fill="#24126A"
            />
            <path
              d="M316.071 184.717L311.192 181.911C310.826 181.667 310.094 181.667 309.728 181.911L305.214 184.595C304.848 184.839 304.726 185.205 305.092 185.449L309.972 188.255C310.338 188.499 311.07 188.499 311.436 188.255L315.949 185.571C316.437 185.327 316.437 184.839 316.071 184.717Z"
              fill="#24126A"
            />
            <path
              d="M323.515 188.988L318.635 186.182C318.269 185.938 317.537 185.938 317.171 186.182L312.657 188.866C312.291 189.11 312.169 189.476 312.535 189.72L317.415 192.526C317.781 192.77 318.513 192.77 318.879 192.526L323.393 189.842C323.88 189.598 324.002 189.232 323.515 188.988Z"
              fill="#24126A"
            />
            <path
              d="M330.956 193.257L326.076 190.451C325.71 190.207 324.978 190.207 324.612 190.451L320.099 193.135C319.733 193.379 319.611 193.745 319.977 193.989L324.856 196.794C325.222 197.038 325.954 197.038 326.32 196.794L330.834 194.111C331.322 193.867 331.444 193.501 330.956 193.257Z"
              fill="#24126A"
            />
            <path
              d="M338.516 197.528L333.637 194.722C333.271 194.478 332.539 194.478 332.173 194.722L327.659 197.406C327.293 197.65 327.171 198.016 327.537 198.259L332.417 201.065C332.783 201.309 333.515 201.309 333.881 201.065L338.394 198.381C338.882 198.138 338.882 197.772 338.516 197.528Z"
              fill="#24126A"
            />
            <path
              d="M345.96 201.917L341.08 199.111C340.714 198.867 339.982 198.867 339.616 199.111L335.103 201.795C334.737 202.039 334.615 202.405 334.981 202.649L339.86 205.455C340.226 205.699 340.958 205.699 341.324 205.455L345.838 202.771C346.326 202.527 346.326 202.161 345.96 201.917Z"
              fill="#24126A"
            />
            <path
              d="M275.694 169.347L270.815 166.541C270.449 166.297 269.717 166.297 269.351 166.541L264.837 169.225C264.471 169.469 264.349 169.835 264.715 170.079L269.595 172.885C269.961 173.129 270.693 173.129 271.059 172.885L275.572 170.201C276.06 169.835 276.06 169.469 275.694 169.347Z"
              fill="#24126A"
            />
            <path
              d="M268.13 164.954L263.25 162.148C262.884 161.904 262.152 161.904 261.786 162.148L257.273 164.832C256.907 165.076 256.785 165.442 257.151 165.686L262.03 168.492C262.396 168.736 263.128 168.736 263.494 168.492L268.008 165.808C268.496 165.564 268.496 165.198 268.13 164.954Z"
              fill="#24126A"
            />
            <path
              d="M260.565 160.563L250.195 154.586C249.829 154.342 249.098 154.342 248.732 154.586L244.218 157.27C243.852 157.514 243.73 157.88 244.096 158.124L254.465 164.101C254.831 164.345 255.563 164.345 255.929 164.101L260.443 161.417C260.931 161.173 260.931 160.807 260.565 160.563Z"
              fill="#24126A"
            />
            <path
              d="M251.783 163.369L243.365 158.49C242.999 158.246 242.267 158.246 241.901 158.49L237.388 161.173C237.022 161.417 236.9 161.783 237.266 162.027L245.683 166.907C246.049 167.151 246.781 167.151 247.147 166.907L251.661 164.223C252.149 163.979 252.149 163.613 251.783 163.369Z"
              fill="#24126A"
            />
            <path
              d="M283.136 173.615L278.256 170.809C277.89 170.565 277.158 170.565 276.792 170.809L272.279 173.493C271.913 173.737 271.791 174.103 272.157 174.347L277.036 177.152C277.402 177.396 278.134 177.396 278.5 177.152L283.014 174.469C283.502 174.225 283.624 173.859 283.136 173.615Z"
              fill="#24126A"
            />
            <path
              d="M290.577 177.885L285.697 175.08C285.331 174.836 284.599 174.836 284.234 175.08L279.72 177.763C279.354 178.007 279.232 178.373 279.598 178.617L284.478 181.423C284.843 181.667 285.575 181.667 285.941 181.423L290.455 178.739C290.943 178.495 291.065 178.129 290.577 177.885Z"
              fill="#24126A"
            />
            <path
              d="M298.138 182.155L293.258 179.349C292.892 179.106 292.16 179.106 291.794 179.349L287.28 182.033C286.914 182.277 286.792 182.643 287.158 182.887L292.038 185.693C292.404 185.937 293.136 185.937 293.502 185.693L298.016 183.009C298.503 182.765 298.504 182.399 298.138 182.155Z"
              fill="#24126A"
            />
            <path
              d="M305.581 186.548L300.701 183.742C300.335 183.498 299.603 183.498 299.237 183.742L294.724 186.426C294.358 186.67 294.236 187.036 294.602 187.28L299.481 190.086C299.847 190.33 300.579 190.33 300.945 190.086L305.459 187.402C305.947 187.158 305.947 186.67 305.581 186.548Z"
              fill="#24126A"
            />
            <path
              d="M313.022 190.817L308.143 188.011C307.777 187.767 307.045 187.767 306.679 188.011L302.165 190.695C301.799 190.939 301.677 191.305 302.043 191.549L306.923 194.354C307.289 194.598 308.021 194.598 308.387 194.354L312.9 191.671C313.388 191.427 313.388 191.061 313.022 190.817Z"
              fill="#24126A"
            />
            <path
              d="M320.466 195.088L315.586 192.282C315.22 192.038 314.488 192.038 314.122 192.282L309.609 194.966C309.243 195.21 309.121 195.576 309.487 195.82L314.366 198.625C314.732 198.869 315.464 198.869 315.83 198.625L320.344 195.942C320.832 195.698 320.832 195.332 320.466 195.088Z"
              fill="#24126A"
            />
            <path
              d="M327.905 199.355L323.026 196.549C322.66 196.305 321.928 196.305 321.562 196.549L317.048 199.233C316.682 199.477 316.56 199.843 316.926 200.087L321.806 202.893C322.172 203.137 322.904 203.137 323.27 202.893L327.783 200.209C328.271 199.965 328.271 199.599 327.905 199.355Z"
              fill="#24126A"
            />
            <path
              d="M335.348 203.748L330.469 200.942C330.103 200.698 329.371 200.698 329.005 200.942L324.491 203.626C324.125 203.87 324.003 204.236 324.369 204.48L329.249 207.286C329.615 207.53 330.347 207.53 330.713 207.286L335.226 204.602C335.714 204.358 335.714 203.992 335.348 203.748Z"
              fill="#24126A"
            />
            <path
              d="M342.786 208.017L337.906 205.211C337.54 204.967 336.808 204.967 336.442 205.211L331.929 207.895C331.563 208.139 331.441 208.505 331.807 208.749L336.686 211.555C337.052 211.799 337.784 211.799 338.15 211.555L342.664 208.871C343.152 208.627 343.152 208.261 342.786 208.017Z"
              fill="#24126A"
            />
            <path
              d="M356.087 215.702L345.596 209.603C345.23 209.359 344.498 209.359 344.132 209.603L339.618 212.287C339.252 212.531 339.13 212.896 339.496 213.14L349.987 219.24C350.353 219.484 351.085 219.484 351.451 219.24L355.965 216.556C356.453 216.312 356.453 215.946 356.087 215.702Z"
              fill="#24126A"
            />
            <path
              d="M342.425 223.631L333.52 218.507C333.154 218.263 332.422 218.263 332.056 218.507L327.542 221.191C327.176 221.435 327.054 221.801 327.42 222.045L336.325 227.168C336.691 227.412 337.423 227.412 337.789 227.168L342.303 224.485C342.791 224.241 342.791 223.875 342.425 223.631Z"
              fill="#24126A"
            />
            <path
              d="M282.159 180.934L277.279 178.128C276.913 177.884 276.182 177.884 275.816 178.128L271.302 180.812C270.936 181.056 270.814 181.422 271.18 181.666L276.06 184.472C276.426 184.716 277.157 184.716 277.523 184.472L282.037 181.788C282.525 181.544 282.525 181.178 282.159 180.934Z"
              fill="#24126A"
            />
            <path
              d="M274.475 176.545L269.596 173.739C269.23 173.495 268.498 173.495 268.132 173.739L263.618 176.423C263.252 176.667 263.13 177.033 263.496 177.277L268.376 180.082C268.742 180.326 269.474 180.326 269.84 180.082L274.353 177.399C274.841 177.155 274.841 176.789 274.475 176.545Z"
              fill="#24126A"
            />
            <path
              d="M266.911 172.152L262.031 169.346C261.665 169.102 260.934 169.102 260.568 169.346L256.054 172.03C255.688 172.274 255.566 172.64 255.932 172.884L260.811 175.689C261.177 175.933 261.909 175.933 262.275 175.689L266.789 173.006C267.277 172.762 267.277 172.396 266.911 172.152Z"
              fill="#24126A"
            />
            <path
              d="M259.225 167.76L254.346 164.954C253.98 164.71 253.248 164.71 252.882 164.954L248.368 167.638C248.002 167.882 247.88 168.248 248.246 168.492L253.126 171.298C253.492 171.542 254.224 171.542 254.59 171.298L259.103 168.614C259.591 168.248 259.591 167.882 259.225 167.76Z"
              fill="#24126A"
            />
            <path
              d="M289.6 185.204L284.721 182.398C284.355 182.154 283.623 182.154 283.257 182.398L278.743 185.082C278.377 185.326 278.255 185.692 278.621 185.936L283.501 188.742C283.867 188.986 284.599 188.986 284.965 188.742L289.478 186.058C289.966 185.814 289.966 185.448 289.6 185.204Z"
              fill="#24126A"
            />
            <path
              d="M297.04 189.597L292.16 186.791C291.794 186.547 291.062 186.547 290.696 186.791L286.183 189.475C285.817 189.719 285.695 190.085 286.061 190.329L290.94 193.134C291.306 193.378 292.038 193.378 292.404 193.134L296.918 190.451C297.406 190.085 297.406 189.719 297.04 189.597Z"
              fill="#24126A"
            />
            <path
              d="M304.481 193.867L299.602 191.061C299.236 190.817 298.504 190.817 298.138 191.061L293.624 193.745C293.258 193.989 293.136 194.355 293.502 194.598L298.382 197.404C298.748 197.648 299.48 197.648 299.846 197.404L304.359 194.72C304.847 194.477 304.847 194.111 304.481 193.867Z"
              fill="#24126A"
            />
            <path
              d="M311.925 198.136L307.045 195.331C306.679 195.087 305.947 195.087 305.581 195.331L301.068 198.014C300.702 198.258 300.58 198.624 300.946 198.868L305.825 201.674C306.191 201.918 306.923 201.918 307.289 201.674L311.803 198.99C312.291 198.746 312.291 198.38 311.925 198.136Z"
              fill="#24126A"
            />
            <path
              d="M319.368 202.407L314.488 199.602C314.122 199.358 313.391 199.358 313.025 199.602L308.511 202.285C308.145 202.529 308.023 202.895 308.389 203.139L313.269 205.945C313.634 206.189 314.366 206.189 314.732 205.945L319.246 203.261C319.734 203.017 319.856 202.651 319.368 202.407Z"
              fill="#24126A"
            />
            <path
              d="M326.929 206.797L322.049 203.991C321.683 203.747 320.951 203.747 320.585 203.991L316.071 206.675C315.706 206.919 315.584 207.285 315.949 207.529L320.829 210.335C321.195 210.579 321.927 210.579 322.293 210.335L326.807 207.651C327.173 207.407 327.295 206.919 326.929 206.797Z"
              fill="#24126A"
            />
            <path
              d="M334.368 211.068L329.488 208.262C329.122 208.018 328.39 208.018 328.025 208.262L323.511 210.946C323.145 211.19 323.023 211.556 323.389 211.8L328.269 214.605C328.634 214.849 329.366 214.849 329.732 214.605L334.246 211.922C334.734 211.678 334.734 211.312 334.368 211.068Z"
              fill="#24126A"
            />
            <path
              d="M341.813 215.335L336.934 212.53C336.568 212.286 335.836 212.286 335.47 212.53L330.956 215.213C330.59 215.457 330.468 215.823 330.834 216.067L335.714 218.873C336.08 219.117 336.812 219.117 337.178 218.873L341.691 216.189C342.179 215.945 342.179 215.579 341.813 215.335Z"
              fill="#24126A"
            />
            <path
              d="M349.255 219.606L344.375 216.8C344.009 216.556 343.277 216.556 342.911 216.8L338.398 219.484C338.032 219.728 337.91 220.094 338.276 220.338L343.155 223.144C343.521 223.388 344.253 223.388 344.619 223.144L349.133 220.46C349.621 220.216 349.621 219.85 349.255 219.606Z"
              fill="#24126A"
            />
            <path
              d="M264.106 178.494L259.227 175.689C258.861 175.445 258.129 175.445 257.763 175.689L253.249 178.372C252.883 178.616 252.761 178.982 253.127 179.226L258.007 182.032C258.373 182.276 259.105 182.276 259.471 182.032L263.984 179.348C264.472 179.104 264.472 178.738 264.106 178.494Z"
              fill="#24126A"
            />
            <path
              d="M256.663 174.227L251.783 171.421C251.417 171.177 250.685 171.177 250.319 171.421L245.806 174.105C245.44 174.349 245.318 174.715 245.684 174.959L250.563 177.764C250.929 178.008 251.661 178.008 252.027 177.764L256.541 175.081C257.029 174.837 257.151 174.471 256.663 174.227Z"
              fill="#24126A"
            />
            <path
              d="M249.341 169.956L244.461 167.15C244.095 166.906 243.363 166.906 242.997 167.15L238.484 169.834C238.118 170.078 237.996 170.444 238.362 170.688L243.241 173.493C243.607 173.737 244.339 173.737 244.705 173.493L249.219 170.81C249.707 170.566 249.707 170.078 249.341 169.956Z"
              fill="#24126A"
            />
            <path
              d="M241.905 165.565L237.026 162.759C236.66 162.515 235.928 162.515 235.562 162.759L231.048 165.443C230.682 165.687 230.56 166.053 230.926 166.297L235.806 169.103C236.172 169.347 236.904 169.347 237.27 169.103L241.783 166.419C242.271 166.175 242.271 165.809 241.905 165.565Z"
              fill="#24126A"
            />
            <path
              d="M234.705 169.834L229.825 167.028C229.459 166.784 228.728 166.784 228.362 167.028L226.898 167.882C226.532 168.126 226.41 168.492 226.776 168.736L231.655 171.542C232.021 171.786 232.753 171.786 233.119 171.542L234.583 170.688C235.071 170.444 235.071 170.078 234.705 169.834Z"
              fill="#24126A"
            />
            <path
              d="M244.342 175.446L239.462 172.64C239.096 172.396 238.364 172.396 237.998 172.64L236.534 173.494C236.168 173.738 236.046 174.104 236.412 174.348L241.292 177.153C241.658 177.397 242.39 177.397 242.756 177.153L244.22 176.299C244.708 176.055 244.83 175.69 244.342 175.446Z"
              fill="#24126A"
            />
            <path
              d="M251.785 179.715L246.905 176.91C246.54 176.666 245.808 176.666 245.442 176.91L243.978 177.763C243.612 178.007 243.49 178.373 243.856 178.617L248.735 181.423C249.101 181.667 249.833 181.667 250.199 181.423L251.663 180.569C252.151 180.325 252.151 179.837 251.785 179.715Z"
              fill="#24126A"
            />
            <path
              d="M259.103 183.986L254.224 181.18C253.858 180.936 253.126 180.936 252.76 181.18L251.296 182.034C250.93 182.278 250.808 182.644 251.174 182.888L256.054 185.694C256.42 185.938 257.152 185.938 257.518 185.694L258.981 184.84C259.469 184.596 259.591 184.108 259.103 183.986Z"
              fill="#24126A"
            />
            <path
              d="M266.547 188.254L261.667 185.448C261.301 185.204 260.569 185.204 260.203 185.448L258.739 186.302C258.373 186.546 258.251 186.912 258.617 187.156L263.497 189.962C263.863 190.206 264.595 190.206 264.961 189.962L266.425 189.108C266.913 188.742 266.913 188.376 266.547 188.254Z"
              fill="#24126A"
            />
            <path
              d="M307.775 212.043L302.896 209.237C302.53 208.993 301.798 208.993 301.432 209.237L299.968 210.091C299.602 210.335 299.48 210.701 299.846 210.945L304.726 213.75C305.092 213.994 305.823 213.994 306.189 213.75L307.653 212.897C308.141 212.653 308.141 212.287 307.775 212.043Z"
              fill="#24126A"
            />
            <path
              d="M315.219 216.312L310.339 213.507C309.973 213.263 309.241 213.263 308.875 213.507L307.411 214.361C307.045 214.604 306.923 214.97 307.289 215.214L312.169 218.02C312.535 218.264 313.267 218.264 313.633 218.02L315.097 217.166C315.463 216.922 315.585 216.434 315.219 216.312Z"
              fill="#24126A"
            />
            <path
              d="M322.539 220.582L317.659 217.776C317.293 217.532 316.561 217.532 316.196 217.776L314.732 218.63C314.366 218.874 314.244 219.24 314.61 219.484L319.489 222.29C319.855 222.534 320.587 222.534 320.953 222.29L322.417 221.436C322.905 221.192 322.905 220.704 322.539 220.582Z"
              fill="#24126A"
            />
            <path
              d="M329.978 224.851L325.099 222.045C324.733 221.801 324.001 221.801 323.635 222.045L322.171 222.899C321.805 223.143 321.683 223.509 322.049 223.753L326.929 226.559C327.295 226.803 328.027 226.803 328.393 226.559L329.856 225.705C330.344 225.461 330.344 224.973 329.978 224.851Z"
              fill="#24126A"
            />
            <path
              d="M271.544 182.765L266.664 179.959C266.298 179.715 265.566 179.715 265.2 179.959L260.687 182.643C260.321 182.887 260.199 183.253 260.565 183.497L265.444 186.303C265.81 186.547 266.542 186.547 266.908 186.303L271.422 183.619C271.91 183.375 272.032 183.009 271.544 182.765Z"
              fill="#24126A"
            />
            <path
              d="M278.989 187.034L274.11 184.228C273.744 183.984 273.012 183.984 272.646 184.228L268.132 186.912C267.766 187.156 267.644 187.522 268.01 187.766L272.89 190.572C273.256 190.816 273.988 190.816 274.353 190.572L278.867 187.888C279.355 187.644 279.477 187.278 278.989 187.034Z"
              fill="#24126A"
            />
            <path
              d="M286.55 191.428L281.67 188.622C281.304 188.378 280.572 188.378 280.206 188.622L275.693 191.306C275.327 191.55 275.205 191.916 275.571 192.16L280.45 194.966C280.816 195.21 281.548 195.21 281.914 194.966L286.428 192.282C286.916 192.038 286.916 191.55 286.55 191.428Z"
              fill="#24126A"
            />
            <path
              d="M293.991 195.697L289.111 192.891C288.745 192.647 288.014 192.647 287.648 192.891L283.134 195.575C282.768 195.818 282.646 196.184 283.012 196.428L287.892 199.234C288.258 199.478 288.989 199.478 289.355 199.234L293.869 196.55C294.357 196.306 294.357 195.94 293.991 195.697Z"
              fill="#24126A"
            />
            <path
              d="M301.432 199.967L296.553 197.162C296.187 196.918 295.455 196.918 295.089 197.162L290.575 199.845C290.209 200.089 290.087 200.455 290.453 200.699L295.333 203.505C295.699 203.749 296.431 203.749 296.797 203.505L301.31 200.821C301.798 200.577 301.798 200.211 301.432 199.967Z"
              fill="#24126A"
            />
            <path
              d="M308.876 204.235L303.996 201.429C303.63 201.185 302.898 201.185 302.532 201.429L298.019 204.113C297.653 204.357 297.531 204.723 297.897 204.967L302.776 207.773C303.142 208.017 303.874 208.017 304.24 207.773L308.754 205.089C309.242 204.845 309.242 204.479 308.876 204.235Z"
              fill="#24126A"
            />
            <path
              d="M316.317 208.628L311.438 205.822C311.072 205.578 310.34 205.578 309.974 205.822L305.46 208.506C305.094 208.75 304.972 209.116 305.338 209.36L310.218 212.166C310.584 212.41 311.316 212.41 311.682 212.166L316.195 209.482C316.683 209.238 316.683 208.872 316.317 208.628Z"
              fill="#24126A"
            />
            <path
              d="M323.759 212.895L318.879 210.09C318.513 209.846 317.781 209.846 317.415 210.09L312.902 212.774C312.536 213.017 312.414 213.383 312.78 213.627L317.659 216.433C318.025 216.677 318.757 216.677 319.123 216.433L323.637 213.749C324.125 213.505 324.125 213.139 323.759 212.895Z"
              fill="#24126A"
            />
            <path
              d="M331.198 217.166L326.318 214.361C325.953 214.117 325.221 214.117 324.855 214.361L320.341 217.044C319.975 217.288 319.853 217.654 320.219 217.898L325.099 220.704C325.465 220.948 326.197 220.948 326.562 220.704L331.076 218.02C331.564 217.776 331.564 217.41 331.198 217.166Z"
              fill="#24126A"
            />
            <path
              d="M271.177 158.734L256.904 150.561C256.538 150.317 255.807 150.317 255.441 150.561L250.927 153.245C250.561 153.489 250.439 153.855 250.805 154.099L265.078 162.272C265.444 162.516 266.176 162.516 266.542 162.272L271.055 159.588C271.543 159.344 271.665 158.978 271.177 158.734Z"
              fill="#24126A"
            />
            <path
              d="M362.794 211.676L348.522 203.503C348.156 203.259 347.424 203.259 347.058 203.503L342.544 206.187C342.178 206.431 342.056 206.797 342.422 207.041L356.695 215.214C357.061 215.458 357.793 215.458 358.159 215.214L362.672 212.53C363.16 212.286 363.16 211.798 362.794 211.676Z"
              fill="#24126A"
            />
            <path
              d="M349.009 194.598L344.129 191.792C343.764 191.548 343.032 191.548 342.666 191.792L337.298 194.963C336.932 195.207 336.81 195.573 337.176 195.817L342.056 198.623C342.422 198.867 343.154 198.867 343.52 198.623L348.887 195.451C349.375 195.207 349.375 194.841 349.009 194.598Z"
              fill="#24126A"
            />
            <path
              d="M294.848 163.367L287.163 158.853C286.797 158.609 286.065 158.609 285.699 158.853L280.331 162.025C279.965 162.269 279.843 162.635 280.209 162.879L287.895 167.393C288.261 167.637 288.993 167.637 289.358 167.393L294.726 164.221C295.214 163.977 295.214 163.611 294.848 163.367Z"
              fill="#24126A"
            />
            <path
              d="M341.815 190.451L334.129 185.937C333.763 185.693 333.032 185.693 332.666 185.937L327.298 189.109C326.932 189.353 326.81 189.719 327.176 189.963L334.861 194.476C335.227 194.72 335.959 194.72 336.325 194.476L341.693 191.305C342.181 191.061 342.181 190.695 341.815 190.451Z"
              fill="#24126A"
            />
            <path
              d="M305.578 169.589L297.893 165.075C297.527 164.831 296.795 164.831 296.429 165.075L291.062 168.247C290.696 168.491 290.574 168.857 290.94 169.101L298.625 173.614C298.991 173.858 299.723 173.858 300.089 173.614L305.456 170.443C305.944 170.199 305.944 169.833 305.578 169.589Z"
              fill="#24126A"
            />
            <path
              d="M291.066 169.223L324.614 188.62C324.98 188.864 325.711 188.864 326.077 188.62L331.567 185.448C331.933 185.204 331.933 184.838 331.567 184.594L298.02 165.198L291.066 169.223Z"
              fill="#24126A"
            />
            <path
              d="M355.228 202.284L360.595 205.334C360.961 205.577 361.449 205.456 361.815 205.334L364.011 203.992C364.377 203.748 364.377 203.504 364.011 203.26L358.643 200.21C358.277 199.966 357.789 200.088 357.423 200.21L355.228 201.552C354.862 201.796 354.862 202.04 355.228 202.284Z"
              fill="#24126A"
            />
            <path
              d="M347.79 197.893L353.158 200.943C353.524 201.187 354.012 201.065 354.378 200.943L356.573 199.601C356.939 199.357 356.939 199.113 356.573 198.869L351.206 195.819C350.84 195.575 350.352 195.697 349.986 195.819L347.79 197.161C347.424 197.405 347.424 197.771 347.79 197.893Z"
              fill="#24126A"
            />
            <path
              d="M351.327 204.48L356.694 207.529C357.06 207.773 357.548 207.651 357.914 207.529L360.11 206.188C360.476 205.944 360.476 205.7 360.11 205.456L354.742 202.406C354.376 202.162 353.888 202.284 353.522 202.406L351.327 203.748C351.083 203.992 350.961 204.358 351.327 204.48Z"
              fill="#24126A"
            />
          </g>
        </g>
      </g>
      <g opacity="0.8">
        <path
          d="M164.561 208.752L159.804 205.946C159.438 205.702 159.438 205.336 159.926 205.092L165.537 201.798C166.025 201.554 166.635 201.554 167.001 201.676L171.759 204.482C172.125 204.726 172.125 205.092 171.637 205.336L166.025 208.63C165.659 208.996 164.927 208.996 164.561 208.752Z"
          fill="#24126A"
        />
        <path
          d="M171.882 213.022L167.124 210.217C166.758 209.973 166.758 209.607 167.246 209.363L172.858 206.069C173.346 205.825 173.956 205.825 174.322 205.947L179.079 208.753C179.445 208.997 179.445 209.363 178.957 209.607L173.346 212.9C172.98 213.266 172.37 213.266 171.882 213.022Z"
          fill="#24126A"
        />
        <path
          d="M179.319 217.291L174.562 214.485C174.196 214.241 174.196 213.875 174.684 213.631L180.295 210.338C180.783 210.094 181.393 210.094 181.759 210.216L186.517 213.022C186.883 213.265 186.883 213.631 186.395 213.875L180.783 217.169C180.417 217.535 179.685 217.535 179.319 217.291Z"
          fill="#24126A"
        />
        <path
          d="M189.569 213.753L184.812 210.948C184.446 210.704 184.446 210.338 184.934 210.094L189.691 207.41C190.179 207.166 190.789 207.166 191.155 207.288L195.913 210.094C196.279 210.338 196.279 210.704 195.791 210.948L191.033 213.631C190.545 213.997 189.935 213.997 189.569 213.753Z"
          fill="#24126A"
        />
        <path
          d="M196.892 218.023L192.134 215.217C191.768 214.973 191.768 214.607 192.256 214.363L197.013 211.68C197.501 211.436 198.111 211.436 198.477 211.558L203.235 214.363C203.601 214.607 203.601 214.973 203.113 215.217L198.355 217.901C197.989 218.267 197.257 218.267 196.892 218.023Z"
          fill="#24126A"
        />
        <path
          d="M204.327 222.293L199.569 219.487C199.203 219.243 199.203 218.877 199.691 218.633L204.449 215.949C204.937 215.705 205.547 215.705 205.913 215.827L210.671 218.633C211.036 218.877 211.036 219.243 210.549 219.487L205.791 222.171C205.303 222.537 204.693 222.537 204.327 222.293Z"
          fill="#24126A"
        />
        <path
          d="M211.649 226.562L206.892 223.756C206.526 223.512 206.526 223.146 207.014 222.902L211.771 220.218C212.259 219.974 212.869 219.974 213.235 220.096L217.993 222.902C218.359 223.146 218.359 223.512 217.871 223.756L213.113 226.44C212.747 226.806 212.015 226.806 211.649 226.562Z"
          fill="#24126A"
        />
        <path
          d="M219.091 230.832L214.333 228.027C213.967 227.783 213.967 227.417 214.455 227.173L219.213 224.489C219.701 224.245 220.311 224.245 220.677 224.367L225.434 227.173C225.8 227.417 225.8 227.783 225.312 228.027L220.555 230.71C220.067 231.076 219.457 231.076 219.091 230.832Z"
          fill="#24126A"
        />
        <path
          d="M226.409 235.101L221.652 232.295C221.286 232.051 221.286 231.685 221.773 231.441L226.531 228.758C227.019 228.514 227.629 228.514 227.995 228.636L232.753 231.441C233.119 231.685 233.119 232.051 232.631 232.295L227.873 234.979C227.507 235.223 226.775 235.345 226.409 235.101Z"
          fill="#24126A"
        />
        <path
          d="M233.852 239.372L229.095 236.566C228.729 236.322 228.729 235.956 229.217 235.712L233.974 233.029C234.462 232.785 235.072 232.785 235.438 232.907L240.196 235.712C240.562 235.956 240.562 236.322 240.074 236.566L235.316 239.25C234.828 239.494 234.218 239.616 233.852 239.372Z"
          fill="#24126A"
        />
        <path
          d="M241.171 243.641L236.413 240.835C236.047 240.591 236.047 240.225 236.535 239.981L241.293 237.297C241.781 237.053 242.391 237.053 242.757 237.175L247.514 239.981C247.88 240.225 247.88 240.591 247.392 240.835L242.635 243.519C242.269 243.763 241.537 243.885 241.171 243.641Z"
          fill="#24126A"
        />
        <path
          d="M248.614 247.912L243.857 245.106C243.491 244.862 243.491 244.496 243.979 244.252L248.736 241.568C249.224 241.324 249.834 241.324 250.2 241.446L254.958 244.252C255.324 244.496 255.324 244.862 254.836 245.106L250.078 247.79C249.59 248.034 248.98 248.156 248.614 247.912Z"
          fill="#24126A"
        />
        <path
          d="M255.933 252.18L251.175 249.374C250.809 249.13 250.809 248.765 251.297 248.521L256.055 245.837C256.542 245.593 257.152 245.593 257.518 245.715L262.276 248.521C262.642 248.765 262.642 249.13 262.154 249.374L257.396 252.058C257.03 252.302 256.298 252.302 255.933 252.18Z"
          fill="#24126A"
        />
        <path
          d="M200.427 211.801L195.669 208.996C195.303 208.752 195.303 208.386 195.791 208.142L200.549 205.458C201.037 205.214 201.647 205.214 202.013 205.336L206.77 208.142C207.136 208.386 207.136 208.752 206.648 208.996L201.891 211.679C201.403 211.923 200.793 211.923 200.427 211.801Z"
          fill="#24126A"
        />
        <path
          d="M192.86 207.411L188.103 204.605C187.737 204.361 187.737 203.995 188.225 203.751L192.982 201.067C193.47 200.823 194.08 200.823 194.446 200.945L199.204 203.751C199.57 203.995 199.57 204.361 199.082 204.605L194.324 207.289C193.958 207.655 193.348 207.655 192.86 207.411Z"
          fill="#24126A"
        />
        <path
          d="M185.42 203.141L175.173 197.163C174.807 196.919 174.807 196.553 175.295 196.309L180.053 193.626C180.541 193.382 181.15 193.382 181.516 193.504L191.764 199.481C192.13 199.725 192.13 200.091 191.642 200.335L186.884 203.019C186.518 203.263 185.786 203.385 185.42 203.141Z"
          fill="#24126A"
        />
        <path
          d="M190.669 197.895L182.374 193.016C182.008 192.772 182.008 192.406 182.496 192.162L187.254 189.478C187.742 189.234 188.352 189.234 188.718 189.356L197.013 194.235C197.379 194.479 197.379 194.845 196.891 195.089L192.133 197.773C191.767 198.017 191.035 198.017 190.669 197.895Z"
          fill="#24126A"
        />
        <path
          d="M207.747 216.072L202.989 213.267C202.623 213.023 202.623 212.657 203.111 212.413L207.869 209.729C208.357 209.485 208.967 209.485 209.333 209.607L214.09 212.413C214.456 212.657 214.456 213.023 213.968 213.267L209.211 215.95C208.845 216.194 208.113 216.194 207.747 216.072Z"
          fill="#24126A"
        />
        <path
          d="M215.184 220.341L210.427 217.535C210.061 217.291 210.061 216.925 210.549 216.681L215.306 213.998C215.794 213.754 216.404 213.754 216.77 213.876L221.528 216.681C221.894 216.925 221.894 217.291 221.406 217.535L216.648 220.219C216.282 220.463 215.55 220.463 215.184 220.341Z"
          fill="#24126A"
        />
        <path
          d="M222.505 224.49L217.747 221.806C217.381 221.562 217.381 221.196 217.869 220.952L222.627 218.268C223.115 218.024 223.725 218.024 224.091 218.146L228.848 220.952C229.214 221.196 229.214 221.562 228.726 221.806L223.969 224.49C223.603 224.734 222.993 224.734 222.505 224.49Z"
          fill="#24126A"
        />
        <path
          d="M229.95 228.757L225.193 225.952C224.827 225.708 224.827 225.342 225.315 225.098L230.072 222.414C230.56 222.17 231.17 222.17 231.536 222.292L236.294 225.098C236.66 225.342 236.66 225.708 236.172 225.952L231.414 228.635C231.048 229.001 230.316 229.001 229.95 228.757Z"
          fill="#24126A"
        />
        <path
          d="M237.265 233.027L232.507 230.222C232.141 229.978 232.141 229.612 232.629 229.368L237.387 226.684C237.875 226.44 238.484 226.44 238.85 226.562L243.608 229.368C243.974 229.612 243.974 229.978 243.486 230.222L238.728 232.905C238.362 233.271 237.753 233.271 237.265 233.027Z"
          fill="#24126A"
        />
        <path
          d="M244.708 237.297L239.95 234.491C239.584 234.247 239.584 233.881 240.072 233.637L244.83 230.954C245.318 230.71 245.928 230.71 246.294 230.832L251.051 233.637C251.417 233.881 251.417 234.247 250.929 234.491L246.172 237.175C245.806 237.541 245.074 237.541 244.708 237.297Z"
          fill="#24126A"
        />
        <path
          d="M252.024 241.568L247.267 238.762C246.901 238.518 246.901 238.152 247.389 237.908L252.146 235.224C252.634 234.98 253.244 234.98 253.61 235.102L258.368 237.908C258.734 238.152 258.734 238.518 258.246 238.762L253.488 241.446C253.122 241.812 252.512 241.812 252.024 241.568Z"
          fill="#24126A"
        />
        <path
          d="M259.47 245.837L254.712 243.031C254.346 242.787 254.346 242.421 254.834 242.177L259.592 239.493C260.08 239.249 260.69 239.249 261.056 239.371L265.813 242.177C266.179 242.421 266.179 242.787 265.691 243.031L260.934 245.715C260.568 246.081 259.836 246.081 259.47 245.837Z"
          fill="#24126A"
        />
        <path
          d="M266.792 250.106L262.034 247.301C261.668 247.057 261.668 246.691 262.156 246.447L266.914 243.763C267.402 243.519 268.012 243.519 268.378 243.641L273.135 246.447C273.501 246.691 273.501 247.057 273.013 247.301L268.256 249.984C267.89 250.35 267.28 250.35 266.792 250.106Z"
          fill="#24126A"
        />
        <path
          d="M279.964 257.67L269.595 251.692C269.229 251.448 269.229 251.082 269.717 250.838L274.474 248.155C274.962 247.911 275.572 247.911 275.938 248.033L286.307 254.01C286.673 254.254 286.673 254.62 286.185 254.864L281.428 257.548C281.062 257.914 280.33 257.914 279.964 257.67Z"
          fill="#24126A"
        />
        <path
          d="M294.359 249.374L285.575 244.251C285.209 244.007 285.209 243.641 285.697 243.397L290.455 240.713C290.943 240.469 291.553 240.469 291.919 240.591L300.702 245.715C301.068 245.959 301.068 246.325 300.58 246.568L295.822 249.252C295.334 249.618 294.725 249.618 294.359 249.374Z"
          fill="#24126A"
        />
        <path
          d="M220.677 215.217L215.919 212.411C215.553 212.167 215.553 211.802 216.041 211.558L220.799 208.874C221.287 208.63 221.897 208.63 222.263 208.752L227.02 211.558C227.386 211.802 227.386 212.167 226.898 212.411L222.141 215.095C221.775 215.339 221.043 215.461 220.677 215.217Z"
          fill="#24126A"
        />
        <path
          d="M213.114 210.824L208.357 208.019C207.991 207.775 207.991 207.409 208.479 207.165L213.236 204.481C213.724 204.237 214.334 204.237 214.7 204.359L219.458 207.165C219.824 207.409 219.824 207.775 219.336 208.019L214.578 210.702C214.212 211.068 213.48 211.068 213.114 210.824Z"
          fill="#24126A"
        />
        <path
          d="M205.552 206.434L200.794 203.628C200.428 203.384 200.428 203.018 200.916 202.774L205.674 200.09C206.162 199.846 206.772 199.846 207.138 199.968L211.895 202.774C212.261 203.018 212.261 203.384 211.773 203.628L207.016 206.312C206.65 206.678 205.918 206.678 205.552 206.434Z"
          fill="#24126A"
        />
        <path
          d="M197.987 202.043L193.23 199.237C192.864 198.993 192.864 198.627 193.352 198.383L198.109 195.7C198.597 195.456 199.207 195.456 199.573 195.578L204.331 198.383C204.697 198.627 204.697 198.993 204.209 199.237L199.451 201.921C199.085 202.287 198.353 202.287 197.987 202.043Z"
          fill="#24126A"
        />
        <path
          d="M228.114 219.488L223.357 216.682C222.991 216.438 222.991 216.072 223.479 215.828L228.236 213.145C228.724 212.901 229.334 212.901 229.7 213.023L234.458 215.828C234.824 216.072 234.824 216.438 234.336 216.682L229.578 219.366C229.09 219.61 228.48 219.732 228.114 219.488Z"
          fill="#24126A"
        />
        <path
          d="M235.436 223.757L230.679 220.951C230.313 220.707 230.313 220.341 230.801 220.097L235.558 217.413C236.046 217.169 236.656 217.169 237.022 217.291L241.78 220.097C242.146 220.341 242.146 220.707 241.658 220.951L236.9 223.635C236.534 223.879 235.802 223.879 235.436 223.757Z"
          fill="#24126A"
        />
        <path
          d="M242.876 228.028L238.118 225.222C237.752 224.978 237.752 224.612 238.24 224.368L242.998 221.684C243.486 221.44 244.096 221.44 244.462 221.562L249.219 224.368C249.585 224.612 249.585 224.978 249.097 225.222L244.34 227.906C243.852 228.15 243.242 228.15 242.876 228.028Z"
          fill="#24126A"
        />
        <path
          d="M250.196 232.295L245.439 229.489C245.073 229.245 245.073 228.88 245.561 228.636L250.318 225.952C250.806 225.708 251.416 225.708 251.782 225.83L256.54 228.636C256.906 228.88 256.906 229.245 256.418 229.489L251.66 232.173C251.294 232.417 250.684 232.417 250.196 232.295Z"
          fill="#24126A"
        />
        <path
          d="M257.642 236.443L252.884 233.637C252.518 233.393 252.518 233.027 253.006 232.783L257.763 230.1C258.251 229.856 258.861 229.856 259.227 229.978L263.985 232.783C264.351 233.027 264.351 233.393 263.863 233.637L259.105 236.321C258.739 236.687 258.008 236.687 257.642 236.443Z"
          fill="#24126A"
        />
        <path
          d="M264.962 240.713L260.204 237.907C259.838 237.663 259.838 237.297 260.326 237.053L265.084 234.369C265.572 234.125 266.182 234.125 266.548 234.247L271.305 237.053C271.671 237.297 271.671 237.663 271.183 237.907L266.426 240.591C266.06 240.957 265.45 240.957 264.962 240.713Z"
          fill="#24126A"
        />
        <path
          d="M272.401 244.981L267.644 242.176C267.278 241.932 267.278 241.566 267.766 241.322L272.523 238.638C273.011 238.394 273.621 238.394 273.987 238.516L278.745 241.322C279.111 241.566 279.111 241.932 278.623 242.176L273.865 244.981C273.499 245.225 272.767 245.225 272.401 244.981Z"
          fill="#24126A"
        />
        <path
          d="M279.722 249.252L274.964 246.447C274.598 246.203 274.598 245.837 275.086 245.593L279.844 242.909C280.332 242.665 280.941 242.665 281.307 242.787L286.065 245.593C286.431 245.837 286.431 246.203 285.943 246.447L281.185 249.13C280.82 249.496 280.21 249.496 279.722 249.252Z"
          fill="#24126A"
        />
        <path
          d="M287.161 253.521L282.403 250.715C282.037 250.471 282.037 250.105 282.525 249.861L287.283 247.178C287.771 246.934 288.381 246.934 288.747 247.056L293.505 249.861C293.87 250.105 293.87 250.471 293.383 250.715L288.625 253.399C288.259 253.765 287.527 253.765 287.161 253.521Z"
          fill="#24126A"
        />
        <path
          d="M216.772 204.603L212.015 201.797C211.649 201.553 211.649 201.187 212.137 200.943L216.894 198.259C217.382 198.015 217.992 198.015 218.358 198.137L223.116 200.943C223.482 201.187 223.482 201.553 222.994 201.797L218.236 204.481C217.87 204.847 217.26 204.847 216.772 204.603Z"
          fill="#24126A"
        />
        <path
          d="M209.452 200.456L204.694 197.65C204.328 197.406 204.328 197.04 204.816 196.796L209.574 194.113C210.062 193.869 210.672 193.869 211.038 193.991L215.796 196.796C216.161 197.04 216.161 197.406 215.674 197.65L210.916 200.334C210.55 200.578 209.818 200.578 209.452 200.456Z"
          fill="#24126A"
        />
        <path
          d="M202.134 196.187L197.376 193.382C197.01 193.138 197.01 192.772 197.498 192.528L202.256 189.844C202.744 189.6 203.354 189.6 203.72 189.722L208.477 192.528C208.843 192.772 208.843 193.138 208.355 193.382L203.598 196.065C203.232 196.309 202.5 196.431 202.134 196.187Z"
          fill="#24126A"
        />
        <path
          d="M194.815 191.916L190.058 189.111C189.692 188.867 189.692 188.501 190.18 188.257L194.937 185.573C195.425 185.329 196.035 185.329 196.401 185.451L201.159 188.257C201.525 188.501 201.525 188.867 201.037 189.111L196.279 191.794C195.791 192.16 195.181 192.16 194.815 191.916Z"
          fill="#24126A"
        />
        <path
          d="M202.378 187.526L197.62 184.72C197.254 184.476 197.254 184.11 197.742 183.866L199.328 183.012C199.816 182.768 200.426 182.768 200.792 182.89L205.55 185.696C205.916 185.94 205.916 186.306 205.428 186.55L203.842 187.404C203.354 187.77 202.744 187.77 202.378 187.526Z"
          fill="#24126A"
        />
        <path
          d="M211.893 193.139L207.136 190.333C206.77 190.089 206.77 189.723 207.258 189.479L208.844 188.625C209.332 188.381 209.942 188.381 210.308 188.503L215.065 191.309C215.431 191.553 215.431 191.919 214.943 192.163L213.357 193.017C212.991 193.261 212.259 193.383 211.893 193.139Z"
          fill="#24126A"
        />
        <path
          d="M219.212 197.285L214.454 194.48C214.088 194.236 214.088 193.87 214.576 193.626L216.162 192.772C216.65 192.528 217.26 192.528 217.626 192.65L222.384 195.455C222.75 195.699 222.75 196.065 222.262 196.309L220.676 197.163C220.31 197.529 219.578 197.529 219.212 197.285Z"
          fill="#24126A"
        />
        <path
          d="M226.532 201.554L221.775 198.748C221.409 198.504 221.409 198.138 221.897 197.894L223.482 197.04C223.97 196.796 224.58 196.796 224.946 196.918L229.704 199.724C230.07 199.968 230.07 200.334 229.582 200.578L227.996 201.432C227.63 201.798 226.898 201.798 226.532 201.554Z"
          fill="#24126A"
        />
        <path
          d="M233.852 205.825L229.095 203.019C228.729 202.775 228.729 202.409 229.217 202.165L230.803 201.311C231.291 201.067 231.901 201.067 232.267 201.189L237.024 203.995C237.39 204.239 237.39 204.605 236.902 204.849L235.316 205.703C234.95 205.947 234.218 205.947 233.852 205.825Z"
          fill="#24126A"
        />
        <path
          d="M274.72 229.367L269.962 226.562C269.596 226.318 269.596 225.952 270.084 225.708L271.67 224.854C272.158 224.61 272.768 224.61 273.134 224.732L277.891 227.538C278.257 227.782 278.257 228.148 277.769 228.392L276.184 229.245C275.818 229.489 275.086 229.611 274.72 229.367Z"
          fill="#24126A"
        />
        <path
          d="M282.04 233.516L277.282 230.711C276.916 230.467 276.916 230.101 277.404 229.857L278.99 229.003C279.478 228.759 280.088 228.759 280.454 228.881L285.212 231.687C285.578 231.931 285.578 232.297 285.09 232.54L283.504 233.394C283.138 233.76 282.406 233.76 282.04 233.516Z"
          fill="#24126A"
        />
        <path
          d="M289.354 237.785L284.597 234.979C284.231 234.735 284.231 234.369 284.719 234.125L286.305 233.271C286.793 233.027 287.403 233.027 287.769 233.149L292.526 235.955C292.892 236.199 292.892 236.565 292.404 236.809L290.818 237.663C290.452 238.029 289.72 238.029 289.354 237.785Z"
          fill="#24126A"
        />
        <path
          d="M296.679 242.056L291.921 239.25C291.555 239.006 291.555 238.64 292.043 238.396L293.629 237.542C294.117 237.298 294.727 237.298 295.093 237.42L299.85 240.226C300.216 240.47 300.216 240.836 299.728 241.08L298.143 241.934C297.655 242.178 297.045 242.178 296.679 242.056Z"
          fill="#24126A"
        />
        <path
          d="M224.216 208.874L219.458 206.068C219.092 205.824 219.092 205.458 219.58 205.214L224.338 202.53C224.826 202.286 225.436 202.286 225.802 202.408L230.559 205.214C230.925 205.458 230.925 205.824 230.437 206.068L225.68 208.752C225.314 209.118 224.582 209.118 224.216 208.874Z"
          fill="#24126A"
        />
        <path
          d="M231.534 213.143L226.776 210.338C226.411 210.094 226.411 209.728 226.898 209.484L231.656 206.8C232.144 206.556 232.754 206.556 233.12 206.678L237.878 209.484C238.244 209.728 238.244 210.094 237.756 210.338L232.998 213.021C232.632 213.387 232.022 213.387 231.534 213.143Z"
          fill="#24126A"
        />
        <path
          d="M238.974 217.413L234.216 214.607C233.85 214.363 233.85 213.997 234.338 213.753L239.096 211.07C239.583 210.826 240.193 210.826 240.559 210.948L245.317 213.753C245.683 213.997 245.683 214.363 245.195 214.607L240.437 217.291C240.071 217.657 239.34 217.657 238.974 217.413Z"
          fill="#24126A"
        />
        <path
          d="M246.415 221.682L241.657 218.876C241.291 218.632 241.291 218.266 241.779 218.022L246.537 215.338C247.025 215.094 247.635 215.094 248.001 215.216L252.758 218.022C253.124 218.266 253.124 218.632 252.636 218.876L247.879 221.56C247.391 221.926 246.781 221.926 246.415 221.682Z"
          fill="#24126A"
        />
        <path
          d="M253.735 225.953L248.978 223.147C248.612 222.903 248.612 222.537 249.1 222.293L253.857 219.609C254.345 219.365 254.955 219.365 255.321 219.487L260.079 222.293C260.445 222.537 260.445 222.903 259.957 223.147L255.199 225.831C254.833 226.197 254.101 226.197 253.735 225.953Z"
          fill="#24126A"
        />
        <path
          d="M261.173 230.221L256.415 227.416C256.049 227.172 256.049 226.806 256.537 226.562L261.295 223.878C261.783 223.634 262.393 223.634 262.759 223.756L267.516 226.562C267.882 226.806 267.882 227.172 267.394 227.416L262.637 230.099C262.149 230.465 261.539 230.465 261.173 230.221Z"
          fill="#24126A"
        />
        <path
          d="M268.495 234.492L263.737 231.686C263.371 231.443 263.371 231.077 263.859 230.833L268.617 228.149C269.105 227.905 269.715 227.905 270.081 228.027L274.838 230.833C275.204 231.077 275.204 231.443 274.717 231.686L269.959 234.37C269.593 234.736 268.861 234.736 268.495 234.492Z"
          fill="#24126A"
        />
        <path
          d="M275.938 238.761L271.181 235.955C270.815 235.711 270.815 235.345 271.303 235.101L276.06 232.417C276.548 232.173 277.158 232.173 277.524 232.295L282.282 235.101C282.648 235.345 282.648 235.711 282.16 235.955L277.402 238.639C276.914 238.883 276.304 239.005 275.938 238.761Z"
          fill="#24126A"
        />
        <path
          d="M283.259 243.032L278.501 240.226C278.135 239.982 278.135 239.616 278.623 239.372L283.381 236.688C283.869 236.444 284.479 236.444 284.845 236.566L289.602 239.372C289.968 239.616 289.968 239.982 289.48 240.226L284.723 242.91C284.357 243.154 283.625 243.276 283.259 243.032Z"
          fill="#24126A"
        />
        <path
          d="M182.005 209.483L167.976 201.31C167.61 201.066 167.61 200.7 168.098 200.456L172.855 197.772C173.343 197.528 173.953 197.528 174.319 197.65L188.348 205.824C188.714 206.068 188.714 206.434 188.226 206.678L183.468 209.361C183.102 209.605 182.371 209.605 182.005 209.483Z"
          fill="#24126A"
        />
        <path
          d="M272.643 261.819L258.614 253.645C258.248 253.401 258.248 253.035 258.736 252.791L263.494 250.108C263.982 249.864 264.592 249.864 264.958 249.986L278.987 258.159C279.353 258.403 279.353 258.769 278.865 259.013L274.107 261.697C273.741 261.941 273.131 262.063 272.643 261.819Z"
          fill="#24126A"
        />
        <path
          d="M243.124 254.131L238.366 251.325C238 251.081 238 250.715 238.488 250.471L244.1 247.178C244.588 246.934 245.198 246.934 245.564 247.056L250.321 249.861C250.687 250.105 250.687 250.471 250.199 250.715L244.588 254.009C244.222 254.375 243.612 254.375 243.124 254.131Z"
          fill="#24126A"
        />
        <path
          d="M189.571 223.269L181.886 218.877C181.52 218.633 181.52 218.267 182.008 218.023L187.619 214.729C188.107 214.485 188.717 214.485 189.083 214.607L196.769 218.999C197.135 219.243 197.135 219.609 196.647 219.853L191.035 223.147C190.669 223.391 189.937 223.391 189.571 223.269Z"
          fill="#24126A"
        />
        <path
          d="M236.046 250.107L228.36 245.716C227.995 245.472 227.994 245.106 228.482 244.862L234.094 241.568C234.582 241.324 235.192 241.324 235.558 241.446L243.243 245.838C243.609 246.082 243.609 246.448 243.121 246.692L237.51 249.985C237.144 250.229 236.412 250.229 236.046 250.107Z"
          fill="#24126A"
        />
        <path
          d="M200.181 229.368L192.495 224.977C192.129 224.733 192.129 224.367 192.617 224.123L198.229 220.829C198.717 220.585 199.327 220.585 199.693 220.707L207.378 225.099C207.744 225.343 207.744 225.709 207.256 225.953L201.644 229.246C201.278 229.612 200.547 229.612 200.181 229.368Z"
          fill="#24126A"
        />
        <path
          d="M199.817 220.828L232.998 239.981C233.364 240.224 233.364 240.59 232.998 240.834L227.264 244.128C226.898 244.372 226.166 244.372 225.8 244.128L192.619 224.976L199.817 220.828Z"
          fill="#24126A"
        />
        <path
          d="M263.859 261.938L269.227 264.988C269.593 265.11 269.471 265.476 269.105 265.72L266.787 267.062C266.421 267.306 265.933 267.306 265.567 267.062L260.199 264.012C259.834 263.89 259.956 263.524 260.321 263.28L262.639 261.938C262.883 261.694 263.493 261.694 263.859 261.938Z"
          fill="#24126A"
        />
        <path
          d="M256.422 257.547L261.789 260.597C262.155 260.719 262.033 261.085 261.667 261.329L259.349 262.671C258.983 262.915 258.496 262.915 258.13 262.671L252.762 259.621C252.396 259.499 252.518 259.133 252.884 258.889L255.202 257.547C255.446 257.425 256.056 257.425 256.422 257.547Z"
          fill="#24126A"
        />
        <path
          d="M248.98 253.277L254.348 256.326C254.714 256.448 254.592 256.814 254.226 257.058L251.908 258.4C251.542 258.644 251.054 258.644 250.688 258.4L245.321 255.35C244.955 255.228 245.077 254.862 245.443 254.618L247.76 253.277C248.126 253.155 248.614 253.155 248.98 253.277Z"
          fill="#24126A"
        />
        <path
          d="M260.445 255.231L265.813 258.28C266.179 258.402 266.057 258.768 265.691 259.012L263.373 260.354C263.007 260.598 262.519 260.598 262.153 260.354L256.785 257.304C256.419 257.183 256.541 256.817 256.907 256.573L259.225 255.231C259.591 255.109 260.079 255.109 260.445 255.231Z"
          fill="#24126A"
        />
      </g>
      <path
        d="M335.721 140.437C335.355 140.437 334.989 140.315 334.623 140.071C333.525 139.461 332.793 137.997 333.037 136.777C333.159 136.167 333.525 135.801 334.013 135.557C334.501 135.313 335.233 135.435 335.843 135.801C336.941 136.411 337.673 137.875 337.429 139.095C337.307 139.705 336.941 140.071 336.453 140.315C336.209 140.315 335.965 140.437 335.721 140.437ZM334.623 135.923C334.501 135.923 334.257 135.923 334.135 136.045C333.769 136.167 333.525 136.533 333.525 136.899C333.281 137.875 333.891 139.095 334.867 139.583C335.355 139.827 335.843 139.949 336.209 139.705C336.575 139.583 336.819 139.217 336.819 138.851C337.063 137.875 336.453 136.655 335.477 136.167C335.233 136.045 334.989 135.923 334.623 135.923Z"
        fill="#42E8E0"
      />
      <path
        d="M341.819 143.854C341.453 143.854 341.087 143.732 340.721 143.488C339.623 142.878 338.891 141.414 339.135 140.194C339.257 139.584 339.623 139.218 340.111 138.974C340.599 138.73 341.331 138.852 341.941 139.218C343.039 139.828 343.771 141.292 343.527 142.512C343.405 143.122 343.039 143.488 342.551 143.732C342.307 143.854 342.063 143.854 341.819 143.854ZM340.721 139.462C340.599 139.462 340.355 139.462 340.233 139.584C339.867 139.706 339.623 140.072 339.623 140.438C339.379 141.414 339.989 142.634 340.965 143.122C341.453 143.366 341.941 143.488 342.307 143.244C342.673 143.122 342.917 142.756 342.917 142.39C343.161 141.414 342.551 140.194 341.575 139.706C341.331 139.584 341.087 139.462 340.721 139.462Z"
        fill="#42E8E0"
      />
      <path
        d="M349.265 146.049C349.021 147.147 347.923 147.513 346.947 146.903C345.849 146.293 345.239 144.951 345.483 143.853C345.727 142.755 346.825 142.389 347.801 142.999C348.899 143.609 349.509 144.951 349.265 146.049Z"
        fill="#42E8E0"
      />
      <path
        d="M232.512 78.8332L229.34 77.0033L229.584 75.5394L232.756 77.3693L232.512 78.8332Z"
        fill="#42E8E0"
      />
      <path
        d="M237.273 81.6379L234.102 79.686L234.346 78.2222L237.517 80.052L237.273 81.6379Z"
        fill="#42E8E0"
      />
      <path
        d="M227.878 76.1481L220.803 72.0005L221.047 70.5366L228.122 74.6843L227.878 76.1481Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.4"
        d="M183.877 84.8549C192.045 80.1388 192.031 64.8222 183.845 50.6443C175.659 36.4665 162.402 28.7962 154.233 33.5124C146.065 38.2285 146.079 53.545 154.265 67.7229C162.451 81.9008 175.709 89.571 183.877 84.8549Z"
        fill="#42E8E0"
      />
      <path
        d="M178.352 86.519C175.424 86.519 172.252 85.543 168.837 83.5912C157.248 76.8818 147.732 60.5352 147.732 46.9943C147.732 40.4069 149.928 35.5273 153.954 33.2095C157.98 30.8917 163.347 31.3796 169.081 34.6733C180.67 41.3828 190.185 57.7294 190.185 71.2702C190.185 77.8577 187.989 82.7373 183.963 85.0551C182.377 86.153 180.426 86.519 178.352 86.519ZM159.687 32.3555C157.736 32.3555 155.906 32.8435 154.32 33.6974C150.416 35.8932 148.342 40.6508 148.342 47.1163C148.342 60.4132 157.736 76.6378 169.203 83.2252C174.692 86.397 179.938 86.8849 183.719 84.6891C187.623 82.4933 189.697 77.7357 189.697 71.2702C189.697 57.9734 180.304 41.7487 168.837 35.1613C165.665 33.3315 162.493 32.3555 159.687 32.3555Z"
        fill="#42E8E0"
      />
      <path
        d="M166.764 93.1055C163.836 93.1055 160.664 92.1296 157.249 90.1778C145.66 83.4683 136.145 67.1217 136.145 53.5809C136.145 46.9934 138.34 42.1138 142.366 39.796C146.392 37.4782 151.759 37.9662 157.493 41.2599C169.082 47.9693 178.597 64.3159 178.597 77.8568C178.597 84.4442 176.401 89.3238 172.375 91.6416C170.668 92.7396 168.716 93.1055 166.764 93.1055ZM147.978 38.9421C146.026 38.9421 144.196 39.43 142.61 40.284C138.706 42.4798 136.632 47.2374 136.632 53.5809C136.632 66.8777 146.026 83.1024 157.493 89.6898C162.982 92.8615 168.228 93.3495 172.009 91.1537C175.913 88.9579 177.987 84.2003 177.987 77.7348C177.987 64.4379 168.594 48.2133 157.127 41.6259C153.955 39.918 150.783 38.9421 147.978 38.9421Z"
        fill="#42E8E0"
      />
      <path
        d="M131.625 144.829V138.73L138.823 102.499L131.747 98.1073L117.475 106.037V152.759C117.475 155.93 118.694 158.004 120.402 158.736L126.746 162.762L127.478 159.712L128.576 154.223C130.406 151.539 131.625 148.001 131.625 144.829Z"
        fill="url(#paint27_linear_656_9840)"
      />
      <path
        d="M131.626 162.518C127.722 164.714 124.551 162.274 124.551 157.15V110.428L138.824 102.499V149.221C138.702 154.467 135.53 160.322 131.626 162.518Z"
        fill="url(#paint28_linear_656_9840)"
      />
      <path
        d="M121.502 130.803L121.258 130.681C120.77 130.437 120.404 130.437 120.16 130.681L118.574 131.656L119.672 131.9C119.672 132.022 119.672 132.022 119.672 132.144V141.172C119.672 142.392 120.404 143.855 121.38 144.343L121.014 145.563L122.6 144.587C122.966 144.465 123.21 143.855 123.21 143.123V134.096C123.21 132.754 122.478 131.29 121.502 130.803Z"
        fill="url(#paint29_linear_656_9840)"
      />
      <path
        opacity="0.3"
        d="M121.502 130.803L121.258 130.681C120.77 130.437 120.404 130.437 120.16 130.681L118.574 131.656L119.672 131.9C119.672 132.022 119.672 132.022 119.672 132.144V141.172C119.672 142.392 120.404 143.855 121.38 144.343L121.014 145.563L122.6 144.587C122.966 144.465 123.21 143.855 123.21 143.123V134.096C123.21 132.754 122.478 131.29 121.502 130.803Z"
        fill="#0F054C"
      />
      <path
        d="M119.917 145.196L119.673 145.074C118.697 144.586 117.965 143.122 117.965 141.902V132.875C117.965 131.655 118.697 131.045 119.673 131.533L119.917 131.655C120.893 132.143 121.625 133.607 121.625 134.827V143.854C121.503 145.196 120.771 145.806 119.917 145.196Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M131.63 162.519C135.534 160.323 138.705 154.346 138.705 149.222V110.185V104.818L131.874 106.282L125.287 109.941L123.823 108.233L117.723 110.551L117.113 122.872V123.116C117.113 126.898 119.919 130.07 123.579 130.68L124.311 130.802V157.151C124.555 162.275 127.726 164.715 131.63 162.519Z"
        fill="#0F054C"
      />
      <path
        d="M163.713 83.3483C164.079 71.6373 156.149 57.1206 146.146 51.0211C140.778 47.7274 135.899 47.4834 132.483 49.8012L99.668 67.6117L123.944 113.602L157.735 95.3033C157.857 95.1814 157.979 95.1813 158.101 95.0594L158.223 94.9374C161.517 92.9855 163.591 88.9599 163.713 83.3483Z"
        fill="url(#paint30_radial_656_9840)"
      />
      <path
        opacity="0.3"
        d="M163.714 83.3484C163.958 76.3949 161.274 68.4656 156.882 61.8782C152.003 64.6839 142.122 70.1735 123.579 80.7866C118.944 83.4703 114.552 85.7881 110.404 87.74L124.067 113.48L157.858 95.1814C157.98 95.0594 158.102 95.0594 158.224 94.9374L158.346 94.8154C161.518 92.9855 163.592 88.9599 163.714 83.3484Z"
        fill="#0F054C"
      />
      <path
        d="M130.043 101.525C129.677 113.236 121.382 117.749 111.379 111.65C101.376 105.55 93.5682 91.0334 93.8122 79.3224C94.1782 67.6114 102.473 63.0978 112.477 69.1973C122.48 75.2968 130.287 89.8136 130.043 101.525Z"
        fill="url(#paint31_radial_656_9840)"
      />
      <path
        d="M130.287 102.257C130.653 90.0583 122.479 75.0536 112.11 68.5881C107.353 65.6604 102.961 65.0504 99.6672 66.3923H99.5452C99.5452 66.3923 99.5452 66.3923 99.4232 66.3923C99.3012 66.5143 99.1792 66.5143 98.9352 66.6363C78.6849 75.9075 60.5085 74.9316 38.3064 73.4677L31.9629 73.1018L80.8808 162.398L83.8085 157.153C94.4216 137.878 105.645 126.533 124.187 114.578C127.847 112.748 130.165 108.479 130.287 102.257Z"
        fill="url(#paint32_linear_656_9840)"
      />
      <path
        opacity="0.3"
        d="M83.8094 157.152C94.4225 137.878 105.646 126.533 124.188 114.578C127.726 112.748 130.044 108.479 130.166 102.257C130.41 95.3037 127.726 87.3743 123.578 80.6649C123.578 80.6649 123.578 80.6649 123.456 80.6649C92.8367 98.1094 74.4162 100.915 74.4162 100.915L65.877 127.997L68.4387 139.952L80.7597 162.398L83.8094 157.152Z"
        fill="#0F054C"
      />
      <path
        d="M87.4686 142.758C88.0786 119.336 72.4639 90.4245 52.5796 78.2255C42.5764 72.126 33.5492 71.2721 26.7178 74.9318L20.6183 78.3475L22.6921 77.9815C18.3005 82.3732 15.6167 89.3266 15.3727 98.4758C14.7628 121.898 30.3775 150.809 50.2618 163.008C58.0691 167.766 65.3885 169.352 71.488 168.01L70.5121 169.352L76.1236 166.302C76.1236 166.302 76.1236 166.302 76.2456 166.302L76.4896 166.18C82.955 162.398 87.1027 154.347 87.4686 142.758Z"
        fill="url(#paint33_linear_656_9840)"
      />
      <path
        d="M83.074 145.199C83.684 121.777 68.0693 92.8651 48.185 80.6662C38.4258 74.6887 29.3986 73.7128 22.6891 77.2505L21.7132 77.7384C21.3472 77.9824 21.1033 78.1044 20.7373 78.3484L22.5671 77.9824C18.1755 82.374 15.4917 89.3274 15.2477 98.4767C14.6378 121.899 30.2525 150.81 50.1368 163.009C57.9441 167.767 65.2635 169.353 71.363 168.011L70.5091 169.231C77.9505 165.937 82.7081 157.52 83.074 145.199Z"
        fill="white"
      />
      <path
        d="M81.8548 145.808C81.2449 169.23 64.5323 178.257 44.648 165.936C24.7636 153.737 9.02697 124.826 9.75891 101.404C10.3689 77.9817 27.0814 68.9545 46.9658 81.2754C66.8501 93.5964 82.4648 122.508 81.8548 145.808Z"
        fill="url(#paint34_linear_656_9840)"
      />
      <path
        d="M77.4649 143.122C76.855 163.617 62.2162 171.546 44.7717 160.811C27.3272 150.076 13.5424 124.702 14.1523 104.208C14.7622 83.7135 29.401 75.7842 46.8455 86.5193C64.29 97.2543 77.9529 122.628 77.4649 143.122Z"
        fill="url(#paint35_radial_656_9840)"
      />
      <path
        opacity="0.3"
        d="M50.3836 158.127C47.6998 156.541 45.26 154.59 42.8202 152.394C37.8187 147.758 37.4527 139.951 41.9663 134.827C47.4558 128.85 56.1171 120.798 69.536 112.137C63.9245 101.524 55.9951 92.0089 46.8459 86.3974C39.1605 81.6398 31.9632 80.5419 26.3516 82.4937C26.1077 82.6157 25.9857 82.6157 25.7417 82.7377H25.6197C25.3757 82.8597 25.2537 82.8597 25.0097 82.9817H24.8878C24.6438 83.1037 24.5218 83.2257 24.2778 83.2257C23.7898 83.4696 23.4239 83.7136 23.0579 83.9576C22.8139 84.0796 22.6919 84.2016 22.57 84.3236C22.57 84.3236 22.448 84.3236 22.448 84.4456C22.326 84.5675 22.082 84.6895 21.96 84.8115L21.838 84.9335C21.716 85.0555 21.472 85.1775 21.3501 85.2995C21.3501 85.2995 21.35 85.2995 21.2281 85.4215C20.8621 85.7874 20.4961 86.1534 20.1302 86.5194C20.0082 86.6414 19.8862 86.8854 19.6422 87.0073L19.5202 87.1293C19.3982 87.2513 19.2762 87.3733 19.1542 87.6173L19.0323 87.7393C18.9103 87.8613 18.7883 88.1052 18.6663 88.2272L18.5443 88.3492C18.4223 88.5932 18.3003 88.7152 18.1783 88.9592C18.0563 89.2032 17.9344 89.4471 17.8124 89.6911C17.8124 89.6911 17.8124 89.6911 17.8124 89.8131C17.6904 90.0571 17.5684 90.1791 17.4464 90.4231C17.4464 90.545 17.3244 90.545 17.3244 90.667C17.2024 90.789 17.2024 91.033 17.0804 91.155C17.0804 91.277 16.9584 91.277 16.9584 91.399C16.8364 91.521 16.8364 91.7649 16.7144 91.8869C16.7144 92.0089 16.5925 92.0089 16.5925 92.1309C16.4705 92.3749 16.4705 92.4969 16.3485 92.7409V92.8629C16.2265 93.1068 16.1045 93.3508 16.1045 93.7168V93.8388C15.9825 94.0827 15.9825 94.3267 15.8605 94.5707C15.8605 94.6927 15.8605 94.6927 15.7385 94.8147C15.7385 95.0587 15.6165 95.1807 15.6165 95.4246C15.6165 95.5466 15.6165 95.6686 15.4945 95.7906C15.4945 96.0346 15.3726 96.1566 15.3726 96.4005C15.3726 96.5225 15.3726 96.6445 15.2506 96.7665C15.2506 97.0105 15.1286 97.2545 15.1286 97.3765C15.1286 97.4985 15.1286 97.4985 15.1286 97.6204C15.0066 97.9864 15.0066 98.2304 15.0066 98.5964V98.7183C15.0066 98.9623 14.8846 99.3283 14.8846 99.5723C14.8846 99.6943 14.8846 99.8163 14.8846 99.9382C14.8846 100.182 14.8846 100.426 14.7626 100.548C14.7626 100.67 14.7626 100.792 14.7626 100.914C14.7626 101.158 14.7626 101.402 14.6406 101.524C14.6406 101.646 14.6406 101.768 14.6406 101.89C14.6406 102.134 14.6406 102.378 14.6406 102.622C14.6406 102.744 14.6406 102.866 14.6406 102.988C14.6406 103.354 14.6406 103.72 14.6406 104.086C14.6406 104.696 14.6406 105.306 14.6406 105.794C14.6406 106.038 14.6406 106.16 14.6406 106.404C14.6406 106.77 14.6406 107.136 14.6406 107.624C14.6406 107.868 14.6406 107.99 14.6406 108.234C14.6406 108.722 14.7626 109.087 14.7626 109.575C14.7626 109.697 14.7626 109.819 14.7626 110.063C14.7626 110.673 14.8846 111.161 15.0066 111.771C15.0066 112.015 15.1286 112.259 15.1286 112.503C15.1286 112.869 15.2506 113.235 15.2506 113.601C15.2506 113.845 15.3726 114.211 15.3726 114.455C15.3726 114.821 15.4945 115.065 15.4945 115.431C15.4945 115.675 15.6165 116.041 15.6165 116.285C15.7385 116.773 15.8605 117.261 15.9825 117.627C16.1045 117.993 16.2265 118.481 16.3485 118.847C16.3485 119.091 16.4705 119.335 16.4705 119.579C16.5925 119.945 16.7145 120.311 16.8364 120.676C16.8364 120.92 16.9584 121.042 16.9584 121.286C17.3244 122.628 17.8124 124.092 18.3003 125.434C18.3003 125.556 18.3003 125.556 18.4223 125.678C18.5443 126.166 18.7883 126.532 18.9103 127.02C18.9103 127.142 19.0323 127.264 19.0323 127.386C24.3998 141.049 34.037 153.858 45.138 160.811C54.8972 166.789 63.6805 167.033 69.78 162.397C64.0464 163.739 57.459 162.519 50.3836 158.127Z"
        fill="#0F054C"
      />
      <mask
        id="mask2_656_9840"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="14"
        y="81"
        width="64"
        height="85"
      >
        <path
          d="M67.3769 163.627C80.1152 156.732 80.7445 133.228 68.7826 111.128C56.8206 89.0289 36.7971 76.7033 24.0589 83.5982C11.3206 90.4932 10.6912 113.998 22.6532 136.097C34.6151 158.197 54.6386 170.522 67.3769 163.627Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_656_9840)">
        <path
          d="M41.1133 115.795L88.8112 81.0278L101.01 115.917L49.5306 131.898L41.1133 115.795Z"
          fill="url(#paint36_linear_656_9840)"
        />
        <path
          d="M52.0913 127.506C51.9693 131.654 49.0416 133.24 45.5039 131.044C41.9662 128.848 39.2824 123.847 39.4044 119.699C39.5264 115.551 42.4541 113.966 45.9918 116.161C49.5295 118.357 52.2133 123.481 52.0913 127.506Z"
          fill="url(#paint37_radial_656_9840)"
        />
        <g opacity="0.3">
          <path
            d="M56.7279 108.355C61.2415 111.16 64.9012 117.748 64.7792 123.115C64.7792 125.067 64.1693 126.653 63.1933 127.629L101.986 116.528L89.4211 80.4191L52.8242 107.135C54.0441 107.135 55.386 107.623 56.7279 108.355Z"
            fill="#0F054C"
          />
        </g>
      </g>
      <path
        d="M335.481 209.485L324.258 203.263C321.696 201.799 319.501 198.749 318.769 195.578L309.009 155.443C307.912 150.686 304.008 147.27 301.324 147.148H301.202C299.86 147.148 299.006 147.88 298.518 149.344L295.591 158.371C295.225 159.347 294.615 160.079 293.761 160.445C292.663 160.811 291.443 160.689 290.101 159.835L288.027 158.615C285.709 157.273 283.514 154.345 282.782 151.295C281.44 146.66 277.902 143.61 275.34 143.366C275.218 143.366 275.096 143.366 275.096 143.366C273.998 143.366 273.145 143.976 272.535 145.074L269.363 151.905C268.997 152.759 268.387 153.247 267.533 153.491C266.557 153.857 265.337 153.613 263.995 152.881L261.678 151.539C259.116 150.076 256.92 146.904 256.188 143.732L246.429 100.426C245.331 95.6682 241.549 92.1305 238.743 92.0085C237.402 91.8865 236.426 92.6184 235.816 93.9603L220.079 137.023C219.713 137.999 219.103 138.609 218.249 138.975C217.273 139.341 215.931 139.097 214.589 138.365L206.66 133.729L206.782 133.607L214.711 138.243C215.931 138.975 217.151 139.219 218.127 138.853C218.859 138.609 219.469 137.999 219.835 137.023L235.572 93.9603C236.06 92.6184 237.036 91.7645 238.377 91.7645C238.499 91.7645 238.499 91.7645 238.621 91.7645C241.427 92.0085 245.331 95.5462 246.429 100.426L256.188 143.732C256.92 146.904 259.116 150.076 261.556 151.417L263.873 152.759C265.093 153.491 266.313 153.735 267.289 153.369C268.021 153.125 268.631 152.637 268.997 151.783L272.169 144.952C272.779 143.732 273.876 143 275.218 143.122C277.902 143.366 281.562 146.538 282.782 151.174C283.636 154.101 285.709 157.029 288.027 158.371L290.101 159.591C291.443 160.323 292.663 160.567 293.639 160.201C294.493 159.835 294.981 159.225 295.347 158.249L298.274 149.222C298.762 147.636 299.86 146.904 301.324 146.904C304.13 147.026 308.034 150.442 309.253 155.321L319.013 195.456C319.745 198.627 321.94 201.677 324.38 203.019L335.603 209.241L335.481 209.485Z"
        fill="#42E8E0"
      />
      <path
        d="M327.059 214.364L315.836 208.143C313.275 206.679 311.079 203.629 310.347 200.458L300.588 160.323C299.49 155.565 295.586 152.15 292.902 152.028C291.56 152.028 290.584 152.76 290.097 154.223L287.169 163.251C286.803 164.227 286.193 164.959 285.339 165.324C284.241 165.69 283.021 165.568 281.679 164.715L279.605 163.495C277.288 162.153 275.092 159.225 274.36 156.175C273.018 151.54 269.48 148.49 266.918 148.246C265.577 148.124 264.601 148.734 264.113 149.954L260.941 156.785C260.575 157.639 259.965 158.127 259.111 158.371C258.135 158.737 256.915 158.493 255.573 157.761L253.256 156.419C250.694 154.955 248.498 151.784 247.766 148.612L238.007 105.306C236.909 100.548 233.127 97.0103 230.322 96.8883C228.98 96.7663 228.004 97.4982 227.394 98.8401L211.657 141.902C211.291 142.878 210.681 143.488 209.827 143.854C208.851 144.22 207.509 143.976 206.168 143.244L198.238 138.609L198.36 138.487L206.29 143.122C207.51 143.854 208.729 144.098 209.705 143.732C210.437 143.488 211.047 142.878 211.413 141.902L227.15 98.8401C227.638 97.3762 228.736 96.6443 230.2 96.6443C233.005 96.8883 236.909 100.426 238.007 105.306L247.766 148.612C248.498 151.784 250.694 154.955 253.134 156.297L255.451 157.639C256.671 158.371 257.891 158.615 258.867 158.249C259.599 158.005 260.209 157.517 260.575 156.663L263.747 149.832C264.357 148.612 265.455 147.88 266.797 148.002C269.48 148.246 273.14 151.418 274.36 156.053C275.214 158.981 277.288 161.909 279.605 163.251L281.679 164.471C283.021 165.202 284.241 165.446 285.217 165.081C286.071 164.715 286.559 164.105 286.925 163.129L289.853 154.101C290.341 152.638 291.316 151.784 292.78 151.784H292.902C295.708 151.906 299.612 155.321 300.832 160.201L310.591 200.336C311.323 203.507 313.519 206.557 315.958 207.899L327.181 214.12L327.059 214.364Z"
        fill="#42E8E0"
      />
      <path
        d="M237.199 91.8924L228.629 96.8103L228.872 97.2335L237.442 92.3157L237.199 91.8924Z"
        fill="#42E8E0"
      />
      <path
        d="M273.429 143.471L264.76 148.461L265.003 148.884L273.673 143.894L273.429 143.471Z"
        fill="#42E8E0"
      />
      <path
        d="M300.129 146.989L291.029 152.21L291.272 152.633L300.372 147.413L300.129 146.989Z"
        fill="#42E8E0"
      />
      <path
        d="M335.481 209.607L324.258 203.385C321.696 201.921 319.501 198.871 318.647 195.578L308.888 155.443C307.79 150.808 304.008 147.392 301.324 147.27C299.982 147.27 299.128 147.88 298.64 149.344L295.835 158.371C295.469 159.469 294.859 160.201 293.883 160.567C292.785 160.933 291.443 160.811 290.101 159.957L288.027 158.737C285.588 157.395 283.514 154.467 282.66 151.417C281.44 146.904 277.902 143.854 275.34 143.61C274.12 143.488 273.145 144.098 272.657 145.196L269.485 152.027C269.119 152.881 268.387 153.491 267.533 153.735C266.435 154.101 265.215 153.857 263.873 153.125L261.556 151.783C258.994 150.32 256.798 147.148 256.066 143.854L246.307 100.548C245.209 95.7902 241.549 92.3744 238.743 92.2525C237.402 92.1305 236.548 92.8624 236.06 94.2043L220.323 137.267C219.957 138.243 219.347 138.974 218.371 139.34C217.273 139.706 215.931 139.462 214.589 138.731L206.66 134.095L206.904 133.607L214.833 138.243C216.053 138.975 217.273 139.096 218.127 138.853C218.859 138.609 219.469 137.999 219.713 137.145L235.45 94.0823C236.06 92.4964 237.158 91.7645 238.743 91.8865C241.671 92.1305 245.575 95.6682 246.673 100.67L256.432 143.976C257.164 147.026 259.238 150.198 261.678 151.539L263.995 152.881C265.215 153.613 266.313 153.735 267.289 153.491C268.021 153.247 268.509 152.759 268.875 152.027L272.047 145.196C272.657 143.854 273.755 143.244 275.218 143.366C277.902 143.61 281.684 146.782 282.904 151.539C283.758 154.467 285.831 157.273 288.027 158.615L290.101 159.835C291.321 160.567 292.541 160.811 293.517 160.445C294.249 160.201 294.859 159.469 295.103 158.615L298.03 149.588C298.518 148.002 299.738 147.148 301.202 147.148C304.13 147.27 308.034 150.686 309.253 155.687L319.013 195.822C319.745 198.871 321.94 201.921 324.38 203.263L335.603 209.485L335.481 209.607Z"
        fill="#42E8E0"
      />
      <path
        d="M326.94 214.608L315.717 208.387C313.155 206.923 310.96 203.873 310.106 200.579L300.347 160.445C299.249 155.809 295.467 152.393 292.783 152.271C291.441 152.271 290.587 152.881 290.099 154.345L287.294 163.25C286.928 164.348 286.318 165.08 285.342 165.446C284.244 165.812 282.902 165.69 281.56 164.836L279.486 163.616C277.046 162.275 274.973 159.347 274.119 156.297C272.899 151.783 269.361 148.734 266.799 148.49C265.579 148.368 264.604 148.978 264.116 150.076L260.944 156.907C260.578 157.761 259.846 158.371 258.992 158.615C257.894 158.981 256.674 158.737 255.332 158.005L253.015 156.663C250.453 155.199 248.257 152.027 247.525 148.734L237.766 105.427C236.668 100.67 233.008 97.2541 230.202 97.1321C228.861 97.0101 228.007 97.742 227.519 99.0839L211.782 142.146C211.416 143.122 210.806 143.854 209.83 144.22C208.732 144.586 207.39 144.342 206.048 143.61L198.119 138.975L198.363 138.487L206.292 143.122C207.512 143.854 208.732 143.976 209.586 143.732C210.318 143.488 210.928 142.878 211.172 142.024L226.909 98.9619C227.519 97.3761 228.617 96.6441 230.202 96.7661C233.13 97.0101 237.034 100.548 238.132 105.549L247.891 148.856C248.623 151.905 250.697 155.077 253.136 156.419L255.454 157.761C256.674 158.493 257.772 158.615 258.748 158.371C259.48 158.127 259.968 157.639 260.334 156.907L263.506 150.076C264.116 148.734 265.213 148.124 266.677 148.246C269.361 148.49 273.143 151.661 274.363 156.419C275.217 159.347 277.29 162.153 279.486 163.494L281.56 164.714C282.78 165.446 284 165.69 284.976 165.324C285.708 165.08 286.318 164.348 286.562 163.494L289.489 154.467C289.977 152.881 291.075 152.027 292.539 152.027H292.661C295.589 152.149 299.493 155.565 300.712 160.567L310.472 200.701C311.204 203.751 313.399 206.801 315.839 208.143L327.062 214.364L326.94 214.608Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M206.898 133.607L214.828 138.242C217.268 139.584 219.341 139.096 220.195 136.9L235.932 93.838C237.762 88.9584 245.081 93.3501 246.667 100.303L256.426 143.61C257.158 146.782 259.354 149.953 261.794 151.417L264.112 152.759C266.307 154.101 268.381 153.735 269.235 151.783L272.407 144.952C274.359 140.682 281.068 144.708 282.898 151.173C283.752 154.223 285.826 157.029 288.144 158.371L290.217 159.59C292.657 161.054 294.853 160.444 295.585 158.127L298.513 149.099C300.221 143.976 307.54 148.245 309.248 155.199L319.007 195.333C319.739 198.505 321.935 201.555 324.496 203.019L335.72 209.24L206.898 133.607Z"
        fill="url(#paint38_linear_656_9840)"
      />
      <path
        opacity="0.5"
        d="M198.361 138.364L206.291 143C208.73 144.342 210.804 143.854 211.658 141.658L227.395 98.5958C229.225 93.7162 236.544 98.1079 238.13 105.061L247.889 148.368C248.621 151.539 250.817 154.711 253.257 156.175L255.574 157.517C257.77 158.859 259.844 158.493 260.698 156.541L263.87 149.71C265.822 145.44 272.531 149.466 274.361 155.931C275.215 158.981 277.289 161.786 279.606 163.128L281.68 164.348C284.12 165.812 286.316 165.202 287.048 162.884L289.976 153.857C291.683 148.734 299.003 153.003 300.711 159.957L310.47 200.091C311.202 203.263 313.398 206.313 315.959 207.777L327.182 213.998L198.361 138.364Z"
        fill="url(#paint39_linear_656_9840)"
      />
      <path
        opacity="0.4"
        d="M67.4382 163.737C80.2357 156.81 80.8871 133.231 68.8931 111.072C56.8991 88.9137 36.8016 76.566 24.004 83.493C11.2065 90.4201 10.5551 113.999 22.5491 136.157C34.5431 158.316 54.6407 170.664 67.4382 163.737Z"
        fill="#42E8E0"
      />
      <path
        d="M373.291 109.088C360.482 109.088 347.795 106.282 338.036 100.671C328.521 95.1814 323.275 87.862 323.275 80.0547C323.275 72.2473 328.521 64.9279 338.036 59.4384C357.554 48.0934 389.272 48.0934 408.79 59.3164C418.305 64.8059 423.551 72.1253 423.551 79.9327C423.551 87.74 418.305 95.0594 408.79 100.549C399.031 106.16 386.1 109.088 373.291 109.088ZM373.413 51.5091C360.604 51.5091 347.795 54.3148 338.158 59.9264C328.887 65.2939 323.641 72.4913 323.763 80.0547C323.763 87.618 328.887 94.8154 338.28 100.183C357.676 111.284 389.272 111.284 408.546 100.061C417.817 94.6934 423.063 87.496 422.941 79.9327C422.941 72.3693 417.817 65.1719 408.424 59.8044C398.787 54.1928 386.1 51.5091 373.413 51.5091Z"
        fill="#42E8E0"
      />
      <path
        d="M310.96 22.5954C313.278 21.2535 315.108 22.3514 315.108 25.0352C315.108 27.719 313.278 30.8907 310.96 32.2326C308.642 33.5745 306.812 32.4766 306.812 29.7928C306.812 27.109 308.642 23.9373 310.96 22.5954Z"
        fill="url(#paint40_linear_656_9840)"
      />
      <path
        d="M311.204 22.7189C308.886 24.0608 307.056 27.2325 307.056 29.9163C307.056 31.1362 307.422 32.1121 308.154 32.4781C307.3 32.1121 306.812 31.1362 306.812 29.6723C306.812 26.9885 308.642 23.8168 310.96 22.4749C312.18 21.743 313.278 21.743 314.01 22.2309C313.278 21.987 312.302 22.109 311.204 22.7189Z"
        fill="white"
      />
      <path
        d="M301.075 16.8629C303.393 15.521 305.223 16.6189 305.223 19.3027C305.223 21.9864 303.393 25.1582 301.075 26.5001C298.758 27.8419 296.928 26.744 296.928 24.0603C296.928 21.3765 298.758 18.2048 301.075 16.8629Z"
        fill="url(#paint41_linear_656_9840)"
      />
      <path
        d="M290.954 11.0061C293.272 9.66417 295.102 10.7621 295.102 13.4459C295.102 16.1296 293.272 19.3014 290.954 20.6432C288.636 21.9851 286.807 20.8872 286.807 18.2034C286.807 15.6417 288.636 12.3479 290.954 11.0061Z"
        fill="url(#paint42_linear_656_9840)"
      />
      <path
        d="M308.029 32.477L313.153 35.4048C312.421 34.9168 311.933 34.0629 311.933 32.721C311.933 30.0372 313.763 26.8655 316.081 25.5236C317.179 24.9137 318.154 24.7917 319.008 25.1576L340.844 37.7226L334.989 47.9697L270.578 11.0068C267.773 9.42097 266.797 5.76128 268.383 2.95552C269.968 0.149756 273.628 -0.826163 276.434 0.759703L293.878 10.7629C293.147 10.2749 292.049 10.2749 290.829 11.0068C288.511 12.3487 286.681 15.5205 286.681 18.2042C286.681 19.5461 287.169 20.522 287.901 20.888L293.025 23.8158C292.293 23.3278 291.805 22.4739 291.805 21.132C291.805 18.4482 293.635 15.2765 295.952 13.9346C297.05 13.3246 298.026 13.2027 298.88 13.5686L304.004 16.4964C303.272 16.0084 302.174 16.0084 300.954 16.7404C298.636 18.0822 296.806 21.254 296.806 23.9377C296.806 25.2796 297.294 26.2556 298.026 26.6215L303.15 29.5493C302.418 29.0613 301.93 28.2074 301.93 26.8655C301.93 24.1817 303.76 21.01 306.077 19.6681C307.175 19.0582 308.151 18.9362 309.005 19.3021L313.885 22.1079C313.153 21.6199 312.055 21.6199 310.835 22.3519C308.517 23.6938 306.687 26.8655 306.687 29.5493C306.809 31.1351 307.297 32.1111 308.029 32.477Z"
        fill="#BCBEFF"
      />
      <path
        d="M301.319 16.9851C299.002 18.327 297.172 21.4988 297.172 24.1825C297.172 25.4024 297.538 26.3783 298.27 26.7443C297.416 26.3783 296.928 25.4024 296.928 23.9386C296.928 21.2548 298.758 18.083 301.075 16.7412C302.295 16.0092 303.393 16.0092 304.125 16.4972C303.393 16.2532 302.417 16.3752 301.319 16.9851Z"
        fill="white"
      />
      <path
        d="M291.198 11.1283C288.88 12.4702 287.051 15.6419 287.051 18.3257C287.051 19.5456 287.417 20.5215 288.149 20.8875C287.295 20.5215 286.807 19.5456 286.807 18.0817C286.807 15.398 288.636 12.2262 290.954 10.8843C292.174 10.1524 293.272 10.1524 294.004 10.6404C293.272 10.5184 292.296 10.5184 291.198 11.1283Z"
        fill="white"
      />
      <path
        opacity="0.48"
        d="M316.084 25.5246C313.766 26.8665 311.936 30.0382 311.936 32.722C311.936 34.0639 312.424 35.0398 313.156 35.4058L308.032 32.478C307.3 31.9901 306.812 31.1361 306.812 29.7943C306.812 27.1105 308.642 23.9388 310.96 22.5969C312.18 21.8649 313.156 21.8649 314.01 22.3529L319.011 25.2806C318.28 24.7927 317.304 24.9147 316.084 25.5246Z"
        fill="url(#paint43_linear_656_9840)"
      />
      <path
        opacity="0.48"
        d="M306.199 19.7899C303.881 21.1318 302.051 24.3035 302.051 26.9873C302.051 28.3292 302.539 29.3051 303.271 29.6711L298.148 26.7433C297.416 26.2553 296.928 25.4014 296.928 24.0595C296.928 21.3758 298.758 18.204 301.075 16.8621C302.295 16.1302 303.271 16.1302 304.125 16.6182L309.127 19.5459C308.273 19.0579 307.297 19.1799 306.199 19.7899Z"
        fill="url(#paint44_linear_656_9840)"
      />
      <path
        opacity="0.48"
        d="M296.078 14.055C293.76 15.3969 291.93 18.5686 291.93 21.2524C291.93 22.5943 292.418 23.5702 293.15 23.9362L288.027 21.0084C287.295 20.5205 286.807 19.6665 286.807 18.3247C286.807 15.6409 288.636 12.4692 290.954 11.1273C292.174 10.3953 293.15 10.3953 294.004 10.8833L299.006 13.811C298.274 13.3231 297.176 13.3231 296.078 14.055Z"
        fill="url(#paint45_linear_656_9840)"
      />
      <path
        d="M335.234 65.9036C335.234 66.2696 335.234 66.5136 335.234 66.8796L347.921 77.4927L368.537 85.178L383.054 81.8843L396.96 77.8586L411.111 67.0015L411.477 66.7576C411.477 65.9036 411.477 65.0497 411.355 64.1958C413.795 60.9021 416.357 57.6083 418.796 54.1926C419.894 55.6565 420.87 57.1204 421.602 58.5843L423.31 57.2424V65.7816C423.31 65.9036 423.31 66.0256 423.31 66.0256V66.3916C423.066 73.589 418.309 80.7864 408.793 86.2759C389.275 97.621 357.802 97.621 338.283 86.3979C328.646 80.7864 323.767 73.589 323.645 66.2696C323.645 66.1476 323.645 66.1476 323.645 66.0256V56.9984L325.474 58.4623C325.84 57.6083 326.45 56.7544 326.938 55.7785C329.012 59.6822 331.208 64.3178 335.234 65.9036Z"
        fill="url(#paint46_linear_656_9840)"
      />
      <path
        d="M407.817 45.1647C408.061 45.2867 408.305 45.4087 408.671 45.6527C413.062 48.2145 416.478 51.1422 418.918 54.1919C416.478 57.4857 413.916 60.7794 411.476 64.1951C410.744 59.1935 407.085 54.3139 400.497 50.5323C385.615 41.993 361.461 41.993 346.578 50.6542C339.258 54.9239 335.599 60.4134 335.477 66.025C331.451 64.4391 329.255 59.8035 326.938 56.0218C328.767 53.338 331.329 50.6543 334.623 48.3364L332.915 48.7024C332.915 48.7024 344.626 38.5773 345.114 38.4553C345.602 38.3333 369.024 32.1118 369.024 32.1118L395.496 34.4296L407.817 45.1647Z"
        fill="url(#paint47_linear_656_9840)"
      />
      <path
        opacity="0.5"
        d="M399.644 44.5536C414.527 53.0929 414.527 66.9997 399.644 75.661C384.761 84.3222 360.607 84.3222 345.725 75.783C330.842 67.2437 330.842 53.3369 345.725 44.6756C360.607 36.0143 384.639 36.0143 399.644 44.5536Z"
        fill="url(#paint48_linear_656_9840)"
      />
      <path
        opacity="0.48"
        d="M399.521 47.2373C414.404 55.7766 414.404 69.6834 399.521 78.3447C384.638 87.0059 360.484 87.0059 345.602 78.4666C330.719 69.9274 330.719 56.0205 345.602 47.3593C360.484 38.698 384.638 38.576 399.521 47.2373Z"
        fill="url(#paint49_linear_656_9840)"
      />
      <path
        d="M408.551 36.7472C389.032 25.5241 357.437 25.6461 338.041 36.8692C318.522 48.2142 318.644 66.3907 338.163 77.6137C357.681 88.8368 389.276 88.7148 408.673 77.4917C428.191 66.1467 428.069 47.9702 408.551 36.7472ZM400.256 41.5048C415.138 50.044 415.138 63.9509 400.256 72.6121C385.373 81.2734 361.219 81.2734 346.336 72.7341C331.453 64.1948 331.453 50.288 346.336 41.6268C361.219 32.9655 385.373 32.9655 400.256 41.5048Z"
        fill="#BCBEFF"
      />
      <path
        d="M408.551 36.7472C389.032 25.5241 357.437 25.6461 338.041 36.8692C318.522 48.2142 318.644 66.3907 338.163 77.6137C357.681 88.8368 389.276 88.7148 408.673 77.4917C428.191 66.1467 428.069 47.9702 408.551 36.7472ZM400.256 41.5048C415.138 50.044 415.138 63.9509 400.256 72.6121C385.373 81.2734 361.219 81.2734 346.336 72.7341C331.453 64.1948 331.453 50.288 346.336 41.6268C361.219 32.9655 385.373 32.9655 400.256 41.5048Z"
        fill="#BCBEFF"
      />
      <path
        d="M337.917 76.7604C357.435 87.9835 389.03 87.8615 408.427 76.6384C420.382 69.685 425.017 60.1698 422.212 51.1426C425.505 60.2918 420.992 70.295 408.671 77.3704C389.152 88.7154 357.679 88.7154 338.161 77.4923C330.719 73.2227 326.084 67.8552 324.254 62.2436C326.206 67.6112 330.719 72.7348 337.917 76.7604Z"
        fill="white"
      />
      <path
        d="M346.089 40.8946C360.972 32.2333 385.126 32.2333 400.009 40.7726C405.742 44.0663 409.28 48.214 410.622 52.4836C409.158 48.4579 405.742 44.6763 400.253 41.5045C385.37 32.9653 361.216 32.9653 346.333 41.6265C337.184 46.8721 333.768 54.1915 335.72 61.0229C333.281 53.9475 336.696 46.3841 346.089 40.8946Z"
        fill="white"
      />
      <path
        d="M299.136 314.42L298.896 314.845L325.685 329.924L325.924 329.498L299.136 314.42Z"
        fill="#42E8E0"
      />
      <path
        d="M342.304 376C341.084 376 339.742 375.634 338.644 375.024L295.948 350.382C295.216 350.016 294.85 349.284 294.85 348.552C294.85 347.82 295.216 347.088 295.948 346.722L359.138 310.247C361.334 308.905 364.14 308.905 366.458 310.247L409.154 334.889C409.886 335.255 410.252 335.987 410.252 336.719C410.252 337.451 409.886 338.183 409.154 338.549L345.963 375.024C344.743 375.634 343.523 376 342.304 376ZM362.676 309.759C361.456 309.759 360.358 310.003 359.26 310.613L296.07 347.088C295.582 347.332 295.216 347.942 295.216 348.552C295.216 349.162 295.582 349.65 296.07 350.016L338.766 374.658C340.84 375.878 343.401 375.878 345.597 374.658L408.788 338.183C409.276 337.939 409.642 337.329 409.642 336.719C409.642 336.109 409.398 335.621 408.788 335.255L366.092 310.613C365.116 310.003 363.896 309.759 362.676 309.759Z"
        fill="#42E8E0"
      />
      <path
        d="M352.549 334.523L345.84 330.62L347.426 329.766L354.135 333.548L352.549 334.523Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M358.285 337.817L354.869 335.866L356.577 334.89L359.871 336.841L358.285 337.817Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M348.643 336.841L341.934 332.938L343.519 331.962L350.229 335.865L348.643 336.841Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M354.379 340.134L350.963 338.182L352.671 337.206L355.964 339.158L354.379 340.134Z"
        fill="#42E8E0"
      />
      <path
        d="M344.745 339.037L338.035 335.133L339.621 334.158L346.33 338.061L344.745 339.037Z"
        fill="#42E8E0"
      />
      <path
        d="M350.48 342.332L347.064 340.38L348.772 339.404L352.066 341.356L350.48 342.332Z"
        fill="#42E8E0"
      />
      <path
        d="M340.84 341.356L334.131 337.452L335.717 336.477L342.426 340.38L340.84 341.356Z"
        fill="#42E8E0"
      />
      <path
        d="M346.572 344.648L343.156 342.696L344.864 341.72L348.158 343.672L346.572 344.648Z"
        fill="#42E8E0"
      />
      <path
        d="M336.938 343.55L330.229 339.646L331.814 338.67L338.524 342.574L336.938 343.55Z"
        fill="#42E8E0"
      />
      <path
        d="M342.668 346.843L339.252 344.891L340.96 343.915L344.254 345.867L342.668 346.843Z"
        fill="#42E8E0"
      />
      <path
        d="M333.03 345.746L326.32 341.964L327.906 340.988L334.616 344.892L333.03 345.746Z"
        fill="#42E8E0"
      />
      <path
        d="M338.767 349.162L335.352 347.21L337.059 346.234L340.353 348.186L338.767 349.162Z"
        fill="#42E8E0"
      />
      <path
        d="M329.129 348.065L322.42 344.161L324.006 343.185L330.715 347.089L329.129 348.065Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M334.863 351.358L331.447 349.406L333.155 348.43L336.449 350.382L334.863 351.358Z"
        fill="#42E8E0"
      />
      <path
        d="M325.225 350.261L318.516 346.479L320.101 345.503L326.811 349.407L325.225 350.261Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M330.961 353.675L327.545 351.724L329.253 350.748L332.547 352.699L330.961 353.675Z"
        fill="#42E8E0"
      />
      <path
        d="M367.43 343.187L360.721 339.405L362.307 338.429L369.016 342.211L367.43 343.187Z"
        fill="#42E8E0"
      />
      <path
        d="M373.166 346.48L369.75 344.529L371.458 343.675L374.752 345.505L373.166 346.48Z"
        fill="#42E8E0"
      />
      <path
        d="M363.524 345.502L356.814 341.599L358.4 340.623L365.11 344.526L363.524 345.502Z"
        fill="#42E8E0"
      />
      <path
        d="M369.259 348.798L365.844 346.847L367.552 345.871L370.845 347.822L369.259 348.798Z"
        fill="#42E8E0"
      />
      <path
        d="M359.625 347.699L352.916 343.796L354.502 342.942L361.211 346.723L359.625 347.699Z"
        fill="#42E8E0"
      />
      <path
        d="M365.361 350.994L361.945 349.042L363.653 348.188L366.947 350.018L365.361 350.994Z"
        fill="#42E8E0"
      />
      <path
        d="M364.135 327.815L357.426 323.912L359.134 322.936L365.843 326.839L364.135 327.815Z"
        fill="#42E8E0"
      />
      <path
        d="M369.868 331.108L366.574 329.156L368.16 328.18L371.576 330.132L369.868 331.108Z"
        fill="#42E8E0"
      />
      <path
        d="M360.233 330.012L353.523 326.231L355.231 325.255L361.941 329.158L360.233 330.012Z"
        fill="#42E8E0"
      />
      <path
        d="M365.966 333.427L362.672 331.475L364.258 330.499L367.673 332.451L365.966 333.427Z"
        fill="#42E8E0"
      />
      <path
        d="M356.331 332.33L349.621 328.427L351.329 327.451L358.038 331.354L356.331 332.33Z"
        fill="#42E8E0"
      />
      <path
        d="M362.065 335.623L358.771 333.671L360.357 332.695L363.773 334.647L362.065 335.623Z"
        fill="#42E8E0"
      />
      <path
        d="M379.02 336.476L372.311 332.572L374.018 331.718L380.728 335.5L379.02 336.476Z"
        fill="#42E8E0"
      />
      <path
        d="M384.757 339.77L381.463 337.818L383.049 336.842L386.464 338.794L384.757 339.77Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M375.12 338.796L368.41 334.892L370.118 333.916L376.827 337.82L375.12 338.796Z"
        fill="#42E8E0"
      />
      <path
        d="M380.85 342.088L377.557 340.136L379.142 339.16L382.558 341.112L380.85 342.088Z"
        fill="#42E8E0"
      />
      <path
        d="M371.211 340.991L364.502 337.087L366.21 336.111L372.919 340.015L371.211 340.991Z"
        fill="#42E8E0"
      />
      <path
        d="M376.944 344.283L373.65 342.332L375.236 341.356L378.652 343.308L376.944 344.283Z"
        fill="#42E8E0"
      />
      <path
        d="M355.721 350.017L349.012 346.113L350.598 345.138L357.307 349.041L355.721 350.017Z"
        fill="#42E8E0"
      />
      <path
        d="M361.453 353.31L358.037 351.358L359.745 350.382L363.039 352.334L361.453 353.31Z"
        fill="#42E8E0"
      />
      <path
        opacity="0.5"
        d="M351.819 352.214L345.109 348.31L346.695 347.457L353.405 351.238L351.819 352.214Z"
        fill="#42E8E0"
      />
      <path
        d="M357.549 355.506L354.133 353.554L355.841 352.578L359.134 354.53L357.549 355.506Z"
        fill="#42E8E0"
      />
      <path
        d="M347.911 354.532L341.201 350.628L342.787 349.652L349.496 353.556L347.911 354.532Z"
        fill="#42E8E0"
      />
      <path
        d="M353.648 357.825L350.232 355.873L351.94 354.897L355.234 356.849L353.648 357.825Z"
        fill="#42E8E0"
      />
      <path
        d="M344.01 356.728L337.301 352.824L338.887 351.848L345.596 355.752L344.01 356.728Z"
        fill="#42E8E0"
      />
      <path
        d="M349.744 360.021L346.328 358.069L348.036 357.093L351.33 359.045L349.744 360.021Z"
        fill="#42E8E0"
      />
      <path
        d="M340.106 358.922L333.396 355.14L335.104 354.164L341.814 357.946L340.106 358.922Z"
        fill="#42E8E0"
      />
      <path
        d="M345.839 362.218L342.545 360.266L344.131 359.412L347.547 361.242L345.839 362.218Z"
        fill="#42E8E0"
      />
      <path
        d="M385.371 321.592L385.127 321.226L408.183 307.441C409.037 306.953 409.647 305.977 409.647 304.879C409.647 303.781 409.037 302.927 408.183 302.439L379.149 285.849C378.051 285.239 377.441 284.141 377.441 282.921C377.441 281.701 378.051 280.603 379.149 279.993L449.171 239.737C450.025 239.249 450.513 238.395 450.513 237.419C450.513 236.443 450.025 235.589 449.171 235.101L437.216 228.026C433.557 225.83 431.239 221.804 431.239 217.535V114.209C431.239 110.062 429.043 106.158 425.383 104.084L413.55 97.1309L413.794 96.7649L425.627 103.718C429.409 105.914 431.727 109.94 431.727 114.209V217.535C431.727 221.682 433.923 225.586 437.582 227.66L449.537 234.735C450.513 235.345 451.001 236.321 451.001 237.419C451.001 238.517 450.391 239.493 449.415 240.103L379.393 280.359C378.539 280.847 377.929 281.823 377.929 282.921C377.929 284.019 378.417 284.873 379.393 285.483L408.427 302.074C409.525 302.683 410.135 303.781 410.135 304.879C410.135 306.099 409.525 307.197 408.549 307.807L385.371 321.592Z"
        fill="#42E8E0"
      />
      <defs>
        <linearGradient
          id="paint0_linear_656_9840"
          x1="310.987"
          y1="165.156"
          x2="306.802"
          y2="157.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_656_9840"
          x1="301.051"
          y1="159.447"
          x2="296.866"
          y2="152.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_656_9840"
          x1="290.948"
          y1="153.636"
          x2="286.763"
          y2="146.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_656_9840"
          x1="309.146"
          y1="166.089"
          x2="315.023"
          y2="155.865"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_656_9840"
          x1="299.209"
          y1="160.378"
          x2="305.087"
          y2="150.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_656_9840"
          x1="289.107"
          y1="154.567"
          x2="294.984"
          y2="144.342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_656_9840"
          x1="334.677"
          y1="222.806"
          x2="410.968"
          y2="178.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.3076" stopColor="#9297EE" />
          <stop offset="0.5949" stopColor="#727AE2" />
          <stop offset="0.8355" stopColor="#5E67DA" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_656_9840"
          x1="410.297"
          y1="169.877"
          x2="332.542"
          y2="204.328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_656_9840"
          x1="359.23"
          y1="216.471"
          x2="386.102"
          y2="169.724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_656_9840"
          x1="359.164"
          y1="219.138"
          x2="386.036"
          y2="172.392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(150.162 277.286) rotate(-59.6141) scale(74.2318 74.2318)"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_656_9840"
          x1="121.86"
          y1="296.129"
          x2="77.3986"
          y2="227.841"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.1237" stopColor="#B4B6FC" />
          <stop offset="0.3207" stopColor="#9CA1F2" />
          <stop offset="0.5651" stopColor="#777EE4" />
          <stop offset="0.744" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_656_9840"
          x1="77.6666"
          y1="321.458"
          x2="43.1253"
          y2="235.935"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_656_9840"
          x1="37.5104"
          y1="316.562"
          x2="74.6341"
          y2="253.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint14_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(74.0734 311.234) scale(83.7564 83.7564)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint15_linear_656_9840"
          x1="68.2396"
          y1="297.927"
          x2="99.886"
          y2="247.211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint16_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.4748 306.009) rotate(-58.0359) scale(47.821 47.8211)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint17_linear_656_9840"
          x1="117.051"
          y1="195.744"
          x2="135.463"
          y2="195.744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_656_9840"
          x1="123.479"
          y1="197.654"
          x2="137.829"
          y2="197.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_656_9840"
          x1="337.594"
          y1="261.7"
          x2="89.2712"
          y2="261.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_656_9840"
          x1="258.809"
          y1="255.918"
          x2="10.4867"
          y2="255.918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_656_9840"
          x1="365.741"
          y1="146.987"
          x2="190.01"
          y2="146.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_656_9840"
          x1="365.739"
          y1="192.054"
          x2="335.564"
          y2="192.054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_656_9840"
          x1="342.199"
          y1="241.227"
          x2="94.0087"
          y2="241.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_656_9840"
          x1="258.801"
          y1="234.44"
          x2="10.4789"
          y2="234.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_656_9840"
          x1="437.634"
          y1="186.603"
          x2="189.444"
          y2="186.603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1779" stopColor="#5C66D9" />
          <stop offset="0.3876" stopColor="#6A73DF" />
          <stop offset="0.6134" stopColor="#8289E8" />
          <stop offset="0.849" stopColor="#A3A7F5" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_656_9840"
          x1="354.242"
          y1="179.815"
          x2="105.92"
          y2="179.815"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0BFF6" />
          <stop offset="0.2938" stopColor="#C5C4F7" />
          <stop offset="0.6399" stopColor="#D3D2F9" />
          <stop offset="1" stopColor="#E9E9FD" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_656_9840"
          x1="116.807"
          y1="130.072"
          x2="138.038"
          y2="130.656"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_656_9840"
          x1="78.9929"
          y1="131.423"
          x2="146.402"
          y2="133.278"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_656_9840"
          x1="118.497"
          y1="137.869"
          x2="123.262"
          y2="137.869"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <radialGradient
          id="paint30_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(102.053 47.8615) rotate(1.57587) scale(74.2313 74.2313)"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(111.876 90.4491) rotate(31.576) scale(21.2604 18.4127)"
        >
          <stop stopColor="#F9636B" />
          <stop offset="1" stopColor="#B6246E" />
        </radialGradient>
        <linearGradient
          id="paint32_linear_656_9840"
          x1="71.0804"
          y1="61.8982"
          x2="105.48"
          y2="135.768"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.1237" stopColor="#B4B6FC" />
          <stop offset="0.3207" stopColor="#9CA1F2" />
          <stop offset="0.5651" stopColor="#777EE4" />
          <stop offset="0.744" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_656_9840"
          x1="26.1959"
          y1="85.9858"
          x2="80.4664"
          y2="160.565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_656_9840"
          x1="9.09206"
          y1="122.645"
          x2="82.4555"
          y2="124.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint35_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(63.1199 150.406) rotate(1.57587) scale(83.8008 83.8008)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint36_linear_656_9840"
          x1="41.1716"
          y1="106.437"
          x2="100.951"
          y2="106.437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E9FD" />
          <stop offset="0.3601" stopColor="#D3D2F9" />
          <stop offset="0.7062" stopColor="#C5C4F7" />
          <stop offset="1" stopColor="#C0BFF6" />
        </linearGradient>
        <radialGradient
          id="paint37_radial_656_9840"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.6164 111.289) scale(47.8213 47.8213)"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.2271" stopColor="#AAADF8" />
          <stop offset="0.6802" stopColor="#7C83E5" />
          <stop offset="1" stopColor="#5761D7" />
        </radialGradient>
        <linearGradient
          id="paint38_linear_656_9840"
          x1="227.905"
          y1="115.393"
          x2="384.256"
          y2="208.641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1055" stopColor="#37B6BF" />
          <stop offset="0.2197" stopColor="#2C87A1" />
          <stop offset="0.338" stopColor="#235F87" />
          <stop offset="0.4587" stopColor="#1C3F72" />
          <stop offset="0.5824" stopColor="#162561" />
          <stop offset="0.7105" stopColor="#121355" />
          <stop offset="0.8458" stopColor="#10084E" />
          <stop offset="1" stopColor="#0F054C" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_656_9840"
          x1="219.403"
          y1="120.167"
          x2="329.904"
          y2="186.105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1055" stopColor="#37B6BF" />
          <stop offset="0.2197" stopColor="#2C87A1" />
          <stop offset="0.338" stopColor="#235F87" />
          <stop offset="0.4587" stopColor="#1C3F72" />
          <stop offset="0.5824" stopColor="#162561" />
          <stop offset="0.7105" stopColor="#121355" />
          <stop offset="0.8458" stopColor="#10084E" />
          <stop offset="1" stopColor="#0F054C" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_656_9840"
          x1="310.987"
          y1="32.1956"
          x2="306.802"
          y2="24.9782"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_656_9840"
          x1="301.051"
          y1="26.4865"
          x2="296.866"
          y2="19.2692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_656_9840"
          x1="290.948"
          y1="20.675"
          x2="286.763"
          y2="13.4577"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_656_9840"
          x1="309.146"
          y1="33.1288"
          x2="315.023"
          y2="22.9042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_656_9840"
          x1="299.209"
          y1="27.4176"
          x2="305.087"
          y2="17.1928"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_656_9840"
          x1="289.107"
          y1="21.6058"
          x2="294.984"
          y2="11.3814"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_656_9840"
          x1="334.677"
          y1="89.8463"
          x2="410.968"
          y2="45.7899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCBEFF" />
          <stop offset="0.3076" stopColor="#9297EE" />
          <stop offset="0.5949" stopColor="#727AE2" />
          <stop offset="0.8355" stopColor="#5E67DA" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_656_9840"
          x1="410.297"
          y1="36.9173"
          x2="332.542"
          y2="71.3692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5761D7" />
          <stop offset="0.1645" stopColor="#5E67DA" />
          <stop offset="0.4051" stopColor="#727AE2" />
          <stop offset="0.6924" stopColor="#9297EE" />
          <stop offset="1" stopColor="#BCBEFF" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_656_9840"
          x1="359.23"
          y1="83.5113"
          x2="386.102"
          y2="36.765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_656_9840"
          x1="359.164"
          y1="86.1787"
          x2="386.036"
          y2="39.4324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E8E0" />
          <stop offset="0.1507" stopColor="#43E3E0" />
          <stop offset="0.3285" stopColor="#45D5DF" />
          <stop offset="0.5199" stopColor="#49BDDD" />
          <stop offset="0.7209" stopColor="#4E9CDB" />
          <stop offset="0.9274" stopColor="#5472D8" />
          <stop offset="1" stopColor="#5761D7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const RectangleGradient = () => {
  return (
    <svg
      width="1200"
      height="456"
      viewBox="0 0 1200 456"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2736_17068)">
        <rect
          width="1200"
          height="456"
          rx="24"
          fill="black"
          fillOpacity="0.1"
        />
        <rect
          x="0.5"
          y="0.5"
          width="1199"
          height="455"
          rx="23.5"
          stroke="white"
          strokeOpacity="0.15"
        />
        <rect
          x="0.5"
          y="0.5"
          width="1199"
          height="455"
          rx="23.5"
          stroke="url(#paint0_linear_2736_17068)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2736_17068"
          x="-64"
          y="-64"
          width="1328"
          height="584"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2736_17068"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2736_17068"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2736_17068"
          x1="600"
          y1="0"
          x2="600"
          y2="456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const RectangleGradientMobile = () => {
  return (
    <svg
      width="343"
      height="750"
      viewBox="0 0 343 750"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2736_17089)">
        <rect
          width="343"
          height="750"
          rx="24"
          fill="black"
          fillOpacity="0.1"
        />
        <rect
          x="0.5"
          y="0.5"
          width="342"
          height="749"
          rx="23.5"
          stroke="white"
          strokeOpacity="0.15"
        />
        <rect
          x="0.5"
          y="0.5"
          width="342"
          height="749"
          rx="23.5"
          stroke="url(#paint0_linear_2736_17089)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2736_17089"
          x="-64"
          y="-64"
          width="471"
          height="878"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2736_17089"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2736_17089"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2736_17089"
          x1="171.5"
          y1="0"
          x2="171.5"
          y2="750"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export {
  AboutUsBanner,
  AboutUsBannerMobile,
  CardBorderMobile,
  CardBorder,
  CardBorderHover,
  OurVisionIcon,
  OurMissionIcon,
  DiscoverBannerMobile,
  DiscoverBanner,
  RectangleGradient,
  RectangleGradientMobile,
};
